var Er = Object.defineProperty;
var Br = (e, t, n) => t in e ? Er(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var W = (e, t, n) => Br(e, typeof t != "symbol" ? t + "" : t, n);
import { createVNode as g, render as Gn, defineComponent as G, computed as q, openBlock as C, createElementBlock as T, normalizeClass as B, normalizeStyle as _e, renderSlot as ne, ref as X, watchEffect as po, watch as ae, nextTick as Ir, onUnmounted as bn, provide as at, inject as Fe, createElementVNode as U, resolveComponent as P, createBlock as F, Teleport as Tt, Transition as gn, withCtx as le, Fragment as J, createCommentVNode as z, toDisplayString as He, reactive as oe, withDirectives as yn, withModifiers as mo, vShow as vn, Comment as jr, createTextVNode as Vn, markRaw as bo, resolveDynamicComponent as It, mergeProps as rt, renderList as Le, useSlots as Pr, h as Fr } from "vue";
const zr = "0.0.5-beta.50", $e = "d", go = 0.3, zd = "80px", qr = "#1890ff", Gr = "#00B578", Vr = "#FF8F1F", Yr = "#FF3B30", yo = "left", qd = "ROOT";
var Wr = /* @__PURE__ */ ((e) => (e.left = "left", e.center = "center", e.right = "right", e))(Wr || {}), Ur = /* @__PURE__ */ ((e) => (e.small = "small", e.medium = "medium", e.large = "large", e))(Ur || {}), Hr = /* @__PURE__ */ ((e) => (e.top = "top", e.right = "right", e.bottom = "bottom", e.left = "left", e.center = "center", e.custom = "custom", e))(Hr || {}), Kr = /* @__PURE__ */ ((e) => (e.primary = "primary", e.success = "success", e.warning = "warning", e.danger = "danger", e.default = "default", e.light = "light", e))(Kr || {}), Xr = /* @__PURE__ */ ((e) => (e.info = "info", e.success = "success", e.warning = "warning", e.error = "error", e))(Xr || {}), wn = /* @__PURE__ */ ((e) => (e.PC = "PC", e.MOBILE = "MOBILE", e))(wn || {});
const Zr = ",";
let Cn = $e;
const Gd = (e) => Cn = e, xr = (e) => e == null ? void 0 : e.replace(`${Cn}-`, "");
function nn(e, t) {
  return t ? typeof t == "string" ? ` ${e}--${t} ` : Array.isArray(t) ? t.reduce((n, o) => n + nn(e, o), "") : Object.keys(t).reduce(
    (n, o) => n + (t[o] ? nn(e, o) : ""),
    ""
  ) : "";
}
function Qr(e) {
  return (t, n) => (t && typeof t != "string" && (n = t, t = ""), t = t ? `${e}__${t}` : e, `${t}${nn(t, n)}`);
}
function V(e) {
  const t = `${Cn}-${e}`;
  return [t, Qr(t)];
}
function Te(e, t) {
  return t.reduce((n, o) => ({ ...n, [o]: e[o] }), {});
}
var vo = function(e) {
  return Object.prototype.toString.call(e);
}, me = function(e) {
  return vo(e) === "[object Object]";
}, Jr = function(e) {
  return /^\d+$/.test(e + "");
}, el = function(e) {
  return /^\d+\.\d+$/.test(e + "");
}, tl = function(e) {
  return Jr(e) || el(e);
}, ie = function(e) {
  return Array.isArray(e) ? e.length === 0 : me(e) ? Object.keys(e).length === 0 : ["[object Set]", "[object Map]"].includes(vo(e)) ? e.size === 0 : [null, void 0, ""].includes(e);
};
function kn(e) {
  if (me(e) || Array.isArray(e)) {
    var t, n = Array.isArray(e) ? [] : {};
    for (t in e) n[t] = kn(e[t]);
    return n;
  }
  return e;
}
var wo = function(e) {
  return e.replace(/(-\w)/g, function(t) {
    return t.substring(1, 2).toUpperCase();
  }).replace(/^(\w)/, function(t) {
    return t.toUpperCase();
  });
}, Oe = function(e) {
  e === void 0 && (e = 12);
  for (var t = [], n = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ".split(""), o = n.length, r = 0; r < e; r++) t.push(n[Math.round(Math.random() * o)]);
  return t.join("");
}, on = function(e, t) {
  throw "[".concat(wo(e), "]: ").concat(t);
};
function Y(e) {
  return e.install = (t) => {
    const { name: n } = e;
    t.component(n, e), t.component(wo(n), e);
  }, e;
}
const K = (e) => tl(e) ? `${e}px` : e, Vd = (e) => {
  const t = window.URL.createObjectURL(e);
  return [t, () => window.URL.revokeObjectURL(t)];
};
class nl {
  request({
    url: t,
    method: n = "GET",
    data: o,
    headers: r,
    responseType: l = "json",
    onProgress: a
  }) {
    return new Promise((s, i) => {
      var d;
      const c = new XMLHttpRequest();
      let u = o;
      if ((d = r == null ? void 0 : r["Content-Type"]) != null && d.includes("json") && (u = JSON.stringify(o || {})), c.onload = () => {
        (c.status < 200 || c.status >= 300) && i(c), s(c.response);
      }, c.upload.onprogress = (f) => {
        const h = f;
        h.percent = f.total > 0 ? f.loaded / f.total * 100 : 0, a == null || a(h);
      }, c.onerror = i, c.open(n, t), c.responseType = l, me(r))
        for (const [f, h] of Object.entries(r))
          c.setRequestHeader(f, h);
      c.send(u);
    });
  }
}
const ol = new nl(), Yd = (e) => ol.request(e);
function $n(e, t = document.createElement("div"), n = document.body) {
  var r;
  const o = g(e, { teleport: t });
  return t.classList.add(`${$e}-teleport`), Gn(o, t), n.appendChild(t), {
    instance: (r = o.component) == null ? void 0 : r.exposed,
    unmount: () => {
      Gn(null, t), n.contains(t) && n.removeChild(t);
    }
  };
}
const { min: rl, max: ll } = Math, je = (e, t = 0, n = 1) => rl(ll(t, e), n), Sn = (e) => {
  e._clipped = !1, e._unclipped = e.slice(0);
  for (let t = 0; t <= 3; t++)
    t < 3 ? ((e[t] < 0 || e[t] > 255) && (e._clipped = !0), e[t] = je(e[t], 0, 255)) : t === 3 && (e[t] = je(e[t], 0, 1));
  return e;
}, Co = {};
for (let e of [
  "Boolean",
  "Number",
  "String",
  "Function",
  "Array",
  "Date",
  "RegExp",
  "Undefined",
  "Null"
])
  Co[`[object ${e}]`] = e.toLowerCase();
function I(e) {
  return Co[Object.prototype.toString.call(e)] || "object";
}
const A = (e, t = null) => e.length >= 3 ? Array.prototype.slice.call(e) : I(e[0]) == "object" && t ? t.split("").filter((n) => e[0][n] !== void 0).map((n) => e[0][n]) : e[0].slice(0), Ze = (e) => {
  if (e.length < 2) return null;
  const t = e.length - 1;
  return I(e[t]) == "string" ? e[t].toLowerCase() : null;
}, { PI: Nt, min: ko, max: $o } = Math, ce = (e) => Math.round(e * 100) / 100, rn = (e) => Math.round(e * 100) / 100, ve = Nt * 2, jt = Nt / 3, al = Nt / 180, sl = 180 / Nt;
function So(e) {
  return [...e.slice(0, 3).reverse(), ...e.slice(3)];
}
const N = {
  format: {},
  autodetect: []
};
class y {
  constructor(...t) {
    const n = this;
    if (I(t[0]) === "object" && t[0].constructor && t[0].constructor === this.constructor)
      return t[0];
    let o = Ze(t), r = !1;
    if (!o) {
      r = !0, N.sorted || (N.autodetect = N.autodetect.sort((l, a) => a.p - l.p), N.sorted = !0);
      for (let l of N.autodetect)
        if (o = l.test(...t), o) break;
    }
    if (N.format[o]) {
      const l = N.format[o].apply(
        null,
        r ? t : t.slice(0, -1)
      );
      n._rgb = Sn(l);
    } else
      throw new Error("unknown format: " + t);
    n._rgb.length === 3 && n._rgb.push(1);
  }
  toString() {
    return I(this.hex) == "function" ? this.hex() : `[${this._rgb.join(",")}]`;
  }
}
const il = "3.1.2", j = (...e) => new y(...e);
j.version = il;
const Ke = {
  aliceblue: "#f0f8ff",
  antiquewhite: "#faebd7",
  aqua: "#00ffff",
  aquamarine: "#7fffd4",
  azure: "#f0ffff",
  beige: "#f5f5dc",
  bisque: "#ffe4c4",
  black: "#000000",
  blanchedalmond: "#ffebcd",
  blue: "#0000ff",
  blueviolet: "#8a2be2",
  brown: "#a52a2a",
  burlywood: "#deb887",
  cadetblue: "#5f9ea0",
  chartreuse: "#7fff00",
  chocolate: "#d2691e",
  coral: "#ff7f50",
  cornflowerblue: "#6495ed",
  cornsilk: "#fff8dc",
  crimson: "#dc143c",
  cyan: "#00ffff",
  darkblue: "#00008b",
  darkcyan: "#008b8b",
  darkgoldenrod: "#b8860b",
  darkgray: "#a9a9a9",
  darkgreen: "#006400",
  darkgrey: "#a9a9a9",
  darkkhaki: "#bdb76b",
  darkmagenta: "#8b008b",
  darkolivegreen: "#556b2f",
  darkorange: "#ff8c00",
  darkorchid: "#9932cc",
  darkred: "#8b0000",
  darksalmon: "#e9967a",
  darkseagreen: "#8fbc8f",
  darkslateblue: "#483d8b",
  darkslategray: "#2f4f4f",
  darkslategrey: "#2f4f4f",
  darkturquoise: "#00ced1",
  darkviolet: "#9400d3",
  deeppink: "#ff1493",
  deepskyblue: "#00bfff",
  dimgray: "#696969",
  dimgrey: "#696969",
  dodgerblue: "#1e90ff",
  firebrick: "#b22222",
  floralwhite: "#fffaf0",
  forestgreen: "#228b22",
  fuchsia: "#ff00ff",
  gainsboro: "#dcdcdc",
  ghostwhite: "#f8f8ff",
  gold: "#ffd700",
  goldenrod: "#daa520",
  gray: "#808080",
  green: "#008000",
  greenyellow: "#adff2f",
  grey: "#808080",
  honeydew: "#f0fff0",
  hotpink: "#ff69b4",
  indianred: "#cd5c5c",
  indigo: "#4b0082",
  ivory: "#fffff0",
  khaki: "#f0e68c",
  laserlemon: "#ffff54",
  lavender: "#e6e6fa",
  lavenderblush: "#fff0f5",
  lawngreen: "#7cfc00",
  lemonchiffon: "#fffacd",
  lightblue: "#add8e6",
  lightcoral: "#f08080",
  lightcyan: "#e0ffff",
  lightgoldenrod: "#fafad2",
  lightgoldenrodyellow: "#fafad2",
  lightgray: "#d3d3d3",
  lightgreen: "#90ee90",
  lightgrey: "#d3d3d3",
  lightpink: "#ffb6c1",
  lightsalmon: "#ffa07a",
  lightseagreen: "#20b2aa",
  lightskyblue: "#87cefa",
  lightslategray: "#778899",
  lightslategrey: "#778899",
  lightsteelblue: "#b0c4de",
  lightyellow: "#ffffe0",
  lime: "#00ff00",
  limegreen: "#32cd32",
  linen: "#faf0e6",
  magenta: "#ff00ff",
  maroon: "#800000",
  maroon2: "#7f0000",
  maroon3: "#b03060",
  mediumaquamarine: "#66cdaa",
  mediumblue: "#0000cd",
  mediumorchid: "#ba55d3",
  mediumpurple: "#9370db",
  mediumseagreen: "#3cb371",
  mediumslateblue: "#7b68ee",
  mediumspringgreen: "#00fa9a",
  mediumturquoise: "#48d1cc",
  mediumvioletred: "#c71585",
  midnightblue: "#191970",
  mintcream: "#f5fffa",
  mistyrose: "#ffe4e1",
  moccasin: "#ffe4b5",
  navajowhite: "#ffdead",
  navy: "#000080",
  oldlace: "#fdf5e6",
  olive: "#808000",
  olivedrab: "#6b8e23",
  orange: "#ffa500",
  orangered: "#ff4500",
  orchid: "#da70d6",
  palegoldenrod: "#eee8aa",
  palegreen: "#98fb98",
  paleturquoise: "#afeeee",
  palevioletred: "#db7093",
  papayawhip: "#ffefd5",
  peachpuff: "#ffdab9",
  peru: "#cd853f",
  pink: "#ffc0cb",
  plum: "#dda0dd",
  powderblue: "#b0e0e6",
  purple: "#800080",
  purple2: "#7f007f",
  purple3: "#a020f0",
  rebeccapurple: "#663399",
  red: "#ff0000",
  rosybrown: "#bc8f8f",
  royalblue: "#4169e1",
  saddlebrown: "#8b4513",
  salmon: "#fa8072",
  sandybrown: "#f4a460",
  seagreen: "#2e8b57",
  seashell: "#fff5ee",
  sienna: "#a0522d",
  silver: "#c0c0c0",
  skyblue: "#87ceeb",
  slateblue: "#6a5acd",
  slategray: "#708090",
  slategrey: "#708090",
  snow: "#fffafa",
  springgreen: "#00ff7f",
  steelblue: "#4682b4",
  tan: "#d2b48c",
  teal: "#008080",
  thistle: "#d8bfd8",
  tomato: "#ff6347",
  turquoise: "#40e0d0",
  violet: "#ee82ee",
  wheat: "#f5deb3",
  white: "#ffffff",
  whitesmoke: "#f5f5f5",
  yellow: "#ffff00",
  yellowgreen: "#9acd32"
}, cl = /^#?([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/, ul = /^#?([A-Fa-f0-9]{8}|[A-Fa-f0-9]{4})$/, Mo = (e) => {
  if (e.match(cl)) {
    (e.length === 4 || e.length === 7) && (e = e.substr(1)), e.length === 3 && (e = e.split(""), e = e[0] + e[0] + e[1] + e[1] + e[2] + e[2]);
    const t = parseInt(e, 16), n = t >> 16, o = t >> 8 & 255, r = t & 255;
    return [n, o, r, 1];
  }
  if (e.match(ul)) {
    (e.length === 5 || e.length === 9) && (e = e.substr(1)), e.length === 4 && (e = e.split(""), e = e[0] + e[0] + e[1] + e[1] + e[2] + e[2] + e[3] + e[3]);
    const t = parseInt(e, 16), n = t >> 24 & 255, o = t >> 16 & 255, r = t >> 8 & 255, l = Math.round((t & 255) / 255 * 100) / 100;
    return [n, o, r, l];
  }
  throw new Error(`unknown hex color: ${e}`);
}, { round: dt } = Math, Oo = (...e) => {
  let [t, n, o, r] = A(e, "rgba"), l = Ze(e) || "auto";
  r === void 0 && (r = 1), l === "auto" && (l = r < 1 ? "rgba" : "rgb"), t = dt(t), n = dt(n), o = dt(o);
  let s = "000000" + (t << 16 | n << 8 | o).toString(16);
  s = s.substr(s.length - 6);
  let i = "0" + dt(r * 255).toString(16);
  switch (i = i.substr(i.length - 2), l.toLowerCase()) {
    case "rgba":
      return `#${s}${i}`;
    case "argb":
      return `#${i}${s}`;
    default:
      return `#${s}`;
  }
};
y.prototype.name = function() {
  const e = Oo(this._rgb, "rgb");
  for (let t of Object.keys(Ke))
    if (Ke[t] === e) return t.toLowerCase();
  return e;
};
N.format.named = (e) => {
  if (e = e.toLowerCase(), Ke[e]) return Mo(Ke[e]);
  throw new Error("unknown color name: " + e);
};
N.autodetect.push({
  p: 5,
  test: (e, ...t) => {
    if (!t.length && I(e) === "string" && Ke[e.toLowerCase()])
      return "named";
  }
});
y.prototype.alpha = function(e, t = !1) {
  return e !== void 0 && I(e) === "number" ? t ? (this._rgb[3] = e, this) : new y([this._rgb[0], this._rgb[1], this._rgb[2], e], "rgb") : this._rgb[3];
};
y.prototype.clipped = function() {
  return this._rgb._clipped || !1;
};
const be = {
  // Corresponds roughly to RGB brighter/darker
  Kn: 18,
  // D65 standard referent
  labWhitePoint: "d65",
  Xn: 0.95047,
  Yn: 1,
  Zn: 1.08883,
  t0: 0.137931034,
  // 4 / 29
  t1: 0.206896552,
  // 6 / 29
  t2: 0.12841855,
  // 3 * t1 * t1
  t3: 8856452e-9,
  // t1 * t1 * t1,
  kE: 216 / 24389,
  kKE: 8,
  kK: 24389 / 27,
  RefWhiteRGB: {
    // sRGB
    X: 0.95047,
    Y: 1,
    Z: 1.08883
  },
  MtxRGB2XYZ: {
    m00: 0.4124564390896922,
    m01: 0.21267285140562253,
    m02: 0.0193338955823293,
    m10: 0.357576077643909,
    m11: 0.715152155287818,
    m12: 0.11919202588130297,
    m20: 0.18043748326639894,
    m21: 0.07217499330655958,
    m22: 0.9503040785363679
  },
  MtxXYZ2RGB: {
    m00: 3.2404541621141045,
    m01: -0.9692660305051868,
    m02: 0.055643430959114726,
    m10: -1.5371385127977166,
    m11: 1.8760108454466942,
    m12: -0.2040259135167538,
    m20: -0.498531409556016,
    m21: 0.041556017530349834,
    m22: 1.0572251882231791
  },
  // used in rgb2xyz
  As: 0.9414285350000001,
  Bs: 1.040417467,
  Cs: 1.089532651,
  MtxAdaptMa: {
    m00: 0.8951,
    m01: -0.7502,
    m02: 0.0389,
    m10: 0.2664,
    m11: 1.7135,
    m12: -0.0685,
    m20: -0.1614,
    m21: 0.0367,
    m22: 1.0296
  },
  MtxAdaptMaI: {
    m00: 0.9869929054667123,
    m01: 0.43230526972339456,
    m02: -0.008528664575177328,
    m10: -0.14705425642099013,
    m11: 0.5183602715367776,
    m12: 0.04004282165408487,
    m20: 0.15996265166373125,
    m21: 0.0492912282128556,
    m22: 0.9684866957875502
  }
}, dl = /* @__PURE__ */ new Map([
  // ASTM E308-01
  ["a", [1.0985, 0.35585]],
  // Wyszecki & Stiles, p. 769
  ["b", [1.0985, 0.35585]],
  // C ASTM E308-01
  ["c", [0.98074, 1.18232]],
  // D50 (ASTM E308-01)
  ["d50", [0.96422, 0.82521]],
  // D55 (ASTM E308-01)
  ["d55", [0.95682, 0.92149]],
  // D65 (ASTM E308-01)
  ["d65", [0.95047, 1.08883]],
  // E (ASTM E308-01)
  ["e", [1, 1, 1]],
  // F2 (ASTM E308-01)
  ["f2", [0.99186, 0.67393]],
  // F7 (ASTM E308-01)
  ["f7", [0.95041, 1.08747]],
  // F11 (ASTM E308-01)
  ["f11", [1.00962, 0.6435]],
  ["icc", [0.96422, 0.82521]]
]);
function we(e) {
  const t = dl.get(String(e).toLowerCase());
  if (!t)
    throw new Error("unknown Lab illuminant " + e);
  be.labWhitePoint = e, be.Xn = t[0], be.Zn = t[1];
}
function lt() {
  return be.labWhitePoint;
}
const Mn = (...e) => {
  e = A(e, "lab");
  const [t, n, o] = e, [r, l, a] = fl(t, n, o), [s, i, c] = _o(r, l, a);
  return [s, i, c, e.length > 3 ? e[3] : 1];
}, fl = (e, t, n) => {
  const { kE: o, kK: r, kKE: l, Xn: a, Yn: s, Zn: i } = be, c = (e + 16) / 116, u = 2e-3 * t + c, d = c - 5e-3 * n, f = u * u * u, h = d * d * d, b = f > o ? f : (116 * u - 16) / r, k = e > l ? Math.pow((e + 16) / 116, 3) : e / r, p = h > o ? h : (116 * d - 16) / r, w = b * a, _ = k * s, v = p * i;
  return [w, _, v];
}, Pt = (e) => {
  const t = Math.sign(e);
  return e = Math.abs(e), (e <= 31308e-7 ? e * 12.92 : 1.055 * Math.pow(e, 1 / 2.4) - 0.055) * t;
}, _o = (e, t, n) => {
  const { MtxAdaptMa: o, MtxAdaptMaI: r, MtxXYZ2RGB: l, RefWhiteRGB: a, Xn: s, Yn: i, Zn: c } = be, u = s * o.m00 + i * o.m10 + c * o.m20, d = s * o.m01 + i * o.m11 + c * o.m21, f = s * o.m02 + i * o.m12 + c * o.m22, h = a.X * o.m00 + a.Y * o.m10 + a.Z * o.m20, b = a.X * o.m01 + a.Y * o.m11 + a.Z * o.m21, k = a.X * o.m02 + a.Y * o.m12 + a.Z * o.m22, p = (e * o.m00 + t * o.m10 + n * o.m20) * (h / u), w = (e * o.m01 + t * o.m11 + n * o.m21) * (b / d), _ = (e * o.m02 + t * o.m12 + n * o.m22) * (k / f), v = p * r.m00 + w * r.m10 + _ * r.m20, M = p * r.m01 + w * r.m11 + _ * r.m21, E = p * r.m02 + w * r.m12 + _ * r.m22, L = Pt(
    v * l.m00 + M * l.m10 + E * l.m20
  ), m = Pt(
    v * l.m01 + M * l.m11 + E * l.m21
  ), $ = Pt(
    v * l.m02 + M * l.m12 + E * l.m22
  );
  return [L * 255, m * 255, $ * 255];
}, On = (...e) => {
  const [t, n, o, ...r] = A(e, "rgb"), [l, a, s] = Lo(t, n, o), [i, c, u] = hl(l, a, s);
  return [i, c, u, ...r.length > 0 && r[0] < 1 ? [r[0]] : []];
};
function hl(e, t, n) {
  const { Xn: o, Yn: r, Zn: l, kE: a, kK: s } = be, i = e / o, c = t / r, u = n / l, d = i > a ? Math.pow(i, 1 / 3) : (s * i + 16) / 116, f = c > a ? Math.pow(c, 1 / 3) : (s * c + 16) / 116, h = u > a ? Math.pow(u, 1 / 3) : (s * u + 16) / 116;
  return [116 * f - 16, 500 * (d - f), 200 * (f - h)];
}
function Ft(e) {
  const t = Math.sign(e);
  return e = Math.abs(e), (e <= 0.04045 ? e / 12.92 : Math.pow((e + 0.055) / 1.055, 2.4)) * t;
}
const Lo = (e, t, n) => {
  e = Ft(e / 255), t = Ft(t / 255), n = Ft(n / 255);
  const { MtxRGB2XYZ: o, MtxAdaptMa: r, MtxAdaptMaI: l, Xn: a, Yn: s, Zn: i, As: c, Bs: u, Cs: d } = be;
  let f = e * o.m00 + t * o.m10 + n * o.m20, h = e * o.m01 + t * o.m11 + n * o.m21, b = e * o.m02 + t * o.m12 + n * o.m22;
  const k = a * r.m00 + s * r.m10 + i * r.m20, p = a * r.m01 + s * r.m11 + i * r.m21, w = a * r.m02 + s * r.m12 + i * r.m22;
  let _ = f * r.m00 + h * r.m10 + b * r.m20, v = f * r.m01 + h * r.m11 + b * r.m21, M = f * r.m02 + h * r.m12 + b * r.m22;
  return _ *= k / c, v *= p / u, M *= w / d, f = _ * l.m00 + v * l.m10 + M * l.m20, h = _ * l.m01 + v * l.m11 + M * l.m21, b = _ * l.m02 + v * l.m12 + M * l.m22, [f, h, b];
};
y.prototype.lab = function() {
  return On(this._rgb);
};
const pl = (...e) => new y(...e, "lab");
Object.assign(j, { lab: pl, getLabWhitePoint: lt, setLabWhitePoint: we });
N.format.lab = Mn;
N.autodetect.push({
  p: 2,
  test: (...e) => {
    if (e = A(e, "lab"), I(e) === "array" && e.length === 3)
      return "lab";
  }
});
y.prototype.darken = function(e = 1) {
  const t = this, n = t.lab();
  return n[0] -= be.Kn * e, new y(n, "lab").alpha(t.alpha(), !0);
};
y.prototype.brighten = function(e = 1) {
  return this.darken(-e);
};
y.prototype.darker = y.prototype.darken;
y.prototype.brighter = y.prototype.brighten;
y.prototype.get = function(e) {
  const [t, n] = e.split("."), o = this[t]();
  if (n) {
    const r = t.indexOf(n) - (t.substr(0, 2) === "ok" ? 2 : 0);
    if (r > -1) return o[r];
    throw new Error(`unknown channel ${n} in mode ${t}`);
  } else
    return o;
};
const { pow: ml } = Math, bl = 1e-7, gl = 20;
y.prototype.luminance = function(e, t = "rgb") {
  if (e !== void 0 && I(e) === "number") {
    if (e === 0)
      return new y([0, 0, 0, this._rgb[3]], "rgb");
    if (e === 1)
      return new y([255, 255, 255, this._rgb[3]], "rgb");
    let n = this.luminance(), o = gl;
    const r = (a, s) => {
      const i = a.interpolate(s, 0.5, t), c = i.luminance();
      return Math.abs(e - c) < bl || !o-- ? i : c > e ? r(a, i) : r(i, s);
    }, l = (n > e ? r(new y([0, 0, 0]), this) : r(this, new y([255, 255, 255]))).rgb();
    return new y([...l, this._rgb[3]]);
  }
  return yl(...this._rgb.slice(0, 3));
};
const yl = (e, t, n) => (e = zt(e), t = zt(t), n = zt(n), 0.2126 * e + 0.7152 * t + 0.0722 * n), zt = (e) => (e /= 255, e <= 0.03928 ? e / 12.92 : ml((e + 0.055) / 1.055, 2.4)), ee = {}, Xe = (e, t, n = 0.5, ...o) => {
  let r = o[0] || "lrgb";
  if (!ee[r] && !o.length && (r = Object.keys(ee)[0]), !ee[r])
    throw new Error(`interpolation mode ${r} is not defined`);
  return I(e) !== "object" && (e = new y(e)), I(t) !== "object" && (t = new y(t)), ee[r](e, t, n).alpha(
    e.alpha() + n * (t.alpha() - e.alpha())
  );
};
y.prototype.mix = y.prototype.interpolate = function(e, t = 0.5, ...n) {
  return Xe(this, e, t, ...n);
};
y.prototype.premultiply = function(e = !1) {
  const t = this._rgb, n = t[3];
  return e ? (this._rgb = [t[0] * n, t[1] * n, t[2] * n, n], this) : new y([t[0] * n, t[1] * n, t[2] * n, n], "rgb");
};
const { sin: vl, cos: wl } = Math, To = (...e) => {
  let [t, n, o] = A(e, "lch");
  return isNaN(o) && (o = 0), o = o * al, [t, wl(o) * n, vl(o) * n];
}, _n = (...e) => {
  e = A(e, "lch");
  const [t, n, o] = e, [r, l, a] = To(t, n, o), [s, i, c] = Mn(r, l, a);
  return [s, i, c, e.length > 3 ? e[3] : 1];
}, Cl = (...e) => {
  const t = So(A(e, "hcl"));
  return _n(...t);
}, { sqrt: kl, atan2: $l, round: Sl } = Math, No = (...e) => {
  const [t, n, o] = A(e, "lab"), r = kl(n * n + o * o);
  let l = ($l(o, n) * sl + 360) % 360;
  return Sl(r * 1e4) === 0 && (l = Number.NaN), [t, r, l];
}, Ln = (...e) => {
  const [t, n, o, ...r] = A(e, "rgb"), [l, a, s] = On(t, n, o), [i, c, u] = No(l, a, s);
  return [i, c, u, ...r.length > 0 && r[0] < 1 ? [r[0]] : []];
};
y.prototype.lch = function() {
  return Ln(this._rgb);
};
y.prototype.hcl = function() {
  return So(Ln(this._rgb));
};
const Ml = (...e) => new y(...e, "lch"), Ol = (...e) => new y(...e, "hcl");
Object.assign(j, { lch: Ml, hcl: Ol });
N.format.lch = _n;
N.format.hcl = Cl;
["lch", "hcl"].forEach(
  (e) => N.autodetect.push({
    p: 2,
    test: (...t) => {
      if (t = A(t, e), I(t) === "array" && t.length === 3)
        return e;
    }
  })
);
y.prototype.saturate = function(e = 1) {
  const t = this, n = t.lch();
  return n[1] += be.Kn * e, n[1] < 0 && (n[1] = 0), new y(n, "lch").alpha(t.alpha(), !0);
};
y.prototype.desaturate = function(e = 1) {
  return this.saturate(-e);
};
y.prototype.set = function(e, t, n = !1) {
  const [o, r] = e.split("."), l = this[o]();
  if (r) {
    const a = o.indexOf(r) - (o.substr(0, 2) === "ok" ? 2 : 0);
    if (a > -1) {
      if (I(t) == "string")
        switch (t.charAt(0)) {
          case "+":
            l[a] += +t;
            break;
          case "-":
            l[a] += +t;
            break;
          case "*":
            l[a] *= +t.substr(1);
            break;
          case "/":
            l[a] /= +t.substr(1);
            break;
          default:
            l[a] = +t;
        }
      else if (I(t) === "number")
        l[a] = t;
      else
        throw new Error("unsupported value for Color.set");
      const s = new y(l, o);
      return n ? (this._rgb = s._rgb, this) : s;
    }
    throw new Error(`unknown channel ${r} in mode ${o}`);
  } else
    return l;
};
y.prototype.tint = function(e = 0.5, ...t) {
  return Xe(this, "white", e, ...t);
};
y.prototype.shade = function(e = 0.5, ...t) {
  return Xe(this, "black", e, ...t);
};
const _l = (e, t, n) => {
  const o = e._rgb, r = t._rgb;
  return new y(
    o[0] + n * (r[0] - o[0]),
    o[1] + n * (r[1] - o[1]),
    o[2] + n * (r[2] - o[2]),
    "rgb"
  );
};
ee.rgb = _l;
const { sqrt: qt, pow: qe } = Math, Ll = (e, t, n) => {
  const [o, r, l] = e._rgb, [a, s, i] = t._rgb;
  return new y(
    qt(qe(o, 2) * (1 - n) + qe(a, 2) * n),
    qt(qe(r, 2) * (1 - n) + qe(s, 2) * n),
    qt(qe(l, 2) * (1 - n) + qe(i, 2) * n),
    "rgb"
  );
};
ee.lrgb = Ll;
const Tl = (e, t, n) => {
  const o = e.lab(), r = t.lab();
  return new y(
    o[0] + n * (r[0] - o[0]),
    o[1] + n * (r[1] - o[1]),
    o[2] + n * (r[2] - o[2]),
    "lab"
  );
};
ee.lab = Tl;
const xe = (e, t, n, o) => {
  let r, l;
  o === "hsl" ? (r = e.hsl(), l = t.hsl()) : o === "hsv" ? (r = e.hsv(), l = t.hsv()) : o === "hcg" ? (r = e.hcg(), l = t.hcg()) : o === "hsi" ? (r = e.hsi(), l = t.hsi()) : o === "lch" || o === "hcl" ? (o = "hcl", r = e.hcl(), l = t.hcl()) : o === "oklch" && (r = e.oklch().reverse(), l = t.oklch().reverse());
  let a, s, i, c, u, d;
  (o.substr(0, 1) === "h" || o === "oklch") && ([a, i, u] = r, [s, c, d] = l);
  let f, h, b, k;
  return !isNaN(a) && !isNaN(s) ? (s > a && s - a > 180 ? k = s - (a + 360) : s < a && a - s > 180 ? k = s + 360 - a : k = s - a, h = a + n * k) : isNaN(a) ? isNaN(s) ? h = Number.NaN : (h = s, (u == 1 || u == 0) && o != "hsv" && (f = c)) : (h = a, (d == 1 || d == 0) && o != "hsv" && (f = i)), f === void 0 && (f = i + n * (c - i)), b = u + n * (d - u), o === "oklch" ? new y([b, f, h], o) : new y([h, f, b], o);
}, Ao = (e, t, n) => xe(e, t, n, "lch");
ee.lch = Ao;
ee.hcl = Ao;
const Nl = (e) => {
  if (I(e) == "number" && e >= 0 && e <= 16777215) {
    const t = e >> 16, n = e >> 8 & 255, o = e & 255;
    return [t, n, o, 1];
  }
  throw new Error("unknown num color: " + e);
}, Al = (...e) => {
  const [t, n, o] = A(e, "rgb");
  return (t << 16) + (n << 8) + o;
};
y.prototype.num = function() {
  return Al(this._rgb);
};
const Rl = (...e) => new y(...e, "num");
Object.assign(j, { num: Rl });
N.format.num = Nl;
N.autodetect.push({
  p: 5,
  test: (...e) => {
    if (e.length === 1 && I(e[0]) === "number" && e[0] >= 0 && e[0] <= 16777215)
      return "num";
  }
});
const Dl = (e, t, n) => {
  const o = e.num(), r = t.num();
  return new y(o + n * (r - o), "num");
};
ee.num = Dl;
const { floor: El } = Math, Bl = (...e) => {
  e = A(e, "hcg");
  let [t, n, o] = e, r, l, a;
  o = o * 255;
  const s = n * 255;
  if (n === 0)
    r = l = a = o;
  else {
    t === 360 && (t = 0), t > 360 && (t -= 360), t < 0 && (t += 360), t /= 60;
    const i = El(t), c = t - i, u = o * (1 - n), d = u + s * (1 - c), f = u + s * c, h = u + s;
    switch (i) {
      case 0:
        [r, l, a] = [h, f, u];
        break;
      case 1:
        [r, l, a] = [d, h, u];
        break;
      case 2:
        [r, l, a] = [u, h, f];
        break;
      case 3:
        [r, l, a] = [u, d, h];
        break;
      case 4:
        [r, l, a] = [f, u, h];
        break;
      case 5:
        [r, l, a] = [h, u, d];
        break;
    }
  }
  return [r, l, a, e.length > 3 ? e[3] : 1];
}, Il = (...e) => {
  const [t, n, o] = A(e, "rgb"), r = ko(t, n, o), l = $o(t, n, o), a = l - r, s = a * 100 / 255, i = r / (255 - a) * 100;
  let c;
  return a === 0 ? c = Number.NaN : (t === l && (c = (n - o) / a), n === l && (c = 2 + (o - t) / a), o === l && (c = 4 + (t - n) / a), c *= 60, c < 0 && (c += 360)), [c, s, i];
};
y.prototype.hcg = function() {
  return Il(this._rgb);
};
const jl = (...e) => new y(...e, "hcg");
j.hcg = jl;
N.format.hcg = Bl;
N.autodetect.push({
  p: 1,
  test: (...e) => {
    if (e = A(e, "hcg"), I(e) === "array" && e.length === 3)
      return "hcg";
  }
});
const Pl = (e, t, n) => xe(e, t, n, "hcg");
ee.hcg = Pl;
const { cos: Ge } = Math, Fl = (...e) => {
  e = A(e, "hsi");
  let [t, n, o] = e, r, l, a;
  return isNaN(t) && (t = 0), isNaN(n) && (n = 0), t > 360 && (t -= 360), t < 0 && (t += 360), t /= 360, t < 1 / 3 ? (a = (1 - n) / 3, r = (1 + n * Ge(ve * t) / Ge(jt - ve * t)) / 3, l = 1 - (a + r)) : t < 2 / 3 ? (t -= 1 / 3, r = (1 - n) / 3, l = (1 + n * Ge(ve * t) / Ge(jt - ve * t)) / 3, a = 1 - (r + l)) : (t -= 2 / 3, l = (1 - n) / 3, a = (1 + n * Ge(ve * t) / Ge(jt - ve * t)) / 3, r = 1 - (l + a)), r = je(o * r * 3), l = je(o * l * 3), a = je(o * a * 3), [r * 255, l * 255, a * 255, e.length > 3 ? e[3] : 1];
}, { min: zl, sqrt: ql, acos: Gl } = Math, Vl = (...e) => {
  let [t, n, o] = A(e, "rgb");
  t /= 255, n /= 255, o /= 255;
  let r;
  const l = zl(t, n, o), a = (t + n + o) / 3, s = a > 0 ? 1 - l / a : 0;
  return s === 0 ? r = NaN : (r = (t - n + (t - o)) / 2, r /= ql((t - n) * (t - n) + (t - o) * (n - o)), r = Gl(r), o > n && (r = ve - r), r /= ve), [r * 360, s, a];
};
y.prototype.hsi = function() {
  return Vl(this._rgb);
};
const Yl = (...e) => new y(...e, "hsi");
j.hsi = Yl;
N.format.hsi = Fl;
N.autodetect.push({
  p: 2,
  test: (...e) => {
    if (e = A(e, "hsi"), I(e) === "array" && e.length === 3)
      return "hsi";
  }
});
const Wl = (e, t, n) => xe(e, t, n, "hsi");
ee.hsi = Wl;
const ln = (...e) => {
  e = A(e, "hsl");
  const [t, n, o] = e;
  let r, l, a;
  if (n === 0)
    r = l = a = o * 255;
  else {
    const s = [0, 0, 0], i = [0, 0, 0], c = o < 0.5 ? o * (1 + n) : o + n - o * n, u = 2 * o - c, d = t / 360;
    s[0] = d + 1 / 3, s[1] = d, s[2] = d - 1 / 3;
    for (let f = 0; f < 3; f++)
      s[f] < 0 && (s[f] += 1), s[f] > 1 && (s[f] -= 1), 6 * s[f] < 1 ? i[f] = u + (c - u) * 6 * s[f] : 2 * s[f] < 1 ? i[f] = c : 3 * s[f] < 2 ? i[f] = u + (c - u) * (2 / 3 - s[f]) * 6 : i[f] = u;
    [r, l, a] = [i[0] * 255, i[1] * 255, i[2] * 255];
  }
  return e.length > 3 ? [r, l, a, e[3]] : [r, l, a, 1];
}, Ro = (...e) => {
  e = A(e, "rgba");
  let [t, n, o] = e;
  t /= 255, n /= 255, o /= 255;
  const r = ko(t, n, o), l = $o(t, n, o), a = (l + r) / 2;
  let s, i;
  return l === r ? (s = 0, i = Number.NaN) : s = a < 0.5 ? (l - r) / (l + r) : (l - r) / (2 - l - r), t == l ? i = (n - o) / (l - r) : n == l ? i = 2 + (o - t) / (l - r) : o == l && (i = 4 + (t - n) / (l - r)), i *= 60, i < 0 && (i += 360), e.length > 3 && e[3] !== void 0 ? [i, s, a, e[3]] : [i, s, a];
};
y.prototype.hsl = function() {
  return Ro(this._rgb);
};
const Ul = (...e) => new y(...e, "hsl");
j.hsl = Ul;
N.format.hsl = ln;
N.autodetect.push({
  p: 2,
  test: (...e) => {
    if (e = A(e, "hsl"), I(e) === "array" && e.length === 3)
      return "hsl";
  }
});
const Hl = (e, t, n) => xe(e, t, n, "hsl");
ee.hsl = Hl;
const { floor: Kl } = Math, Xl = (...e) => {
  e = A(e, "hsv");
  let [t, n, o] = e, r, l, a;
  if (o *= 255, n === 0)
    r = l = a = o;
  else {
    t === 360 && (t = 0), t > 360 && (t -= 360), t < 0 && (t += 360), t /= 60;
    const s = Kl(t), i = t - s, c = o * (1 - n), u = o * (1 - n * i), d = o * (1 - n * (1 - i));
    switch (s) {
      case 0:
        [r, l, a] = [o, d, c];
        break;
      case 1:
        [r, l, a] = [u, o, c];
        break;
      case 2:
        [r, l, a] = [c, o, d];
        break;
      case 3:
        [r, l, a] = [c, u, o];
        break;
      case 4:
        [r, l, a] = [d, c, o];
        break;
      case 5:
        [r, l, a] = [o, c, u];
        break;
    }
  }
  return [r, l, a, e.length > 3 ? e[3] : 1];
}, { min: Zl, max: xl } = Math, Ql = (...e) => {
  e = A(e, "rgb");
  let [t, n, o] = e;
  const r = Zl(t, n, o), l = xl(t, n, o), a = l - r;
  let s, i, c;
  return c = l / 255, l === 0 ? (s = Number.NaN, i = 0) : (i = a / l, t === l && (s = (n - o) / a), n === l && (s = 2 + (o - t) / a), o === l && (s = 4 + (t - n) / a), s *= 60, s < 0 && (s += 360)), [s, i, c];
};
y.prototype.hsv = function() {
  return Ql(this._rgb);
};
const Jl = (...e) => new y(...e, "hsv");
j.hsv = Jl;
N.format.hsv = Xl;
N.autodetect.push({
  p: 2,
  test: (...e) => {
    if (e = A(e, "hsv"), I(e) === "array" && e.length === 3)
      return "hsv";
  }
});
const ea = (e, t, n) => xe(e, t, n, "hsv");
ee.hsv = ea;
function kt(e, t) {
  let n = e.length;
  Array.isArray(e[0]) || (e = [e]), Array.isArray(t[0]) || (t = t.map((a) => [a]));
  let o = t[0].length, r = t[0].map((a, s) => t.map((i) => i[s])), l = e.map(
    (a) => r.map((s) => Array.isArray(a) ? a.reduce((i, c, u) => i + c * (s[u] || 0), 0) : s.reduce((i, c) => i + c * a, 0))
  );
  return n === 1 && (l = l[0]), o === 1 ? l.map((a) => a[0]) : l;
}
const Tn = (...e) => {
  e = A(e, "lab");
  const [t, n, o, ...r] = e, [l, a, s] = ta([t, n, o]), [i, c, u] = _o(l, a, s);
  return [i, c, u, ...r.length > 0 && r[0] < 1 ? [r[0]] : []];
};
function ta(e) {
  var t = [
    [1.2268798758459243, -0.5578149944602171, 0.2813910456659647],
    [-0.0405757452148008, 1.112286803280317, -0.0717110580655164],
    [-0.0763729366746601, -0.4214933324022432, 1.5869240198367816]
  ], n = [
    [1, 0.3963377773761749, 0.2158037573099136],
    [1, -0.1055613458156586, -0.0638541728258133],
    [1, -0.0894841775298119, -1.2914855480194092]
  ], o = kt(n, e);
  return kt(
    t,
    o.map((r) => r ** 3)
  );
}
const Nn = (...e) => {
  const [t, n, o, ...r] = A(e, "rgb"), l = Lo(t, n, o);
  return [...na(l), ...r.length > 0 && r[0] < 1 ? [r[0]] : []];
};
function na(e) {
  const t = [
    [0.819022437996703, 0.3619062600528904, -0.1288737815209879],
    [0.0329836539323885, 0.9292868615863434, 0.0361446663506424],
    [0.0481771893596242, 0.2642395317527308, 0.6335478284694309]
  ], n = [
    [0.210454268309314, 0.7936177747023054, -0.0040720430116193],
    [1.9779985324311684, -2.42859224204858, 0.450593709617411],
    [0.0259040424655478, 0.7827717124575296, -0.8086757549230774]
  ], o = kt(t, e);
  return kt(
    n,
    o.map((r) => Math.cbrt(r))
  );
}
y.prototype.oklab = function() {
  return Nn(this._rgb);
};
const oa = (...e) => new y(...e, "oklab");
Object.assign(j, { oklab: oa });
N.format.oklab = Tn;
N.autodetect.push({
  p: 2,
  test: (...e) => {
    if (e = A(e, "oklab"), I(e) === "array" && e.length === 3)
      return "oklab";
  }
});
const ra = (e, t, n) => {
  const o = e.oklab(), r = t.oklab();
  return new y(
    o[0] + n * (r[0] - o[0]),
    o[1] + n * (r[1] - o[1]),
    o[2] + n * (r[2] - o[2]),
    "oklab"
  );
};
ee.oklab = ra;
const la = (e, t, n) => xe(e, t, n, "oklch");
ee.oklch = la;
const { pow: Gt, sqrt: Vt, PI: Yt, cos: Yn, sin: Wn, atan2: aa } = Math, sa = (e, t = "lrgb", n = null) => {
  const o = e.length;
  n || (n = Array.from(new Array(o)).map(() => 1));
  const r = o / n.reduce(function(d, f) {
    return d + f;
  });
  if (n.forEach((d, f) => {
    n[f] *= r;
  }), e = e.map((d) => new y(d)), t === "lrgb")
    return ia(e, n);
  const l = e.shift(), a = l.get(t), s = [];
  let i = 0, c = 0;
  for (let d = 0; d < a.length; d++)
    if (a[d] = (a[d] || 0) * n[0], s.push(isNaN(a[d]) ? 0 : n[0]), t.charAt(d) === "h" && !isNaN(a[d])) {
      const f = a[d] / 180 * Yt;
      i += Yn(f) * n[0], c += Wn(f) * n[0];
    }
  let u = l.alpha() * n[0];
  e.forEach((d, f) => {
    const h = d.get(t);
    u += d.alpha() * n[f + 1];
    for (let b = 0; b < a.length; b++)
      if (!isNaN(h[b]))
        if (s[b] += n[f + 1], t.charAt(b) === "h") {
          const k = h[b] / 180 * Yt;
          i += Yn(k) * n[f + 1], c += Wn(k) * n[f + 1];
        } else
          a[b] += h[b] * n[f + 1];
  });
  for (let d = 0; d < a.length; d++)
    if (t.charAt(d) === "h") {
      let f = aa(c / s[d], i / s[d]) / Yt * 180;
      for (; f < 0; ) f += 360;
      for (; f >= 360; ) f -= 360;
      a[d] = f;
    } else
      a[d] = a[d] / s[d];
  return u /= o, new y(a, t).alpha(u > 0.99999 ? 1 : u, !0);
}, ia = (e, t) => {
  const n = e.length, o = [0, 0, 0, 0];
  for (let r = 0; r < e.length; r++) {
    const l = e[r], a = t[r] / n, s = l._rgb;
    o[0] += Gt(s[0], 2) * a, o[1] += Gt(s[1], 2) * a, o[2] += Gt(s[2], 2) * a, o[3] += s[3] * a;
  }
  return o[0] = Vt(o[0]), o[1] = Vt(o[1]), o[2] = Vt(o[2]), o[3] > 0.9999999 && (o[3] = 1), new y(Sn(o));
}, { pow: ca } = Math;
function $t(e) {
  let t = "rgb", n = j("#ccc"), o = 0, r = [0, 1], l = [], a = [0, 0], s = !1, i = [], c = !1, u = 0, d = 1, f = !1, h = {}, b = !0, k = 1;
  const p = function(m) {
    if (m = m || ["#fff", "#000"], m && I(m) === "string" && j.brewer && j.brewer[m.toLowerCase()] && (m = j.brewer[m.toLowerCase()]), I(m) === "array") {
      m.length === 1 && (m = [m[0], m[0]]), m = m.slice(0);
      for (let $ = 0; $ < m.length; $++)
        m[$] = j(m[$]);
      l.length = 0;
      for (let $ = 0; $ < m.length; $++)
        l.push($ / (m.length - 1));
    }
    return E(), i = m;
  }, w = function(m) {
    if (s != null) {
      const $ = s.length - 1;
      let O = 0;
      for (; O < $ && m >= s[O]; )
        O++;
      return O - 1;
    }
    return 0;
  };
  let _ = (m) => m, v = (m) => m;
  const M = function(m, $) {
    let O, S;
    if ($ == null && ($ = !1), isNaN(m) || m === null)
      return n;
    $ ? S = m : s && s.length > 2 ? S = w(m) / (s.length - 2) : d !== u ? S = (m - u) / (d - u) : S = 1, S = v(S), $ || (S = _(S)), k !== 1 && (S = ca(S, k)), S = a[0] + S * (1 - a[0] - a[1]), S = je(S, 0, 1);
    const R = Math.floor(S * 1e4);
    if (b && h[R])
      O = h[R];
    else {
      if (I(i) === "array")
        for (let D = 0; D < l.length; D++) {
          const H = l[D];
          if (S <= H) {
            O = i[D];
            break;
          }
          if (S >= H && D === l.length - 1) {
            O = i[D];
            break;
          }
          if (S > H && S < l[D + 1]) {
            S = (S - H) / (l[D + 1] - H), O = j.interpolate(
              i[D],
              i[D + 1],
              S,
              t
            );
            break;
          }
        }
      else I(i) === "function" && (O = i(S));
      b && (h[R] = O);
    }
    return O;
  };
  var E = () => h = {};
  p(e);
  const L = function(m) {
    const $ = j(M(m));
    return c && $[c] ? $[c]() : $;
  };
  return L.classes = function(m) {
    if (m != null) {
      if (I(m) === "array")
        s = m, r = [m[0], m[m.length - 1]];
      else {
        const $ = j.analyze(r);
        m === 0 ? s = [$.min, $.max] : s = j.limits($, "e", m);
      }
      return L;
    }
    return s;
  }, L.domain = function(m) {
    if (!arguments.length)
      return r;
    u = m[0], d = m[m.length - 1], l = [];
    const $ = i.length;
    if (m.length === $ && u !== d)
      for (let O of Array.from(m))
        l.push((O - u) / (d - u));
    else {
      for (let O = 0; O < $; O++)
        l.push(O / ($ - 1));
      if (m.length > 2) {
        const O = m.map((R, D) => D / (m.length - 1)), S = m.map((R) => (R - u) / (d - u));
        S.every((R, D) => O[D] === R) || (v = (R) => {
          if (R <= 0 || R >= 1) return R;
          let D = 0;
          for (; R >= S[D + 1]; ) D++;
          const H = (R - S[D]) / (S[D + 1] - S[D]);
          return O[D] + H * (O[D + 1] - O[D]);
        });
      }
    }
    return r = [u, d], L;
  }, L.mode = function(m) {
    return arguments.length ? (t = m, E(), L) : t;
  }, L.range = function(m, $) {
    return p(m), L;
  }, L.out = function(m) {
    return c = m, L;
  }, L.spread = function(m) {
    return arguments.length ? (o = m, L) : o;
  }, L.correctLightness = function(m) {
    return m == null && (m = !0), f = m, E(), f ? _ = function($) {
      const O = M(0, !0).lab()[0], S = M(1, !0).lab()[0], R = O > S;
      let D = M($, !0).lab()[0];
      const H = O + (S - O) * $;
      let Ee = D - H, tt = 0, ct = 1, ut = 20;
      for (; Math.abs(Ee) > 0.01 && ut-- > 0; )
        (function() {
          return R && (Ee *= -1), Ee < 0 ? (tt = $, $ += (ct - $) * 0.5) : (ct = $, $ += (tt - $) * 0.5), D = M($, !0).lab()[0], Ee = D - H;
        })();
      return $;
    } : _ = ($) => $, L;
  }, L.padding = function(m) {
    return m != null ? (I(m) === "number" && (m = [m, m]), a = m, L) : a;
  }, L.colors = function(m, $) {
    arguments.length < 2 && ($ = "hex");
    let O = [];
    if (arguments.length === 0)
      O = i.slice(0);
    else if (m === 1)
      O = [L(0.5)];
    else if (m > 1) {
      const S = r[0], R = r[1] - S;
      O = ua(0, m).map(
        (D) => L(S + D / (m - 1) * R)
      );
    } else {
      e = [];
      let S = [];
      if (s && s.length > 2)
        for (let R = 1, D = s.length, H = 1 <= D; H ? R < D : R > D; H ? R++ : R--)
          S.push((s[R - 1] + s[R]) * 0.5);
      else
        S = r;
      O = S.map((R) => L(R));
    }
    return j[$] && (O = O.map((S) => S[$]())), O;
  }, L.cache = function(m) {
    return m != null ? (b = m, L) : b;
  }, L.gamma = function(m) {
    return m != null ? (k = m, L) : k;
  }, L.nodata = function(m) {
    return m != null ? (n = j(m), L) : n;
  }, L;
}
function ua(e, t, n) {
  let o = [], r = e < t, l = t;
  for (let a = e; r ? a < l : a > l; r ? a++ : a--)
    o.push(a);
  return o;
}
const da = function(e) {
  let t = [1, 1];
  for (let n = 1; n < e; n++) {
    let o = [1];
    for (let r = 1; r <= t.length; r++)
      o[r] = (t[r] || 0) + t[r - 1];
    t = o;
  }
  return t;
}, fa = function(e) {
  let t, n, o, r;
  if (e = e.map((l) => new y(l)), e.length === 2)
    [n, o] = e.map((l) => l.lab()), t = function(l) {
      const a = [0, 1, 2].map((s) => n[s] + l * (o[s] - n[s]));
      return new y(a, "lab");
    };
  else if (e.length === 3)
    [n, o, r] = e.map((l) => l.lab()), t = function(l) {
      const a = [0, 1, 2].map(
        (s) => (1 - l) * (1 - l) * n[s] + 2 * (1 - l) * l * o[s] + l * l * r[s]
      );
      return new y(a, "lab");
    };
  else if (e.length === 4) {
    let l;
    [n, o, r, l] = e.map((a) => a.lab()), t = function(a) {
      const s = [0, 1, 2].map(
        (i) => (1 - a) * (1 - a) * (1 - a) * n[i] + 3 * (1 - a) * (1 - a) * a * o[i] + 3 * (1 - a) * a * a * r[i] + a * a * a * l[i]
      );
      return new y(s, "lab");
    };
  } else if (e.length >= 5) {
    let l, a, s;
    l = e.map((i) => i.lab()), s = e.length - 1, a = da(s), t = function(i) {
      const c = 1 - i, u = [0, 1, 2].map(
        (d) => l.reduce(
          (f, h, b) => f + a[b] * c ** (s - b) * i ** b * h[d],
          0
        )
      );
      return new y(u, "lab");
    };
  } else
    throw new RangeError("No point in running bezier with only one color.");
  return t;
}, ha = (e) => {
  const t = fa(e);
  return t.scale = () => $t(t), t;
}, { round: Do } = Math;
y.prototype.rgb = function(e = !0) {
  return e === !1 ? this._rgb.slice(0, 3) : this._rgb.slice(0, 3).map(Do);
};
y.prototype.rgba = function(e = !0) {
  return this._rgb.slice(0, 4).map((t, n) => n < 3 ? e === !1 ? t : Do(t) : t);
};
const pa = (...e) => new y(...e, "rgb");
Object.assign(j, { rgb: pa });
N.format.rgb = (...e) => {
  const t = A(e, "rgba");
  return t[3] === void 0 && (t[3] = 1), t;
};
N.autodetect.push({
  p: 3,
  test: (...e) => {
    if (e = A(e, "rgba"), I(e) === "array" && (e.length === 3 || e.length === 4 && I(e[3]) == "number" && e[3] >= 0 && e[3] <= 1))
      return "rgb";
  }
});
const he = (e, t, n) => {
  if (!he[n])
    throw new Error("unknown blend mode " + n);
  return he[n](e, t);
}, Ne = (e) => (t, n) => {
  const o = j(n).rgb(), r = j(t).rgb();
  return j.rgb(e(o, r));
}, Ae = (e) => (t, n) => {
  const o = [];
  return o[0] = e(t[0], n[0]), o[1] = e(t[1], n[1]), o[2] = e(t[2], n[2]), o;
}, ma = (e) => e, ba = (e, t) => e * t / 255, ga = (e, t) => e > t ? t : e, ya = (e, t) => e > t ? e : t, va = (e, t) => 255 * (1 - (1 - e / 255) * (1 - t / 255)), wa = (e, t) => t < 128 ? 2 * e * t / 255 : 255 * (1 - 2 * (1 - e / 255) * (1 - t / 255)), Ca = (e, t) => 255 * (1 - (1 - t / 255) / (e / 255)), ka = (e, t) => e === 255 ? 255 : (e = 255 * (t / 255) / (1 - e / 255), e > 255 ? 255 : e);
he.normal = Ne(Ae(ma));
he.multiply = Ne(Ae(ba));
he.screen = Ne(Ae(va));
he.overlay = Ne(Ae(wa));
he.darken = Ne(Ae(ga));
he.lighten = Ne(Ae(ya));
he.dodge = Ne(Ae(ka));
he.burn = Ne(Ae(Ca));
const { pow: $a, sin: Sa, cos: Ma } = Math;
function Oa(e = 300, t = -1.5, n = 1, o = 1, r = [0, 1]) {
  let l = 0, a;
  I(r) === "array" ? a = r[1] - r[0] : (a = 0, r = [r, r]);
  const s = function(i) {
    const c = ve * ((e + 120) / 360 + t * i), u = $a(r[0] + a * i, o), f = (l !== 0 ? n[0] + i * l : n) * u * (1 - u) / 2, h = Ma(c), b = Sa(c), k = u + f * (-0.14861 * h + 1.78277 * b), p = u + f * (-0.29227 * h - 0.90649 * b), w = u + f * (1.97294 * h);
    return j(Sn([k * 255, p * 255, w * 255, 1]));
  };
  return s.start = function(i) {
    return i == null ? e : (e = i, s);
  }, s.rotations = function(i) {
    return i == null ? t : (t = i, s);
  }, s.gamma = function(i) {
    return i == null ? o : (o = i, s);
  }, s.hue = function(i) {
    return i == null ? n : (n = i, I(n) === "array" ? (l = n[1] - n[0], l === 0 && (n = n[1])) : l = 0, s);
  }, s.lightness = function(i) {
    return i == null ? r : (I(i) === "array" ? (r = i, a = i[1] - i[0]) : (r = [i, i], a = 0), s);
  }, s.scale = () => j.scale(s), s.hue(n), s;
}
const _a = "0123456789abcdef", { floor: La, random: Ta } = Math, Na = () => {
  let e = "#";
  for (let t = 0; t < 6; t++)
    e += _a.charAt(La(Ta() * 16));
  return new y(e, "hex");
}, { log: Un, pow: Aa, floor: Ra, abs: Da } = Math;
function Eo(e, t = null) {
  const n = {
    min: Number.MAX_VALUE,
    max: Number.MAX_VALUE * -1,
    sum: 0,
    values: [],
    count: 0
  };
  return I(e) === "object" && (e = Object.values(e)), e.forEach((o) => {
    t && I(o) === "object" && (o = o[t]), o != null && !isNaN(o) && (n.values.push(o), n.sum += o, o < n.min && (n.min = o), o > n.max && (n.max = o), n.count += 1);
  }), n.domain = [n.min, n.max], n.limits = (o, r) => Bo(n, o, r), n;
}
function Bo(e, t = "equal", n = 7) {
  I(e) == "array" && (e = Eo(e));
  const { min: o, max: r } = e, l = e.values.sort((s, i) => s - i);
  if (n === 1)
    return [o, r];
  const a = [];
  if (t.substr(0, 1) === "c" && (a.push(o), a.push(r)), t.substr(0, 1) === "e") {
    a.push(o);
    for (let s = 1; s < n; s++)
      a.push(o + s / n * (r - o));
    a.push(r);
  } else if (t.substr(0, 1) === "l") {
    if (o <= 0)
      throw new Error(
        "Logarithmic scales are only possible for values > 0"
      );
    const s = Math.LOG10E * Un(o), i = Math.LOG10E * Un(r);
    a.push(o);
    for (let c = 1; c < n; c++)
      a.push(Aa(10, s + c / n * (i - s)));
    a.push(r);
  } else if (t.substr(0, 1) === "q") {
    a.push(o);
    for (let s = 1; s < n; s++) {
      const i = (l.length - 1) * s / n, c = Ra(i);
      if (c === i)
        a.push(l[c]);
      else {
        const u = i - c;
        a.push(l[c] * (1 - u) + l[c + 1] * u);
      }
    }
    a.push(r);
  } else if (t.substr(0, 1) === "k") {
    let s;
    const i = l.length, c = new Array(i), u = new Array(n);
    let d = !0, f = 0, h = null;
    h = [], h.push(o);
    for (let p = 1; p < n; p++)
      h.push(o + p / n * (r - o));
    for (h.push(r); d; ) {
      for (let w = 0; w < n; w++)
        u[w] = 0;
      for (let w = 0; w < i; w++) {
        const _ = l[w];
        let v = Number.MAX_VALUE, M;
        for (let E = 0; E < n; E++) {
          const L = Da(h[E] - _);
          L < v && (v = L, M = E), u[M]++, c[w] = M;
        }
      }
      const p = new Array(n);
      for (let w = 0; w < n; w++)
        p[w] = null;
      for (let w = 0; w < i; w++)
        s = c[w], p[s] === null ? p[s] = l[w] : p[s] += l[w];
      for (let w = 0; w < n; w++)
        p[w] *= 1 / u[w];
      d = !1;
      for (let w = 0; w < n; w++)
        if (p[w] !== h[w]) {
          d = !0;
          break;
        }
      h = p, f++, f > 200 && (d = !1);
    }
    const b = {};
    for (let p = 0; p < n; p++)
      b[p] = [];
    for (let p = 0; p < i; p++)
      s = c[p], b[s].push(l[p]);
    let k = [];
    for (let p = 0; p < n; p++)
      k.push(b[p][0]), k.push(b[p][b[p].length - 1]);
    k = k.sort((p, w) => p - w), a.push(k[0]);
    for (let p = 1; p < k.length; p += 2) {
      const w = k[p];
      !isNaN(w) && a.indexOf(w) === -1 && a.push(w);
    }
  }
  return a;
}
const Ea = (e, t) => {
  e = new y(e), t = new y(t);
  const n = e.luminance(), o = t.luminance();
  return n > o ? (n + 0.05) / (o + 0.05) : (o + 0.05) / (n + 0.05);
};
/**
 * @license
 *
 * The APCA contrast prediction algorithm is based of the formulas published
 * in the APCA-1.0.98G specification by Myndex. The specification is available at:
 * https://raw.githubusercontent.com/Myndex/apca-w3/master/images/APCAw3_0.1.17_APCA0.0.98G.svg
 *
 * Note that the APCA implementation is still beta, so please update to
 * future versions of chroma.js when they become available.
 *
 * You can read more about the APCA Readability Criterion at
 * https://readtech.org/ARC/
 */
const Hn = 0.027, Ba = 5e-4, Ia = 0.1, Kn = 1.14, ft = 0.022, Xn = 1.414, ja = (e, t) => {
  e = new y(e), t = new y(t), e.alpha() < 1 && (e = Xe(t, e, e.alpha(), "rgb"));
  const n = Zn(...e.rgb()), o = Zn(...t.rgb()), r = n >= ft ? n : n + Math.pow(ft - n, Xn), l = o >= ft ? o : o + Math.pow(ft - o, Xn), a = Math.pow(l, 0.56) - Math.pow(r, 0.57), s = Math.pow(l, 0.65) - Math.pow(r, 0.62), i = Math.abs(l - r) < Ba ? 0 : r < l ? a * Kn : s * Kn;
  return (Math.abs(i) < Ia ? 0 : i > 0 ? i - Hn : i + Hn) * 100;
};
function Zn(e, t, n) {
  return 0.2126729 * Math.pow(e / 255, 2.4) + 0.7151522 * Math.pow(t / 255, 2.4) + 0.072175 * Math.pow(n / 255, 2.4);
}
const { sqrt: ge, pow: Z, min: Pa, max: Fa, atan2: xn, abs: Qn, cos: ht, sin: Jn, exp: za, PI: eo } = Math;
function qa(e, t, n = 1, o = 1, r = 1) {
  var l = function(Bt) {
    return 360 * Bt / (2 * eo);
  }, a = function(Bt) {
    return 2 * eo * Bt / 360;
  };
  e = new y(e), t = new y(t);
  const [s, i, c] = Array.from(e.lab()), [u, d, f] = Array.from(t.lab()), h = (s + u) / 2, b = ge(Z(i, 2) + Z(c, 2)), k = ge(Z(d, 2) + Z(f, 2)), p = (b + k) / 2, w = 0.5 * (1 - ge(Z(p, 7) / (Z(p, 7) + Z(25, 7)))), _ = i * (1 + w), v = d * (1 + w), M = ge(Z(_, 2) + Z(c, 2)), E = ge(Z(v, 2) + Z(f, 2)), L = (M + E) / 2, m = l(xn(c, _)), $ = l(xn(f, v)), O = m >= 0 ? m : m + 360, S = $ >= 0 ? $ : $ + 360, R = Qn(O - S) > 180 ? (O + S + 360) / 2 : (O + S) / 2, D = 1 - 0.17 * ht(a(R - 30)) + 0.24 * ht(a(2 * R)) + 0.32 * ht(a(3 * R + 6)) - 0.2 * ht(a(4 * R - 63));
  let H = S - O;
  H = Qn(H) <= 180 ? H : S <= O ? H + 360 : H - 360, H = 2 * ge(M * E) * Jn(a(H) / 2);
  const Ee = u - s, tt = E - M, ct = 1 + 0.015 * Z(h - 50, 2) / ge(20 + Z(h - 50, 2)), ut = 1 + 0.045 * L, qn = 1 + 0.015 * L * D, Ar = 30 * za(-Z((R - 275) / 25, 2)), Rr = -(2 * ge(Z(L, 7) / (Z(L, 7) + Z(25, 7)))) * Jn(2 * a(Ar)), Dr = ge(
    Z(Ee / (n * ct), 2) + Z(tt / (o * ut), 2) + Z(H / (r * qn), 2) + Rr * (tt / (o * ut)) * (H / (r * qn))
  );
  return Fa(0, Pa(100, Dr));
}
function Ga(e, t, n = "lab") {
  e = new y(e), t = new y(t);
  const o = e.get(n), r = t.get(n);
  let l = 0;
  for (let a in o) {
    const s = (o[a] || 0) - (r[a] || 0);
    l += s * s;
  }
  return Math.sqrt(l);
}
const Va = (...e) => {
  try {
    return new y(...e), !0;
  } catch {
    return !1;
  }
}, Ya = {
  cool() {
    return $t([j.hsl(180, 1, 0.9), j.hsl(250, 0.7, 0.4)]);
  },
  hot() {
    return $t(["#000", "#f00", "#ff0", "#fff"]).mode(
      "rgb"
    );
  }
}, an = {
  // sequential
  OrRd: ["#fff7ec", "#fee8c8", "#fdd49e", "#fdbb84", "#fc8d59", "#ef6548", "#d7301f", "#b30000", "#7f0000"],
  PuBu: ["#fff7fb", "#ece7f2", "#d0d1e6", "#a6bddb", "#74a9cf", "#3690c0", "#0570b0", "#045a8d", "#023858"],
  BuPu: ["#f7fcfd", "#e0ecf4", "#bfd3e6", "#9ebcda", "#8c96c6", "#8c6bb1", "#88419d", "#810f7c", "#4d004b"],
  Oranges: ["#fff5eb", "#fee6ce", "#fdd0a2", "#fdae6b", "#fd8d3c", "#f16913", "#d94801", "#a63603", "#7f2704"],
  BuGn: ["#f7fcfd", "#e5f5f9", "#ccece6", "#99d8c9", "#66c2a4", "#41ae76", "#238b45", "#006d2c", "#00441b"],
  YlOrBr: ["#ffffe5", "#fff7bc", "#fee391", "#fec44f", "#fe9929", "#ec7014", "#cc4c02", "#993404", "#662506"],
  YlGn: ["#ffffe5", "#f7fcb9", "#d9f0a3", "#addd8e", "#78c679", "#41ab5d", "#238443", "#006837", "#004529"],
  Reds: ["#fff5f0", "#fee0d2", "#fcbba1", "#fc9272", "#fb6a4a", "#ef3b2c", "#cb181d", "#a50f15", "#67000d"],
  RdPu: ["#fff7f3", "#fde0dd", "#fcc5c0", "#fa9fb5", "#f768a1", "#dd3497", "#ae017e", "#7a0177", "#49006a"],
  Greens: ["#f7fcf5", "#e5f5e0", "#c7e9c0", "#a1d99b", "#74c476", "#41ab5d", "#238b45", "#006d2c", "#00441b"],
  YlGnBu: ["#ffffd9", "#edf8b1", "#c7e9b4", "#7fcdbb", "#41b6c4", "#1d91c0", "#225ea8", "#253494", "#081d58"],
  Purples: ["#fcfbfd", "#efedf5", "#dadaeb", "#bcbddc", "#9e9ac8", "#807dba", "#6a51a3", "#54278f", "#3f007d"],
  GnBu: ["#f7fcf0", "#e0f3db", "#ccebc5", "#a8ddb5", "#7bccc4", "#4eb3d3", "#2b8cbe", "#0868ac", "#084081"],
  Greys: ["#ffffff", "#f0f0f0", "#d9d9d9", "#bdbdbd", "#969696", "#737373", "#525252", "#252525", "#000000"],
  YlOrRd: ["#ffffcc", "#ffeda0", "#fed976", "#feb24c", "#fd8d3c", "#fc4e2a", "#e31a1c", "#bd0026", "#800026"],
  PuRd: ["#f7f4f9", "#e7e1ef", "#d4b9da", "#c994c7", "#df65b0", "#e7298a", "#ce1256", "#980043", "#67001f"],
  Blues: ["#f7fbff", "#deebf7", "#c6dbef", "#9ecae1", "#6baed6", "#4292c6", "#2171b5", "#08519c", "#08306b"],
  PuBuGn: ["#fff7fb", "#ece2f0", "#d0d1e6", "#a6bddb", "#67a9cf", "#3690c0", "#02818a", "#016c59", "#014636"],
  Viridis: ["#440154", "#482777", "#3f4a8a", "#31678e", "#26838f", "#1f9d8a", "#6cce5a", "#b6de2b", "#fee825"],
  // diverging
  Spectral: ["#9e0142", "#d53e4f", "#f46d43", "#fdae61", "#fee08b", "#ffffbf", "#e6f598", "#abdda4", "#66c2a5", "#3288bd", "#5e4fa2"],
  RdYlGn: ["#a50026", "#d73027", "#f46d43", "#fdae61", "#fee08b", "#ffffbf", "#d9ef8b", "#a6d96a", "#66bd63", "#1a9850", "#006837"],
  RdBu: ["#67001f", "#b2182b", "#d6604d", "#f4a582", "#fddbc7", "#f7f7f7", "#d1e5f0", "#92c5de", "#4393c3", "#2166ac", "#053061"],
  PiYG: ["#8e0152", "#c51b7d", "#de77ae", "#f1b6da", "#fde0ef", "#f7f7f7", "#e6f5d0", "#b8e186", "#7fbc41", "#4d9221", "#276419"],
  PRGn: ["#40004b", "#762a83", "#9970ab", "#c2a5cf", "#e7d4e8", "#f7f7f7", "#d9f0d3", "#a6dba0", "#5aae61", "#1b7837", "#00441b"],
  RdYlBu: ["#a50026", "#d73027", "#f46d43", "#fdae61", "#fee090", "#ffffbf", "#e0f3f8", "#abd9e9", "#74add1", "#4575b4", "#313695"],
  BrBG: ["#543005", "#8c510a", "#bf812d", "#dfc27d", "#f6e8c3", "#f5f5f5", "#c7eae5", "#80cdc1", "#35978f", "#01665e", "#003c30"],
  RdGy: ["#67001f", "#b2182b", "#d6604d", "#f4a582", "#fddbc7", "#ffffff", "#e0e0e0", "#bababa", "#878787", "#4d4d4d", "#1a1a1a"],
  PuOr: ["#7f3b08", "#b35806", "#e08214", "#fdb863", "#fee0b6", "#f7f7f7", "#d8daeb", "#b2abd2", "#8073ac", "#542788", "#2d004b"],
  // qualitative
  Set2: ["#66c2a5", "#fc8d62", "#8da0cb", "#e78ac3", "#a6d854", "#ffd92f", "#e5c494", "#b3b3b3"],
  Accent: ["#7fc97f", "#beaed4", "#fdc086", "#ffff99", "#386cb0", "#f0027f", "#bf5b17", "#666666"],
  Set1: ["#e41a1c", "#377eb8", "#4daf4a", "#984ea3", "#ff7f00", "#ffff33", "#a65628", "#f781bf", "#999999"],
  Set3: ["#8dd3c7", "#ffffb3", "#bebada", "#fb8072", "#80b1d3", "#fdb462", "#b3de69", "#fccde5", "#d9d9d9", "#bc80bd", "#ccebc5", "#ffed6f"],
  Dark2: ["#1b9e77", "#d95f02", "#7570b3", "#e7298a", "#66a61e", "#e6ab02", "#a6761d", "#666666"],
  Paired: ["#a6cee3", "#1f78b4", "#b2df8a", "#33a02c", "#fb9a99", "#e31a1c", "#fdbf6f", "#ff7f00", "#cab2d6", "#6a3d9a", "#ffff99", "#b15928"],
  Pastel2: ["#b3e2cd", "#fdcdac", "#cbd5e8", "#f4cae4", "#e6f5c9", "#fff2ae", "#f1e2cc", "#cccccc"],
  Pastel1: ["#fbb4ae", "#b3cde3", "#ccebc5", "#decbe4", "#fed9a6", "#ffffcc", "#e5d8bd", "#fddaec", "#f2f2f2"]
}, Io = Object.keys(an), to = new Map(Io.map((e) => [e.toLowerCase(), e])), Wa = typeof Proxy == "function" ? new Proxy(an, {
  get(e, t) {
    const n = t.toLowerCase();
    if (to.has(n))
      return e[to.get(n)];
  },
  getOwnPropertyNames() {
    return Object.getOwnPropertyNames(Io);
  }
}) : an, Ua = (...e) => {
  e = A(e, "cmyk");
  const [t, n, o, r] = e, l = e.length > 4 ? e[4] : 1;
  return r === 1 ? [0, 0, 0, l] : [
    t >= 1 ? 0 : 255 * (1 - t) * (1 - r),
    // r
    n >= 1 ? 0 : 255 * (1 - n) * (1 - r),
    // g
    o >= 1 ? 0 : 255 * (1 - o) * (1 - r),
    // b
    l
  ];
}, { max: no } = Math, Ha = (...e) => {
  let [t, n, o] = A(e, "rgb");
  t = t / 255, n = n / 255, o = o / 255;
  const r = 1 - no(t, no(n, o)), l = r < 1 ? 1 / (1 - r) : 0, a = (1 - t - r) * l, s = (1 - n - r) * l, i = (1 - o - r) * l;
  return [a, s, i, r];
};
y.prototype.cmyk = function() {
  return Ha(this._rgb);
};
const Ka = (...e) => new y(...e, "cmyk");
Object.assign(j, { cmyk: Ka });
N.format.cmyk = Ua;
N.autodetect.push({
  p: 2,
  test: (...e) => {
    if (e = A(e, "cmyk"), I(e) === "array" && e.length === 4)
      return "cmyk";
  }
});
const Xa = (...e) => {
  const t = A(e, "hsla");
  let n = Ze(e) || "lsa";
  return t[0] = ce(t[0] || 0) + "deg", t[1] = ce(t[1] * 100) + "%", t[2] = ce(t[2] * 100) + "%", n === "hsla" || t.length > 3 && t[3] < 1 ? (t[3] = "/ " + (t.length > 3 ? t[3] : 1), n = "hsla") : t.length = 3, `${n.substr(0, 3)}(${t.join(" ")})`;
}, Za = (...e) => {
  const t = A(e, "lab");
  let n = Ze(e) || "lab";
  return t[0] = ce(t[0]) + "%", t[1] = ce(t[1]), t[2] = ce(t[2]), n === "laba" || t.length > 3 && t[3] < 1 ? t[3] = "/ " + (t.length > 3 ? t[3] : 1) : t.length = 3, `lab(${t.join(" ")})`;
}, xa = (...e) => {
  const t = A(e, "lch");
  let n = Ze(e) || "lab";
  return t[0] = ce(t[0]) + "%", t[1] = ce(t[1]), t[2] = isNaN(t[2]) ? "none" : ce(t[2]) + "deg", n === "lcha" || t.length > 3 && t[3] < 1 ? t[3] = "/ " + (t.length > 3 ? t[3] : 1) : t.length = 3, `lch(${t.join(" ")})`;
}, Qa = (...e) => {
  const t = A(e, "lab");
  return t[0] = ce(t[0] * 100) + "%", t[1] = rn(t[1]), t[2] = rn(t[2]), t.length > 3 && t[3] < 1 ? t[3] = "/ " + (t.length > 3 ? t[3] : 1) : t.length = 3, `oklab(${t.join(" ")})`;
}, jo = (...e) => {
  const [t, n, o, ...r] = A(e, "rgb"), [l, a, s] = Nn(t, n, o), [i, c, u] = No(l, a, s);
  return [i, c, u, ...r.length > 0 && r[0] < 1 ? [r[0]] : []];
}, Ja = (...e) => {
  const t = A(e, "lch");
  return t[0] = ce(t[0] * 100) + "%", t[1] = rn(t[1]), t[2] = isNaN(t[2]) ? "none" : ce(t[2]) + "deg", t.length > 3 && t[3] < 1 ? t[3] = "/ " + (t.length > 3 ? t[3] : 1) : t.length = 3, `oklch(${t.join(" ")})`;
}, { round: Wt } = Math, es = (...e) => {
  const t = A(e, "rgba");
  let n = Ze(e) || "rgb";
  if (n.substr(0, 3) === "hsl")
    return Xa(Ro(t), n);
  if (n.substr(0, 3) === "lab") {
    const o = lt();
    we("d50");
    const r = Za(On(t), n);
    return we(o), r;
  }
  if (n.substr(0, 3) === "lch") {
    const o = lt();
    we("d50");
    const r = xa(Ln(t), n);
    return we(o), r;
  }
  return n.substr(0, 5) === "oklab" ? Qa(Nn(t)) : n.substr(0, 5) === "oklch" ? Ja(jo(t)) : (t[0] = Wt(t[0]), t[1] = Wt(t[1]), t[2] = Wt(t[2]), (n === "rgba" || t.length > 3 && t[3] < 1) && (t[3] = "/ " + (t.length > 3 ? t[3] : 1), n = "rgba"), `${n.substr(0, 3)}(${t.slice(0, n === "rgb" ? 3 : 4).join(" ")})`);
}, Po = (...e) => {
  e = A(e, "lch");
  const [t, n, o, ...r] = e, [l, a, s] = To(t, n, o), [i, c, u] = Tn(l, a, s);
  return [i, c, u, ...r.length > 0 && r[0] < 1 ? [r[0]] : []];
}, ke = /((?:-?\d+)|(?:-?\d+(?:\.\d+)?)%|none)/.source, fe = /((?:-?(?:\d+(?:\.\d*)?|\.\d+)%?)|none)/.source, St = /((?:-?(?:\d+(?:\.\d*)?|\.\d+)%)|none)/.source, ue = /\s*/.source, Qe = /\s+/.source, An = /\s*,\s*/.source, At = /((?:-?(?:\d+(?:\.\d*)?|\.\d+)(?:deg)?)|none)/.source, Je = /\s*(?:\/\s*((?:[01]|[01]?\.\d+)|\d+(?:\.\d+)?%))?/.source, Fo = new RegExp(
  "^rgba?\\(" + ue + [ke, ke, ke].join(Qe) + Je + "\\)$"
), zo = new RegExp(
  "^rgb\\(" + ue + [ke, ke, ke].join(An) + ue + "\\)$"
), qo = new RegExp(
  "^rgba\\(" + ue + [ke, ke, ke, fe].join(An) + ue + "\\)$"
), Go = new RegExp(
  "^hsla?\\(" + ue + [At, St, St].join(Qe) + Je + "\\)$"
), Vo = new RegExp(
  "^hsl?\\(" + ue + [At, St, St].join(An) + ue + "\\)$"
), Yo = /^hsla\(\s*(-?\d+(?:\.\d+)?),\s*(-?\d+(?:\.\d+)?)%\s*,\s*(-?\d+(?:\.\d+)?)%\s*,\s*([01]|[01]?\.\d+)\)$/, Wo = new RegExp(
  "^lab\\(" + ue + [fe, fe, fe].join(Qe) + Je + "\\)$"
), Uo = new RegExp(
  "^lch\\(" + ue + [fe, fe, At].join(Qe) + Je + "\\)$"
), Ho = new RegExp(
  "^oklab\\(" + ue + [fe, fe, fe].join(Qe) + Je + "\\)$"
), Ko = new RegExp(
  "^oklch\\(" + ue + [fe, fe, At].join(Qe) + Je + "\\)$"
), { round: Xo } = Math, Ve = (e) => e.map((t, n) => n <= 2 ? je(Xo(t), 0, 255) : t), x = (e, t = 0, n = 100, o = !1) => (typeof e == "string" && e.endsWith("%") && (e = parseFloat(e.substring(0, e.length - 1)) / 100, o ? e = t + (e + 1) * 0.5 * (n - t) : e = t + e * (n - t)), +e), te = (e, t) => e === "none" ? t : e, Rn = (e) => {
  if (e = e.toLowerCase().trim(), e === "transparent")
    return [0, 0, 0, 0];
  let t;
  if (N.format.named)
    try {
      return N.format.named(e);
    } catch {
    }
  if ((t = e.match(Fo)) || (t = e.match(zo))) {
    let n = t.slice(1, 4);
    for (let r = 0; r < 3; r++)
      n[r] = +x(te(n[r], 0), 0, 255);
    n = Ve(n);
    const o = t[4] !== void 0 ? +x(t[4], 0, 1) : 1;
    return n[3] = o, n;
  }
  if (t = e.match(qo)) {
    const n = t.slice(1, 5);
    for (let o = 0; o < 4; o++)
      n[o] = +x(n[o], 0, 255);
    return n;
  }
  if ((t = e.match(Go)) || (t = e.match(Vo))) {
    const n = t.slice(1, 4);
    n[0] = +te(n[0].replace("deg", ""), 0), n[1] = +x(te(n[1], 0), 0, 100) * 0.01, n[2] = +x(te(n[2], 0), 0, 100) * 0.01;
    const o = Ve(ln(n)), r = t[4] !== void 0 ? +x(t[4], 0, 1) : 1;
    return o[3] = r, o;
  }
  if (t = e.match(Yo)) {
    const n = t.slice(1, 4);
    n[1] *= 0.01, n[2] *= 0.01;
    const o = ln(n);
    for (let r = 0; r < 3; r++)
      o[r] = Xo(o[r]);
    return o[3] = +t[4], o;
  }
  if (t = e.match(Wo)) {
    const n = t.slice(1, 4);
    n[0] = x(te(n[0], 0), 0, 100), n[1] = x(te(n[1], 0), -125, 125, !0), n[2] = x(te(n[2], 0), -125, 125, !0);
    const o = lt();
    we("d50");
    const r = Ve(Mn(n));
    we(o);
    const l = t[4] !== void 0 ? +x(t[4], 0, 1) : 1;
    return r[3] = l, r;
  }
  if (t = e.match(Uo)) {
    const n = t.slice(1, 4);
    n[0] = x(n[0], 0, 100), n[1] = x(te(n[1], 0), 0, 150, !1), n[2] = +te(n[2].replace("deg", ""), 0);
    const o = lt();
    we("d50");
    const r = Ve(_n(n));
    we(o);
    const l = t[4] !== void 0 ? +x(t[4], 0, 1) : 1;
    return r[3] = l, r;
  }
  if (t = e.match(Ho)) {
    const n = t.slice(1, 4);
    n[0] = x(te(n[0], 0), 0, 1), n[1] = x(te(n[1], 0), -0.4, 0.4, !0), n[2] = x(te(n[2], 0), -0.4, 0.4, !0);
    const o = Ve(Tn(n)), r = t[4] !== void 0 ? +x(t[4], 0, 1) : 1;
    return o[3] = r, o;
  }
  if (t = e.match(Ko)) {
    const n = t.slice(1, 4);
    n[0] = x(te(n[0], 0), 0, 1), n[1] = x(te(n[1], 0), 0, 0.4, !1), n[2] = +te(n[2].replace("deg", ""), 0);
    const o = Ve(Po(n)), r = t[4] !== void 0 ? +x(t[4], 0, 1) : 1;
    return o[3] = r, o;
  }
};
Rn.test = (e) => (
  // modern
  Fo.test(e) || Go.test(e) || Wo.test(e) || Uo.test(e) || Ho.test(e) || Ko.test(e) || // legacy
  zo.test(e) || qo.test(e) || Vo.test(e) || Yo.test(e) || e === "transparent"
);
y.prototype.css = function(e) {
  return es(this._rgb, e);
};
const ts = (...e) => new y(...e, "css");
j.css = ts;
N.format.css = Rn;
N.autodetect.push({
  p: 5,
  test: (e, ...t) => {
    if (!t.length && I(e) === "string" && Rn.test(e))
      return "css";
  }
});
N.format.gl = (...e) => {
  const t = A(e, "rgba");
  return t[0] *= 255, t[1] *= 255, t[2] *= 255, t;
};
const ns = (...e) => new y(...e, "gl");
j.gl = ns;
y.prototype.gl = function() {
  const e = this._rgb;
  return [e[0] / 255, e[1] / 255, e[2] / 255, e[3]];
};
y.prototype.hex = function(e) {
  return Oo(this._rgb, e);
};
const os = (...e) => new y(...e, "hex");
j.hex = os;
N.format.hex = Mo;
N.autodetect.push({
  p: 4,
  test: (e, ...t) => {
    if (!t.length && I(e) === "string" && [3, 4, 5, 6, 7, 8, 9].indexOf(e.length) >= 0)
      return "hex";
  }
});
const { log: pt } = Math, Zo = (e) => {
  const t = e / 100;
  let n, o, r;
  return t < 66 ? (n = 255, o = t < 6 ? 0 : -155.25485562709179 - 0.44596950469579133 * (o = t - 2) + 104.49216199393888 * pt(o), r = t < 20 ? 0 : -254.76935184120902 + 0.8274096064007395 * (r = t - 10) + 115.67994401066147 * pt(r)) : (n = 351.97690566805693 + 0.114206453784165 * (n = t - 55) - 40.25366309332127 * pt(n), o = 325.4494125711974 + 0.07943456536662342 * (o = t - 50) - 28.0852963507957 * pt(o), r = 255), [n, o, r, 1];
}, { round: rs } = Math, ls = (...e) => {
  const t = A(e, "rgb"), n = t[0], o = t[2];
  let r = 1e3, l = 4e4;
  const a = 0.4;
  let s;
  for (; l - r > a; ) {
    s = (l + r) * 0.5;
    const i = Zo(s);
    i[2] / i[0] >= o / n ? l = s : r = s;
  }
  return rs(s);
};
y.prototype.temp = y.prototype.kelvin = y.prototype.temperature = function() {
  return ls(this._rgb);
};
const Ut = (...e) => new y(...e, "temp");
Object.assign(j, { temp: Ut, kelvin: Ut, temperature: Ut });
N.format.temp = N.format.kelvin = N.format.temperature = Zo;
y.prototype.oklch = function() {
  return jo(this._rgb);
};
const as = (...e) => new y(...e, "oklch");
Object.assign(j, { oklch: as });
N.format.oklch = Po;
N.autodetect.push({
  p: 2,
  test: (...e) => {
    if (e = A(e, "oklch"), I(e) === "array" && e.length === 3)
      return "oklch";
  }
});
Object.assign(j, {
  analyze: Eo,
  average: sa,
  bezier: ha,
  blend: he,
  brewer: Wa,
  Color: y,
  colors: Ke,
  contrast: Ea,
  contrastAPCA: ja,
  cubehelix: Oa,
  deltaE: qa,
  distance: Ga,
  input: N,
  interpolate: Xe,
  limits: Bo,
  mix: Xe,
  random: Na,
  scale: $t,
  scales: Ya,
  valid: Va
});
const Ce = (e) => [
  ...Array.from({ length: 5 }).map(
    (t, n) => j.scale([e, "#fff"])((n + 5) / 10).hex()
  ).toReversed(),
  ...Array.from({ length: 5 }).map(
    (t, n) => j.scale([e, "#000"])(n / 10).hex()
  )
], Rt = (e, t) => {
  document.querySelector("html").style.cssText += [
    `--${$e}-${t}: ${e[5]};`,
    ...e.reduce(
      (n, o, r) => [...n, `--${$e}-${t}-${r + 1}: ${o};`],
      []
    )
  ].join("");
}, xo = (e = qr) => {
  Rt(Ce(e), "primary");
}, Qo = (e = Gr) => {
  Rt(Ce(e), "success");
}, Jo = (e = Vr) => {
  Rt(Ce(e), "warning");
}, er = (e = Yr) => {
  Rt(Ce(e), "error");
}, ss = (e) => {
  xo(e == null ? void 0 : e.primary), Qo(e == null ? void 0 : e.success), Jo(e == null ? void 0 : e.warning), er(e == null ? void 0 : e.error);
}, Wd = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  generateColors: Ce,
  generateErrorColors: er,
  generatePrimaryColors: xo,
  generateSuccessColors: Qo,
  generateWarningColors: Jo,
  initColors: ss
}, Symbol.toStringTag, { value: "Module" })), tr = (e) => `${e}-${Oe(6)}`, Mt = (e, t, n) => {
  if (Array.isArray(t) && Array.isArray(e)) {
    for (let o = 0; o < t.length; o++)
      if (!Mt(e[o], t[o])) return !1;
  }
  if (me(t) && me(e))
    for (const [o, r] of Object.entries(t)) {
      if ((me(r) || Array.isArray(r)) && !Mt(r, e[o]))
        return !1;
      if (n === o) return r === e[o];
    }
  return e === t;
}, is = {
  /**
   * 网格列数
   * 类型为 string 时，可传入 gridTemplateColumns
   */
  columns: {
    type: [Number, String],
    required: !0
  },
  /**
   * 显示定义网格每行高度
   */
  rows: {
    type: String,
    default: ""
  },
  /**
   * 间隙
   */
  gap: {
    type: [Number, String],
    default: 0
  },
  /**
   * 行间距
   */
  rowGap: {
    type: [Number, String],
    default: void 0
  },
  /**
   * 列间距
   */
  columnGap: {
    type: [Number, String],
    default: void 0
  },
  /**
   * 水平对齐方式
   */
  justify: {
    type: String,
    default: "normal"
  },
  /**
   * 垂直对齐方式
   */
  align: {
    type: String,
    default: "normal"
  }
}, cs = {
  /**
   * 占用行数
   */
  row: {
    type: [Number, String],
    default: 1
  },
  /**
   * 占用列数
   */
  column: {
    type: [Number, String],
    default: 1
  },
  height: {
    type: [Number, String],
    default: void 0
  },
  /**
   * 水平排列对齐方式
   */
  justify: {
    type: String,
    default: void 0
  },
  /**
   * 垂直排列对齐方式
   */
  align: {
    type: String,
    default: void 0
  }
}, Q = (e, t) => {
  const n = e.__vccOpts || e;
  for (const [o, r] of t)
    n[o] = r;
  return n;
}, [us, ds] = V("grid"), fs = G({
  name: us,
  props: is,
  setup(e) {
    const t = ds(), n = q(() => {
      const o = {
        left: "start",
        center: "center",
        right: "end"
      }, r = {
        top: "start",
        middle: "center",
        bottom: "end"
      }, l = {
        gridTemplateRows: e.rows,
        gridTemplateColumns: typeof e.columns == "number" ? `repeat(${e.columns}, 1fr)` : e.columns,
        gap: K(e.gap),
        justifyItems: o[e.justify],
        alignContent: r[e.align]
      };
      return ie(e.rowGap) || Object.assign(l, {
        rowGap: K(e.rowGap)
      }), ie(e.columnGap) || Object.assign(l, {
        columnGap: K(e.columnGap)
      }), l;
    });
    return {
      wrapperClassName: t,
      gridStyle: n
    };
  }
});
function hs(e, t, n, o, r, l) {
  return C(), T("div", {
    class: B(e.wrapperClassName),
    style: _e(e.gridStyle)
  }, [
    ne(e.$slots, "default")
  ], 6);
}
const ps = /* @__PURE__ */ Q(fs, [["render", hs]]), [ms, bs] = V("grid-item"), gs = G({
  name: ms,
  props: cs,
  setup(e) {
    const t = bs(), n = q(() => ({
      gridRow: `span ${e.row} / span ${e.row}`,
      gridColumn: `span ${e.column} / span 1`,
      height: K(e.height),
      alignSelf: e.align,
      justifySelf: e.justify
    }));
    return {
      className: t,
      style: n
    };
  }
});
function ys(e, t, n, o, r, l) {
  return C(), T("div", {
    class: B(e.className),
    style: _e(e.style)
  }, [
    ne(e.$slots, "default")
  ], 6);
}
const vs = /* @__PURE__ */ Q(gs, [["render", ys]]), Dn = Y(ps), et = Y(vs), ws = {
  visible: {
    type: Boolean,
    default: !1
  },
  /**
   * 消息内容
   */
  content: String,
  /**
   * 自定义消息图标
   */
  icon: {
    type: Object,
    default: void 0
  },
  /**
   * 消息提示类型
   */
  type: {
    type: String,
    default: "text"
  },
  /**
   * 消息主题
   */
  theme: {
    type: String,
    default: ""
  },
  /**
   * 是否显示关闭图标
   */
  closable: {
    type: Boolean,
    default: !1
  },
  /**
   * 消息提示时间，单位毫秒
   */
  duration: {
    type: Number,
    default: 2e3
  },
  teleport: {
    type: [String, Object],
    default: "body"
  },
  /**
   * 提示框关闭完成事件
   */
  onClosed: {
    type: Function,
    default: void 0
  }
};
function Dt(e, t, n, o) {
  const r = X(), l = n && e[n] !== void 0;
  po(() => {
    l ? r.value = e[n] : r.value = e.modelValue;
  });
  function a(c) {
    r.value = c;
  }
  function s(c, u = !1) {
    l ? t(o, c) : t("update:model-value", c, u);
  }
  return [q({
    get() {
      return r.value;
    },
    set(c) {
      a(c);
    }
  }), s];
}
let Ht = 2e3;
function nr(e, t = !0) {
  const n = e.zIndex ?? Ht, o = X(n);
  function r() {
    Ht = o.value ? o.value + 1 : Ht + 1;
  }
  return t && r(), [o, r];
}
function Ud(e, t, n) {
  const o = ae(
    () => e,
    (r) => {
      Ir(() => o()), t(r);
    },
    n
  );
}
const Kt = [], Xt = /* @__PURE__ */ new Map();
let oo = 0;
const or = (e, t) => {
  const { type: n, closeOnEsc: o, closeFN: r } = t, l = `${n}@${oo}`;
  Xt.set(l, r), oo++;
  const a = (s) => {
    var i;
    if (s.keyCode === 27 || s.code === "Escape") {
      const [c] = [...Kt].reverse();
      c === l && ((i = Xt.get(l)) == null || i());
    }
  };
  bn(() => {
    Xt.delete(l);
  }), ae(
    () => e.value,
    (s) => {
      o && (s ? (Kt.push(l), document.addEventListener("keydown", a)) : (Kt.pop(), document.removeEventListener("keydown", a)));
    }
  );
}, Re = {
  className: {
    type: [String, Array, Object],
    default: void 0
  },
  /**
   * 明细表行 id
   */
  rowId: {
    type: String,
    default: void 0
  },
  /**
   * 表单中使用时，代表当前组件配置模型
   */
  model: {
    type: Object,
    default: void 0
  },
  /**
   * 禁用状态
   */
  disabled: {
    type: Boolean,
    default: !1
  },
  /**
   * 只读状态
   */
  readonly: {
    type: Boolean,
    default: !1
  },
  /**
   * 自定义 key
   */
  keys: {
    type: Object,
    default: void 0
  },
  /**
   * 锁定 body 滚动
   * @default true
   */
  lockScroll: {
    type: Boolean,
    default: !0
  },
  /**
   * 需要将元素插入到那个位置
   */
  teleport: {
    type: [String, Object],
    default: "body"
  },
  /**
   * 是否开启懒加载渲染，默认开启
   */
  lazyRender: {
    type: Boolean,
    default: !0
  },
  /**
   * 必填标识位置
   */
  requiredMarkPosition: String,
  /**
   * 表单宽度
   */
  labelWidth: [Number, String],
  /**
   * 终端类型
   */
  clientType: String,
  /**
   * 边框显示
   */
  border: {
    type: Boolean,
    default: void 0
  },
  /**
   * 显示圆角
   */
  round: {
    type: Boolean,
    default: void 0
  },
  /**
   * 分隔符
   * 常用于多个值合并显示进行分割
   */
  separator: {
    type: String,
    default: void 0
  },
  /**
   * 是否按下 esc 关闭对话框
   */
  closeOnEsc: {
    type: Boolean,
    default: void 0
  },
  /**
   * 排列方式，水平、垂直
   */
  direction: {
    type: String,
    default: void 0
  },
  /**
   * id 生成器
   */
  idGenerator: {
    type: Function,
    default: void 0
  },
  /**
   * 表单组件标题自定义渲染
   */
  renderFormLabel: {
    type: Function,
    default: void 0
  },
  /**
   * 使用自定义描述
   */
  useCustomDescription: {
    type: Boolean,
    default: void 0
  },
  /**
   * 全局自定义渲染单元格标题
   */
  renderCellTitle: {
    type: Function,
    default: void 0
  }
}, Cs = {
  ...Te(Re, [
    "keys",
    "clientType",
    "labelWidth",
    "border",
    "round",
    "separator",
    "closeOnEsc",
    "direction",
    "idGenerator",
    "renderFormLabel",
    "useCustomDescription",
    "renderCellTitle",
    "requiredMarkPosition"
  ]),
  /**
   * 是否需要创建真实 DOM
   */
  createNode: {
    type: Boolean,
    default: !0
  },
  /**
   * 标题布局类型
   */
  layout: {
    type: String,
    default: "horizontal"
  },
  /**
   * 是否显示冒号
   */
  colon: {
    type: Boolean,
    default: !1
  },
  /**
   * 主题颜色
   */
  theme: {
    type: Object,
    default: void 0
  },
  /**
   * 是否为顶级组件
   */
  isRoot: {
    type: Boolean,
    default: !1
  },
  /**
   * 高度是否撑满
   */
  fullHeight: {
    type: Boolean,
    default: !0
  }
}, En = Symbol("ConfigProvider"), mt = (e, t) => ({
  [`--${$e}-${t}`]: e[5],
  ...e.reduce(
    (n, o, r) => ({
      ...n,
      [`--${$e}-${t}-${r + 1}`]: o
    }),
    {}
  )
}), ks = (e) => q(() => {
  var n, o, r, l;
  const t = {};
  return (n = e.theme) != null && n.primary && Object.assign(t, mt(Ce(e.theme.primary), "primary")), (o = e.theme) != null && o.success && Object.assign(t, mt(Ce(e.theme.success), "success")), (r = e.theme) != null && r.warning && Object.assign(t, mt(Ce(e.theme.warning), "warning")), (l = e.theme) != null && l.error && Object.assign(t, mt(Ce(e.theme.error), "error")), t;
}), [$s, Ss] = V("config-provider"), Ms = G({
  name: $s,
  props: Cs,
  setup(e, t) {
    const n = ze(["renderFormLabel", "useCustomDescription", "renderCellTitle", "requiredMarkPosition"], e);
    return at(En, q(() => ({
      ...e,
      renderFormLabel: n.value.renderFormLabel,
      useCustomDescription: n.value.useCustomDescription,
      renderCellTitle: n.value.renderCellTitle,
      requiredMarkPosition: n.value.requiredMarkPosition
    }))), e.createNode ? () => {
      var l, a;
      const o = ks(e), r = {
        height: e.fullHeight ? "100%" : void 0
      };
      if (e.isRoot) {
        const s = document.querySelector("html"), i = [];
        if (s) {
          for (const [c, u] of Object.entries(o.value))
            i.push(`${c}: ${u};`);
          s.style.cssText += i.join("");
        }
      } else
        Object.assign(r, o.value);
      return g("div", {
        class: Ss(),
        style: r
      }, [(a = (l = t.slots).default) == null ? void 0 : a.call(l)]);
    } : () => {
      var o, r;
      return (r = (o = t.slots).default) == null ? void 0 : r.call(o);
    };
  }
}), Os = Y(Ms), Zt = {
  keys: {
    label: "label",
    value: "value",
    children: "children"
  },
  requiredMarkPosition: yo,
  clientType: "MOBILE",
  layout: "horizontal",
  round: !0,
  separator: Zr,
  closeOnEsc: !0,
  direction: "horizontal",
  idGenerator: Oe
};
function ze(e, t) {
  const n = Fe(
    En,
    q(() => Zt)
  );
  return q(
    () => e.reduce((o, r) => r === "keys" ? {
      ...o,
      keys: {
        ...Zt.keys,
        ...n.value.keys,
        ...t.keys
      }
    } : {
      ...o,
      [r]: ie(t == null ? void 0 : t[r]) ? n.value[r] ?? Zt[r] : t == null ? void 0 : t[r]
    }, {})
  );
}
const _s = "d";
function sn(e, t) {
  return t ? typeof t == "string" ? ` ${e}--${t} ` : Array.isArray(t) ? t.reduce((n, o) => n + sn(e, o), "") : Object.keys(t).reduce(
    (n, o) => n + (t[o] ? sn(e, o) : ""),
    ""
  ) : "";
}
function Ls(e) {
  return (t, n) => (t && typeof t != "string" && (n = t, t = ""), t = t ? `${e}__${t}` : e, `${t}${sn(t, n)}`);
}
function Ts(e) {
  const t = `${_s}-${e}`;
  return [t, Ls(t)];
}
const Ns = {
  color: {
    type: String,
    default: "inherit"
  },
  size: {
    type: String,
    default: "medium"
  },
  class: {
    type: String,
    default: ""
  },
  className: {
    type: String,
    default: ""
  },
  spin: {
    type: Boolean,
    default: !1
  },
  rotate: {
    type: Number,
    default: 0
  },
  onClick: {
    type: Function
  }
}, [As, Rs] = Ts("icon"), Ds = G({
  name: As,
  props: Ns,
  emits: ["click"],
  setup(e, {
    emit: t,
    attrs: n,
    slots: o
  }) {
    return () => {
      var r, l;
      const {
        color: a,
        size: s,
        spin: i,
        className: c,
        rotate: u
      } = e, d = [Rs({
        [s]: s,
        spin: i
      }), c, e.class, n == null ? void 0 : n.class].join(""), f = !["small", "medium", "large"].includes(s), h = {
        width: f ? s : void 0,
        height: f ? s : void 0,
        color: a,
        transform: `rotate(${u}deg)`
      };
      function b(p) {
        t("click", p);
      }
      const k = (l = (r = o.default) == null ? void 0 : r.call(o)) == null ? void 0 : l.map((p) => ({
        ...p,
        props: {
          ...p.props,
          style: h
        }
      }));
      return g("span", {
        class: d,
        onClick: b
      }, [k]);
    };
  }
});
var Es = function(e) {
  return e.replace(/(-\w)/g, function(t) {
    return t.substring(1, 2).toUpperCase();
  }).replace(/^(\w)/, function(t) {
    return t.toUpperCase();
  });
};
function Bs(e) {
  return e.install = (t) => {
    const { name: n } = e;
    t.component(n, e), t.component(Es(n), e);
  }, e;
}
const de = Bs(Ds), Is = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, js = /* @__PURE__ */ U("g", {
  fill: "none",
  "fill-rule": "evenodd",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.5"
}, [
  /* @__PURE__ */ U("path", { d: "m6 6 12 12M6 18 18 6" })
], -1), Ps = [
  js
];
function Fs(e, t) {
  return C(), T("svg", Is, [...Ps]);
}
const zs = { render: Fs }, rr = (e) => g(de, e, {
  default: () => [g(zs, null, null)]
}), qs = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, Gs = /* @__PURE__ */ U("path", {
  fill: "none",
  "fill-rule": "evenodd",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.5",
  d: "m9 19 6.5-6.5L9 6"
}, null, -1), Vs = [
  Gs
];
function Ys(e, t) {
  return C(), T("svg", qs, [...Vs]);
}
const Ws = { render: Ys }, Us = (e) => g(de, e, {
  default: () => [g(Ws, null, null)]
}), Hs = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, Ks = /* @__PURE__ */ U("path", {
  fill: "none",
  "fill-rule": "evenodd",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.5",
  d: "M15.5 19 9 12.5 15.5 6"
}, null, -1), Xs = [
  Ks
];
function Zs(e, t) {
  return C(), T("svg", Hs, [...Xs]);
}
const xs = { render: Zs }, Qs = (e) => g(de, e, {
  default: () => [g(xs, null, null)]
}), Js = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, ei = /* @__PURE__ */ U("path", {
  fill: "currentColor",
  d: "m9.779 3.25-.719 1.5H3.053c-.176 0-.303.12-.303.25v10.252l3.997-3.796a.75.75 0 0 1 .97-.053l2.082 1.582.623-.69 3.294 4.744-.967 3.71-9.696.001c-.988 0-1.803-.775-1.803-1.75V5c0-.975.815-1.75 1.803-1.75zm11.168 0c.988 0 1.803.775 1.803 1.75v14c0 .927-.736 1.672-1.656 1.744l-.147.006h-6.12L16 17.04l-4.265-6.2.76-.842a.75.75 0 0 1 .998-.105l7.757 5.635V5c0-.13-.127-.25-.303-.25H10.881l.868-1.5zM7 6.75c.356 0 .686.118.948.318l-.557 1.16.98.705A1.55 1.55 0 0 1 7 9.75c-.842 0-1.54-.663-1.54-1.5s.698-1.5 1.54-1.5"
}, null, -1), ti = [
  ei
];
function ni(e, t) {
  return C(), T("svg", Js, [...ti]);
}
const oi = { render: ni }, ri = (e) => g(de, e, {
  default: () => [g(oi, null, null)]
}), li = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, ai = /* @__PURE__ */ U("path", {
  fill: "currentColor",
  "fill-opacity": ".85",
  "fill-rule": "nonzero",
  d: "M12.214 2.1c5.385 0 9.75 4.366 9.75 9.75a.75.75 0 0 1-1.5 0 8.25 8.25 0 0 0-8.25-8.25.75.75 0 1 1 0-1.5"
}, null, -1), si = [
  ai
];
function ii(e, t) {
  return C(), T("svg", li, [...si]);
}
const ci = { render: ii }, Bn = (e) => g(de, e, {
  default: () => [g(ci, null, null)]
}), ui = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, di = /* @__PURE__ */ U("path", {
  fill: "currentColor",
  "fill-opacity": ".85",
  "fill-rule": "nonzero",
  d: "M2.79 11.462a.75.75 0 0 1 .75.75 8.25 8.25 0 0 0 8.25 8.25.75.75 0 1 1 0 1.5c-5.385 0-9.75-4.365-9.75-9.75a.75.75 0 0 1 .75-.75m9.424-9.361c5.385 0 9.75 4.365 9.75 9.75a.75.75 0 0 1-1.5 0 8.25 8.25 0 0 0-8.25-8.25.75.75 0 1 1 0-1.5"
}, null, -1), fi = [
  di
];
function hi(e, t) {
  return C(), T("svg", ui, [...fi]);
}
const pi = { render: hi }, mi = (e) => g(de, e, {
  default: () => [g(pi, null, null)]
}), bi = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, gi = /* @__PURE__ */ U("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M12.844 10.094a.75.75 0 0 0 1.06 1.06l5.594-5.593v3.688a.75.75 0 0 0 1.5 0V3.75a.75.75 0 0 0-.75-.75H14.75a.75.75 0 1 0 0 1.5h3.689zM9.25 20.998a.75.75 0 0 0 0-1.5H5.56l5.595-5.594a.75.75 0 1 0-1.061-1.06L4.5 18.438v-3.689a.75.75 0 0 0-1.5 0v5.5a.747.747 0 0 0 .75.75z",
  "clip-rule": "evenodd"
}, null, -1), yi = [
  gi
];
function vi(e, t) {
  return C(), T("svg", bi, [...yi]);
}
const wi = { render: vi }, Ci = (e) => g(de, e, {
  default: () => [g(wi, null, null)]
}), ki = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, $i = /* @__PURE__ */ U("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M20.779 4.28a.75.75 0 0 0-1.061-1.06l-5.594 5.594v-3.69a.75.75 0 0 0-1.5 0v5.5a.75.75 0 0 0 .75.75h5.4990000000000006a.75.75 0 0 0 0-1.5h-3.688zM5.125 12.624a.75.75 0 0 0 0 1.5h3.689L3.22 19.718a.75.75 0 1 0 1.06 1.06l5.594-5.593v3.688a.75.75 0 0 0 1.5 0v-5.499a.75.75 0 0 0-.458-.691.8.8 0 0 0-.292-.059z",
  "clip-rule": "evenodd"
}, null, -1), Si = [
  $i
];
function Mi(e, t) {
  return C(), T("svg", ki, [...Si]);
}
const Oi = { render: Mi }, _i = (e) => g(de, e, {
  default: () => [g(Oi, null, null)]
}), Li = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, Ti = /* @__PURE__ */ U("g", {
  fill: "currentColor",
  "fill-rule": "nonzero"
}, [
  /* @__PURE__ */ U("path", {
    "fill-opacity": ".85",
    d: "M12 22C6.486 22 2 17.514 2 12S6.486 2 12 2s10 4.486 10 10-4.486 10-10 10"
  }),
  /* @__PURE__ */ U("path", {
    fill: "#FFF",
    d: "M16.799 9.348a.714.714 0 0 0-1.01.006l-5.208 5.264-2.305-2.369a.714.714 0 1 0-1.024.996l2.813 2.89q.002.003.006.005l.003.006c.045.044.101.071.154.101.028.015.05.04.078.052a.7.7 0 0 0 .538.001c.027-.011.049-.034.075-.049.054-.03.11-.056.155-.101l.005-.006.005-.004 5.72-5.781a.715.715 0 0 0-.005-1.011"
  })
], -1), Ni = [
  Ti
];
function Ai(e, t) {
  return C(), T("svg", Li, [...Ni]);
}
const Ri = { render: Ai }, cn = (e) => g(de, e, {
  default: () => [g(Ri, null, null)]
}), Di = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, Ei = /* @__PURE__ */ U("path", {
  fill: "currentColor",
  "fill-opacity": ".85",
  "fill-rule": "nonzero",
  d: "M11.969 1.846c-5.514 0-10 4.486-10 10s4.486 10 10 10 10-4.486 10-10-4.486-10-10-10m4.08 13.08a.714.714 0 1 1-1.012 1.009l-3.072-3.081-3.081 3.048a.714.714 0 1 1-1.004-1.015l3.078-3.045L7.89 8.766a.714.714 0 1 1 1.012-1.009l3.07 3.08 3.082-3.048a.714.714 0 1 1 1.004 1.016l-3.078 3.044z"
}, null, -1), Bi = [
  Ei
];
function Ii(e, t) {
  return C(), T("svg", Di, [...Bi]);
}
const ji = { render: Ii }, un = (e) => g(de, e, {
  default: () => [g(ji, null, null)]
}), Pi = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, Fi = /* @__PURE__ */ U("path", {
  fill: "currentColor",
  "fill-opacity": ".85",
  "fill-rule": "nonzero",
  d: "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2m.717 15.022a.717.717 0 1 1-1.434 0v-6.457a.717.717 0 1 1 1.434 0zM12 8.412a1.077 1.077 0 1 1 .002-2.153A1.077 1.077 0 0 1 12 8.413"
}, null, -1), zi = [
  Fi
];
function qi(e, t) {
  return C(), T("svg", Pi, [...zi]);
}
const Gi = { render: qi }, dn = (e) => g(de, e, {
  default: () => [g(Gi, null, null)]
}), Vi = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, Yi = /* @__PURE__ */ U("path", {
  fill: "currentColor",
  "fill-opacity": ".85",
  "fill-rule": "nonzero",
  d: "M12 22c5.514 0 10-4.486 10-10S17.514 2 12 2 2 6.486 2 12s4.486 10 10 10m-.717-15.022a.717.717 0 1 1 1.434 0v6.457a.717.717 0 1 1-1.434 0zm.717 8.61a1.077 1.077 0 1 1-.002 2.153A1.077 1.077 0 0 1 12 15.587"
}, null, -1), Wi = [
  Yi
];
function Ui(e, t) {
  return C(), T("svg", Vi, [...Wi]);
}
const Hi = { render: Ui }, fn = (e) => g(de, e, {
  default: () => [g(Hi, null, null)]
}), [ro, bt] = V("message"), Ki = G({
  name: ro,
  components: {
    CheckCircleFilled: cn,
    CloseFilled: un,
    WarningFilled: fn,
    TipsFilled: dn,
    CloseOutlined: rr,
    Loading2Outlined: Bn
  },
  inheritAttrs: !1,
  props: ws,
  emits: ["update:visible", "closed"],
  setup(e, { emit: t }) {
    const n = bt(), o = bt("content"), r = bt("text"), l = bt("closable"), [a, s] = Dt(e, t, "visible", "update:visible"), i = () => {
      s(!1);
    }, c = () => {
      t("closed");
    };
    return ae(
      () => e.visible,
      (u) => {
        if (u && e.duration > 0) {
          const d = setTimeout(() => {
            i(), clearTimeout(d);
          }, e.duration);
        }
      }
    ), {
      name: ro,
      containerClassName: n,
      contentClassName: o,
      closeIconClassName: l,
      innerVisible: a,
      textClassName: r,
      handleClose: i,
      onAfterLeave: c
    };
  }
});
function Xi(e, t, n, o, r, l) {
  const a = P("tips-filled"), s = P("check-circle-filled"), i = P("warning-filled"), c = P("close-filled"), u = P("loading2-outlined"), d = P("close-outlined");
  return C(), F(Tt, {
    to: e.teleport
  }, [
    g(gn, {
      name: e.name,
      appear: "",
      onAfterLeave: e.onAfterLeave
    }, {
      default: le(() => [
        e.visible ? (C(), T("div", {
          key: 0,
          class: B(e.containerClassName)
        }, [
          U("div", {
            class: B(e.contentClassName)
          }, [
            e.type === "text" ? (C(), T(J, { key: 0 }, [
              e.theme === "info" ? (C(), F(a, {
                key: 0,
                size: "small",
                color: "var(--d-primary)"
              })) : z("", !0),
              e.theme === "success" ? (C(), F(s, {
                key: 1,
                size: "small",
                color: "var(--d-success)"
              })) : z("", !0),
              e.theme === "warning" ? (C(), F(i, {
                key: 2,
                size: "small",
                color: "var(--d-warning)"
              })) : z("", !0),
              e.theme === "error" ? (C(), F(c, {
                key: 3,
                size: "small",
                color: "var(--d-error)"
              })) : z("", !0)
            ], 64)) : e.type === "loading" ? (C(), F(u, {
              key: 1,
              size: "small",
              spin: "",
              color: "var(--d-primary)"
            })) : z("", !0),
            U("span", {
              class: B(e.textClassName)
            }, He(e.content), 3),
            e.closable ? (C(), F(d, {
              key: 2,
              class: B(e.closeIconClassName),
              size: "small",
              onClick: e.handleClose
            }, null, 8, ["class", "onClick"])) : z("", !0)
          ], 2)
        ], 2)) : z("", !0)
      ]),
      _: 1
    }, 8, ["name", "onAfterLeave"])
  ], 8, ["to"]);
}
const lr = /* @__PURE__ */ Q(Ki, [["render", Xi]]), ar = `${$e}-message-container`, Ot = document.createElement("div");
Ot.setAttribute("id", ar);
const In = /* @__PURE__ */ new Map(), lo = {
  duration: 2e3
};
function Zi(e, t) {
  const {
    instance: n,
    unmount: o
  } = $n({
    setup(r, {
      expose: l
    }) {
      const a = oe({
        show: !1
      }), s = (u) => a.show = u, i = () => s(!0), c = () => {
        s(!1), setTimeout(() => {
          In.delete(t), o();
        }, lo.duration);
      };
      return l({
        open: i,
        destroy: c
      }), () => {
        const u = {
          ...lo,
          ...e,
          teleport: `#${ar}`,
          visible: a.show,
          "transition-appear": !0,
          "onUpdate:visible": c
        };
        return g(lr, u, null);
      };
    }
  }, void 0, Ot);
  return n;
}
function Ye(e) {
  let t;
  document.body.contains(Ot) || document.body.appendChild(Ot), typeof e == "string" ? t = {
    content: e
  } : t = e;
  const n = tr("message"), o = Zi(t, n);
  return In.set(n, o), o.open(), o;
}
const sr = {
  text: (e, t) => Ye({
    content: e,
    ...t
  }),
  info: (e, t) => Ye({
    content: e,
    ...t,
    theme: "info"
  }),
  success: (e, t) => Ye({
    content: e,
    ...t,
    theme: "success"
  }),
  warning: (e, t) => Ye({
    content: e,
    ...t,
    theme: "warning"
  }),
  error: (e, t) => Ye({
    content: e,
    ...t,
    theme: "error"
  }),
  loading: (e, t) => Ye({
    content: e,
    ...t,
    type: "loading"
  }),
  destroyAll() {
    In.forEach((e) => {
      e.destroy();
    });
  }
}, xi = () => sr, Qi = Y(lr), Ji = {
  /**
   * 图片宽度，为数字时，单位：px
   */
  width: {
    type: [String, Number],
    default: ""
  },
  /**
   * 图片高度，为数字时，单位：px
   */
  height: {
    type: [String, Number],
    default: ""
  },
  /**
   * 图片地址
   */
  src: {
    type: String,
    default: ""
  },
  /**
   * 图片错误展示文本，原始属性
   */
  alt: {
    type: String,
    default: ""
  },
  /**
   * 填充模式
   */
  fit: {
    type: String,
    default: "fill"
  },
  /**
   * 元素位置
   */
  position: {
    type: String,
    default: ""
  },
  /**
   * 圆角大小，为数字时，单位：px
   */
  radius: [String, Number],
  /**
   * 是否为圆形
   */
  round: Boolean,
  /**
   * 是否显示加载中状态，外部控制
   */
  showLoading: Boolean,
  /**
   * 是否显示加载失败，外部控制
   */
  showError: Boolean,
  /**
   * 加载失败文案
   */
  errorText: {
    type: String,
    default: "加载失败"
  },
  /**
   * 是否延迟渲染
   * 对应原生 loading 属性
   * @link https://developer.mozilla.org/zh-CN/docs/Web/HTML/Element/img#loading
   */
  lazy: {
    type: Boolean,
    default: !0
  }
}, [ec, xt] = V("image"), tc = G({
  name: ec,
  components: {
    Loading2Outlined: Bn,
    ImageFailOutlined: ri
  },
  props: Ji,
  setup(e) {
    const t = xt(), n = xt("tips"), o = xt("tips-icon"), r = X(e.showLoading ?? !0), l = X(e.showError ?? !1), a = q(() => ({
      width: K(e.width),
      height: K(e.height)
    })), s = q(() => ({
      objectFit: e.fit,
      objectPosition: e.position,
      borderRadius: e.round ? "50%" : e.radius
    }));
    return ae(
      () => e.showLoading,
      () => {
        r.value = e.showLoading;
      }
    ), ae(
      () => e.showError,
      () => {
        l.value = e.showError;
      }
    ), {
      wrapperClassName: t,
      tipsClassName: n,
      wrapperStyle: a,
      imageStyle: s,
      tipsIconClassName: o,
      loading: r,
      loadError: l,
      handleLoad: () => {
        e.showLoading || (r.value = !1);
      },
      handleError: () => {
        l.value = !0;
      }
    };
  }
}), nc = ["src", "alt", "loading"];
function oc(e, t, n, o, r, l) {
  const a = P("loading2-outlined"), s = P("image-fail-outlined");
  return C(), T("div", {
    class: B(e.wrapperClassName),
    style: _e(e.wrapperStyle)
  }, [
    ne(e.$slots, "default", {
      src: e.src,
      alt: e.alt,
      loading: e.lazy ? "lazy" : "eager",
      style: _e(e.imageStyle),
      load: e.handleLoad,
      error: e.handleError
    }, () => [
      U("img", {
        src: e.src,
        alt: e.alt,
        loading: e.lazy ? "lazy" : "eager",
        style: _e(e.imageStyle),
        onLoad: t[0] || (t[0] = (...i) => e.handleLoad && e.handleLoad(...i)),
        onError: t[1] || (t[1] = (...i) => e.handleError && e.handleError(...i))
      }, null, 44, nc)
    ]),
    e.loading || e.loadError ? (C(), T("div", {
      key: 0,
      class: B(e.tipsClassName)
    }, [
      e.loading && !e.loadError ? (C(), F(a, {
        key: 0,
        class: B(e.tipsIconClassName),
        spin: e.loading
      }, null, 8, ["class", "spin"])) : z("", !0),
      e.loadError ? (C(), T(J, { key: 1 }, [
        g(s, {
          class: B(e.tipsIconClassName)
        }, null, 8, ["class"]),
        U("p", null, He(e.errorText), 1)
      ], 64)) : z("", !0)
    ], 2)) : z("", !0)
  ], 6);
}
const rc = /* @__PURE__ */ Q(tc, [["render", oc]]), lc = Y(rc), ac = {
  /**
   * 主题分类
   */
  theme: {
    type: String,
    default: "default"
  },
  /**
   * 按钮大小
   */
  size: {
    type: String,
    default: "medium"
  },
  /**
   * 是否禁用
   */
  disabled: {
    type: Boolean,
    default: !1
  },
  /**
   * 是否为块级元素
   */
  block: Boolean,
  /**
   * 填充模式
   */
  fill: {
    type: String,
    default: "solid"
  },
  /**
   * 按钮形状
   */
  shape: {
    type: String,
    default: "default"
  },
  /**
   * 是否显示 loading 效果
   */
  loading: Boolean,
  /**
   * 链接模式
   */
  link: Boolean,
  /**
   * 虚线模式
   */
  dashed: {
    type: Boolean,
    default: !1
  },
  onClick: {
    type: Function,
    default: () => {
    }
  }
}, [sc, nt] = V("button"), ic = G({
  name: sc,
  components: {
    LoadingOutlined: mi
  },
  props: ac,
  emits: ["click"],
  setup(e, t) {
    const n = X(!1), o = q(
      () => nt({
        [`theme-${e.theme}`]: !0,
        [`size-${e.size}`]: !0,
        [`shape-${e.shape}`]: !e.link,
        "fill-outline": e.dashed,
        dashed: e.dashed,
        [`fill-${e.fill}`]: !e.link && !e.dashed,
        block: e.block,
        disabled: e.disabled,
        "is-link": e.link,
        active: n.value
      })
    ), r = (l) => {
      e.fill !== "none" && !e.link && (n.value = !0, setTimeout(() => n.value = !1, 300)), t.emit("click", l);
    };
    return {
      wrapperClassName: o,
      iconClassName: nt("icon"),
      innerTextClassName: nt("text"),
      iconLoadingClassName: nt("icon-loading"),
      customIconClassName: nt("custom-icon"),
      onClick: r
    };
  }
}), cc = ["disabled"];
function uc(e, t, n, o, r, l) {
  const a = P("loading-outlined");
  return C(), T("button", {
    class: B([e.wrapperClassName, e.$attrs.class]),
    disabled: e.loading || e.disabled,
    onClick: t[0] || (t[0] = (...s) => e.onClick && e.onClick(...s))
  }, [
    e.loading ? (C(), F(a, {
      key: 0,
      spin: "",
      class: B(e.iconLoadingClassName),
      size: "small",
      color: "inherit"
    }, null, 8, ["class"])) : z("", !0),
    e.$slots.icon ? (C(), T("span", {
      key: 1,
      class: B(e.iconClassName)
    }, [
      ne(e.$slots, "icon")
    ], 2)) : z("", !0),
    U("span", {
      class: B(e.innerTextClassName)
    }, [
      ne(e.$slots, "default")
    ], 2)
  ], 10, cc);
}
const dc = /* @__PURE__ */ Q(ic, [["render", uc]]), Ue = Y(dc), fc = {
  ...Te(Re, ["lockScroll", "teleport"]),
  visible: {
    type: Boolean,
    default: !1
  },
  zIndex: {
    type: Number,
    default: void 0
  },
  duration: {
    type: [Number, String],
    default: go
  },
  overlayClass: {
    type: String,
    default: ""
  },
  overlayStyle: {
    type: Object,
    default: void 0
  },
  closeOnOverlayClick: {
    type: Boolean,
    default: !0
  },
  /**
   * 是否开启懒加载渲染，默认开启
   */
  lazyRender: {
    type: Boolean,
    default: !0
  }
}, [ao, hc] = V("overlay"), pc = G({
  name: ao,
  inheritAttrs: !1,
  props: fc,
  emits: ["update:visible", "click"],
  setup(e, { emit: t }) {
    const [n, o] = Dt(
      e,
      t,
      "visible",
      "update:visible"
    ), r = X(e.visible ? !0 : !e.lazyRender), [l] = ie(e.zIndex) ? nr(e) : [X(e.zIndex)], a = q(() => ({
      zIndex: l.value,
      transitionDuration: typeof e.duration == "number" ? `${e.duration}s` : e.duration,
      ...e.overlayStyle ?? {}
    }));
    function s() {
      e.lockScroll && document.body.classList.add(`${$e}-overflow-hidden`);
    }
    function i() {
      e.lockScroll && document.body.classList.remove(`${$e}-overflow-hidden`);
    }
    function c() {
      e.closeOnOverlayClick && (o(n.value = !n.value), t("click"));
    }
    return ae(
      () => e.visible,
      (u) => {
        u && (r.value = !0);
      }
    ), {
      name: ao,
      innerVisible: n,
      style: a,
      isLoaded: r,
      bem: hc,
      handleClose: c,
      onTransitionBefore: s,
      onTransitionAfterLeave: i
    };
  }
});
function mc(e, t, n, o, r, l) {
  return C(), F(Tt, {
    to: e.teleport
  }, [
    g(gn, {
      name: e.name,
      onBeforeEnter: e.onTransitionBefore,
      onAfterLeave: e.onTransitionAfterLeave
    }, {
      default: le(() => [
        e.isLoaded ? yn((C(), T("div", {
          key: 0,
          class: B([e.bem(), e.overlayClass].join(" ")),
          style: _e(e.style),
          onClick: t[0] || (t[0] = mo((...a) => e.handleClose && e.handleClose(...a), ["stop"]))
        }, [
          ne(e.$slots, "default")
        ], 6)), [
          [vn, e.innerVisible]
        ]) : z("", !0)
      ]),
      _: 3
    }, 8, ["name", "onBeforeEnter", "onAfterLeave"])
  ], 8, ["to"]);
}
const bc = /* @__PURE__ */ Q(pc, [["render", mc]]), ir = Y(bc), gc = {
  ...Te(Re, ["lockScroll", "teleport", "lazyRender", "round"]),
  visible: Boolean,
  title: String,
  placement: {
    type: String,
    default: "center"
  },
  zIndex: {
    type: Number,
    default: void 0
  },
  duration: {
    type: [Number, String],
    default: go
  },
  closable: Boolean,
  /**
   * 是否支持全屏
   */
  scale: {
    type: Boolean,
    default: !1
  },
  /**
   * 动画前缀
   */
  transitionPrefix: {
    type: String,
    default: void 0
  },
  transitionAppear: {
    type: Boolean,
    default: !1
  },
  popupContainerClass: {
    type: [String, Array, Object],
    default: void 0
  },
  popupClass: {
    type: [String, Array, Object],
    default: void 0
  },
  popupHeaderClass: {
    type: [String, Array, Object],
    default: void 0
  },
  popupBodyClass: {
    type: [String, Array, Object],
    default: void 0
  },
  popupStyle: {
    type: Object,
    default: {}
  },
  overlay: {
    type: Boolean,
    default: !0
  },
  overlayClass: String,
  overlayStyle: {
    type: Object,
    default: {}
  },
  closeOnOverlayClick: {
    type: Boolean,
    default: !0
  }
}, [so, io] = V("popup"), yc = G({
  name: so,
  components: { DOverlay: ir, CloseOutlined: rr, FullScreenOutlined: Ci, NonFullScreenOutlined: _i },
  inheritAttrs: !1,
  props: gc,
  emits: ["update:visible", "open", "opened", "close", "closed", "click-overlay-icon"],
  setup(e, { emit: t, slots: n }) {
    const o = q(() => e.placement === "center"), r = X(e.visible ? !0 : !e.lazyRender), l = X(), a = ze(["round"], e), s = X(!1), i = q(() => e.title || e.closable || n.title || n["header-left"] || n["header-right"]), c = q(
      () => [
        io("wrapper", {
          [e.placement]: e.placement,
          round: a.value.round,
          notCenter: !o.value,
          "full-screen": s.value
        }),
        e.popupClass
      ].join(" ")
    ), [u] = nr(e), d = q(
      () => `${e.transitionPrefix || so}-${e.placement}`
    ), f = q(() => ({
      zIndex: u.value,
      transitionDuration: typeof e.duration == "number" ? `${e.duration}s` : e.duration
    })), h = q(() => {
      const M = { ...e.popupStyle };
      return s.value && (M.width = "100%", M.height = "100%"), M;
    }), b = () => t("open"), k = () => t("opened"), p = () => t("closed"), w = () => {
      v(!1), t("update:visible", !1), t("close");
    }, _ = () => {
      w(), t("click-overlay-icon");
    }, v = (M) => {
      s.value = M;
    };
    return ae(
      () => e.visible,
      (M) => {
        M && (r.value = !0);
      }
    ), {
      transitionPosition: d,
      wrapperClassName: c,
      style: f,
      isCenter: o,
      showHeader: i,
      isLoaded: r,
      wrapperRef: l,
      fullScreen: s,
      popupStyle: h,
      bem: io,
      handleClose: w,
      onEnter: b,
      onAfterEnter: k,
      onAfterLeave: p,
      handleClickIcon: _,
      toggleFullScreen: v
    };
  }
});
function vc(e, t, n, o, r, l) {
  const a = P("d-overlay"), s = P("full-screen-outlined"), i = P("non-full-screen-outlined"), c = P("close-outlined");
  return C(), F(Tt, {
    to: e.teleport
  }, [
    e.overlay ? (C(), F(a, {
      key: 0,
      teleport: e.wrapperRef,
      visible: e.visible,
      "overlay-class": e.overlayClass,
      "z-index": -1,
      "overlay-style": e.overlayStyle,
      "lazy-render": e.lazyRender,
      "lock-scroll": e.lockScroll,
      "close-on-overlay-click": e.closeOnOverlayClick,
      onClick: t[0] || (t[0] = (u) => e.closeOnOverlayClick && e.handleClose())
    }, null, 8, ["teleport", "visible", "overlay-class", "overlay-style", "lazy-render", "lock-scroll", "close-on-overlay-click"])) : z("", !0),
    g(gn, {
      name: e.transitionPosition,
      appear: e.transitionAppear,
      onEnter: e.onEnter,
      onAfterEnter: e.onAfterEnter,
      onAfterLeave: e.onAfterLeave
    }, {
      default: le(() => [
        e.isLoaded ? yn((C(), T("div", {
          key: 0,
          ref: "wrapperRef",
          class: B([e.bem("container"), e.popupContainerClass]),
          style: _e(e.style)
        }, [
          U("div", {
            class: B(e.wrapperClassName),
            style: _e(e.popupStyle)
          }, [
            e.showHeader ? (C(), T("header", {
              key: 0,
              class: B([e.bem("header"), e.popupHeaderClass])
            }, [
              e.$slots["header-left"] ? (C(), T("div", {
                key: 0,
                class: B(e.bem("header-left"))
              }, [
                ne(e.$slots, "header-left")
              ], 2)) : z("", !0),
              ne(e.$slots, "title", {}, () => [
                U("div", {
                  class: B(e.bem("header-title"))
                }, He(e.title), 3)
              ]),
              e.$slots["header-right"] ? (C(), T("div", {
                key: 1,
                class: B(e.bem("header-right"))
              }, [
                ne(e.$slots, "header-right")
              ], 2)) : z("", !0),
              e.scale ? (C(), T("span", {
                key: 2,
                class: B([e.bem("header-scale"), "cursor-block"])
              }, [
                e.fullScreen ? (C(), F(i, {
                  key: 1,
                  onClick: t[2] || (t[2] = (u) => e.toggleFullScreen(!1))
                })) : (C(), F(s, {
                  key: 0,
                  onClick: t[1] || (t[1] = (u) => e.toggleFullScreen(!0))
                }))
              ], 2)) : z("", !0),
              e.closable ? (C(), T("span", {
                key: 3,
                class: B([e.bem("header-closable"), "cursor-block"]),
                onClick: t[3] || (t[3] = (...u) => e.handleClickIcon && e.handleClickIcon(...u))
              }, [
                ne(e.$slots, "close-icon", {}, () => [
                  g(c)
                ])
              ], 2)) : z("", !0)
            ], 2)) : z("", !0),
            U("div", {
              class: B([e.bem("body"), e.popupBodyClass])
            }, [
              ne(e.$slots, "default")
            ], 2),
            ne(e.$slots, "footer")
          ], 6)
        ], 6)), [
          [vn, e.visible]
        ]) : z("", !0)
      ]),
      _: 3
    }, 8, ["name", "appear", "onEnter", "onAfterEnter", "onAfterLeave"])
  ], 8, ["to"]);
}
const wc = /* @__PURE__ */ Q(yc, [["render", vc]]), _t = Y(wc), Cc = {
  /**
   * 间隙，单位：px
   */
  gap: {
    type: Number,
    default: 8
  },
  /**
   * 排列方式，水平、垂直
   */
  direction: {
    type: String,
    default: "horizontal"
  },
  /**
   * 水平排列对齐方式
   */
  justify: {
    type: String,
    default: void 0
  },
  /**
   * 垂直排列对齐方式
   */
  align: {
    type: String,
    default: void 0
  },
  /**
   * 是否自动换行，水平时生效
   */
  wrap: {
    type: Boolean,
    default: !1
  }
}, jn = (e, t = []) => (e.forEach((n) => {
  n.type !== jr && (n.type === J && Array.isArray(n.children) && jn(n.children, t), n.type !== J && t.push(n));
}), t), [kc, $c] = V("space"), Sc = G({
  name: kc,
  props: Cc,
  setup(e, {
    slots: t,
    attrs: n
  }) {
    return () => {
      var l;
      const o = q(() => [$c({
        [e.direction]: e.direction,
        [`justify-${e.justify}`]: e.justify,
        [`align-${e.align}`]: e.align,
        wrap: e.wrap
      }), n.class]), r = jn(((l = t.default) == null ? void 0 : l.call(t)) ?? []);
      return g("div", {
        class: o.value,
        style: {
          gap: K(e.gap)
        }
      }, [r]);
    };
  }
}), cr = Y(Sc), Mc = {
  ...Te(Re, [
    "requiredMarkPosition",
    "clientType",
    "border",
    "round",
    "useCustomDescription",
    "renderCellTitle"
  ]),
  title: String,
  titleClass: String,
  titleWidth: [String, Number],
  titleAlign: {
    type: String,
    default: "left"
  },
  /**
   * 标题垂直居中
   */
  titleVerticalCenter: {
    type: Boolean,
    default: !1
  },
  hideTitle: Boolean,
  required: Boolean,
  content: String,
  contentClass: String,
  contentAlign: String,
  disabled: Boolean,
  suffix: String,
  description: String,
  arrow: Boolean,
  layout: String
}, Pn = Symbol("CellGroup"), Oc = (e) => {
  const { cellTitleWidth: t, cellContentAlign: n, layout: o, border: r, round: l } = Fe(
    Pn,
    {}
  ), a = ze(
    [
      "layout",
      "labelWidth",
      "requiredMarkPosition",
      "clientType",
      "border",
      "round",
      "useCustomDescription",
      "renderCellTitle"
    ],
    e
  );
  return q(() => {
    const s = e.clientType || a.value.clientType;
    return {
      clientType: e.clientType || a.value.clientType,
      hideTitle: e.hideTitle,
      border: e.border ?? r ?? a.value.border,
      round: s === wn.PC ? !1 : e.round ?? l ?? a.value.round,
      contentAlign: e.contentAlign || n || "left",
      labelWidth: e.titleWidth || t || a.value.labelWidth,
      layout: e.layout || (o == null ? void 0 : o.value) || a.value.layout || "horizontal",
      requiredMarkPosition: e.requiredMarkPosition || a.value.requiredMarkPosition,
      useCustomDescription: e.useCustomDescription || a.value.useCustomDescription,
      renderCellTitle: e.renderCellTitle || a.value.renderCellTitle
    };
  });
}, [_c, se] = V("cell"), Lc = G({
  name: _c,
  props: Mc,
  setup(e, {
    slots: t
  }) {
    at(Pn, {
      layout: X("horizontal")
    });
    const n = Oc(e), o = q(() => {
      var r;
      return se({
        "hide-title": n.value.hideTitle,
        [`layout-${n.value.layout}`]: n.value.layout,
        disabled: e.disabled,
        border: n.value.border || n.value.border === void 0,
        [`${(r = n.value.clientType) == null ? void 0 : r.toLowerCase()}`]: !0,
        round: n.value.round
      });
    });
    return () => {
      var p, w, _;
      const r = [se("title", {
        [e.titleAlign]: e.titleAlign,
        "title-vertical-center": e.titleVerticalCenter
      }), e.titleClass], l = [se("content", {
        [n.value.contentAlign]: n.value.contentAlign
      }), e.contentClass], a = t["left-icon"] ? g("span", {
        class: se("title-icon")
      }, [t["left-icon"]()]) : null, s = e.required && n.value.requiredMarkPosition === "left" ? g("span", {
        class: se("title-mark")
      }, [Vn("*")]) : null, i = e.required && n.value.requiredMarkPosition === "right" ? g("span", {
        class: se("title-mark")
      }, [Vn("*")]) : null, c = ((w = (p = n.value).renderCellTitle) == null ? void 0 : w.call(p, e.title, e.description)) || g("span", null, [e.title]), u = g(J, null, [a, s, c, i]), d = !n.value.hideTitle && !(ie(e.title) && ie(t.title)) ? g("div", {
        class: r,
        style: {
          width: K(n.value.labelWidth)
        }
      }, [ie(t.title) ? u : (_ = t.title) == null ? void 0 : _.call(t)]) : null, f = n.value.useCustomDescription ? null : e.description ? g("div", {
        class: se("description")
      }, [e.description]) : null, h = t["right-icon"] ? g("span", {
        class: se("right-icon")
      }, [t["right-icon"]()]) : null, b = t.suffix || e.suffix ? g("div", {
        class: se("suffix")
      }, [t.suffix ? t.suffix() : e.suffix]) : null, k = e.arrow ? g(Us, {
        className: se("arrow"),
        color: "var(--d-secondary-text-color)"
      }, null) : null;
      return n.value.clientType === "MOBILE" ? g("div", {
        class: o.value
      }, [g("div", {
        class: se("wrapper")
      }, [d, g("div", {
        class: l
      }, [g("div", {
        class: se("content-inner")
      }, [t.default ? t.default() : e.content]), h, b, k])]), f]) : g("div", {
        class: o.value
      }, [d, g("div", {
        class: l
      }, [f, g("div", {
        class: se("content-inner")
      }, [t.default ? t.default() : e.content]), h, b])]);
    };
  }
}), ur = Y(Lc), Tc = {
  ...Te(Re, ["border", "round"]),
  title: String,
  cellTitleWidth: String,
  cellContentAlign: String,
  layout: String
}, [Nc, Qt] = V("cell-group"), Ac = G({
  name: Nc,
  props: Tc,
  setup(e, {
    slots: t
  }) {
    const n = X(e.layout), o = ze(["border", "round"], e);
    return at(Pn, {
      cellTitleWidth: e.cellTitleWidth,
      cellContentAlign: e.cellContentAlign,
      layout: n,
      border: o.value.border,
      round: o.value.round
    }), po(() => {
      n.value = e.layout;
    }), () => {
      var l;
      const {
        title: r
      } = e;
      return g("div", {
        class: Qt()
      }, [r && g("p", {
        class: Qt("title")
      }, [r]), g("div", {
        class: Qt("content")
      }, [(l = t.default) == null ? void 0 : l.call(t)])]);
    };
  }
}), dr = Y(Ac), fr = {
  ...Te(Re, [
    "disabled",
    "readonly",
    "requiredMarkPosition",
    "labelWidth",
    "clientType",
    "border",
    "round",
    "idGenerator",
    "renderFormLabel",
    "useCustomDescription"
  ]),
  /**
   * 表单模型
   */
  models: {
    type: Array,
    required: !0,
    default: () => []
  },
  /**
   * 表单数据
   */
  data: {
    type: Object,
    default: void 0
  },
  /**
   * 显示属性联动
   */
  viewLinkage: {
    type: Array,
    default: () => []
  },
  /**
   * 表单 FormStore
   */
  store: Object,
  /**
   * 标题布局类型
   */
  layout: String,
  /**
   * 是否隐藏标题
   */
  hideLabel: Boolean,
  /**
   * 是否显示背景
   */
  hasBackground: {
    type: Boolean,
    default: !0
  },
  /**
   * 是否显示冒号
   */
  colon: {
    type: Boolean,
    default: void 0
  },
  /**
   * 内容对齐方式
   */
  contentAlign: {
    type: String,
    default: "left"
  }
}, [hr, We] = V("form");
var st = /* @__PURE__ */ ((e) => (e.FORM = "form", e.FIELD = "field", e.LINKAGE = "linkage", e))(st || {});
const Fn = Symbol("Form");
var Me = function() {
  return Me = Object.assign || function(e) {
    for (var t, n = 1, o = arguments.length; n < o; n++) for (var r in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
    return e;
  }, Me.apply(this, arguments);
};
function gt(e, t, n, o) {
  return new (n || (n = Promise))(function(r, l) {
    function a(c) {
      try {
        i(o.next(c));
      } catch (u) {
        l(u);
      }
    }
    function s(c) {
      try {
        i(o.throw(c));
      } catch (u) {
        l(u);
      }
    }
    function i(c) {
      var u;
      c.done ? r(c.value) : (u = c.value, u instanceof n ? u : new n(function(d) {
        d(u);
      })).then(a, s);
    }
    i((o = o.apply(e, [])).next());
  });
}
function yt(e, t) {
  var n, o, r, l, a = { label: 0, sent: function() {
    if (1 & r[0]) throw r[1];
    return r[1];
  }, trys: [], ops: [] };
  return l = { next: s(0), throw: s(1), return: s(2) }, typeof Symbol == "function" && (l[Symbol.iterator] = function() {
    return this;
  }), l;
  function s(i) {
    return function(c) {
      return function(u) {
        if (n) throw new TypeError("Generator is already executing.");
        for (; l && (l = 0, u[0] && (a = 0)), a; ) try {
          if (n = 1, o && (r = 2 & u[0] ? o.return : u[0] ? o.throw || ((r = o.return) && r.call(o), 0) : o.next) && !(r = r.call(o, u[1])).done) return r;
          switch (o = 0, r && (u = [2 & u[0], r.value]), u[0]) {
            case 0:
            case 1:
              r = u;
              break;
            case 4:
              return a.label++, { value: u[1], done: !1 };
            case 5:
              a.label++, o = u[1], u = [0];
              continue;
            case 7:
              u = a.ops.pop(), a.trys.pop();
              continue;
            default:
              if (r = a.trys, !((r = r.length > 0 && r[r.length - 1]) || u[0] !== 6 && u[0] !== 2)) {
                a = 0;
                continue;
              }
              if (u[0] === 3 && (!r || u[1] > r[0] && u[1] < r[3])) {
                a.label = u[1];
                break;
              }
              if (u[0] === 6 && a.label < r[1]) {
                a.label = r[1], r = u;
                break;
              }
              if (r && a.label < r[2]) {
                a.label = r[2], a.ops.push(u);
                break;
              }
              r[2] && a.ops.pop(), a.trys.pop();
              continue;
          }
          u = t.call(e, a);
        } catch (d) {
          u = [6, d], o = 0;
        } finally {
          n = r = 0;
        }
        if (5 & u[0]) throw u[1];
        return { value: u[0] ? u[1] : void 0, done: !0 };
      }([i, c]);
    };
  }
}
var zn = function(e) {
  return Object.prototype.toString.call(e);
}, hn = function(e) {
  return zn(e) === "[object Object]";
}, pr = function(e) {
  return /^\d+$/.test(e + "");
}, mr = function(e) {
  return /^\d+\.\d+$/.test(e + "");
}, co = function(e) {
  return zn(e) === "[object Promise]";
}, Pe = function(e) {
  return Array.isArray(e) ? e.length === 0 : hn(e) ? Object.keys(e).length === 0 : ["[object Set]", "[object Map]"].includes(zn(e)) ? e.size === 0 : [null, void 0, ""].includes(e);
}, Jt = function(e, t) {
  throw "[".concat(function(n) {
    return n.replace(/(-\w)/g, function(o) {
      return o.substr(1, 1).toUpperCase();
    }).replace(/^(\w)/, function(o) {
      return o.toUpperCase();
    });
  }(e), "]: ").concat(t);
}, Rc = { validator: function(e) {
  return !Pe(e);
} }, Dc = { validator: function(e, t) {
  var n = t.ruleValue;
  return !!Pe(e) || e < parseFloat(n);
} }, Ec = { validator: function(e, t) {
  var n = t.ruleValue;
  return !!Pe(e) || e > parseFloat(n);
} }, Bc = { validator: function(e) {
  return pr(t = e) || mr(t);
  var t;
} }, Ic = { validator: function(e) {
  return pr(e);
} }, jc = { validator: function(e) {
  return mr(e);
} }, Pc = { paramsEnum: [{ name: "min" }, { name: "max" }], validator: function(e, t) {
  var n = t.ruleValue, o = n === void 0 ? [] : n;
  return !!Pe(e) || e >= Number(o[0]) && e <= Number(o[1]);
} }, Fc = Object.freeze({ __proto__: null, alpha: { validator: function(e) {
  return /^[a-z]*$/i.test(e);
} }, alpha_num: { validator: function(e) {
  return /^[a-z\d]*$/i.test(e);
} }, alpha_spaces: { validator: function(e) {
  return /^[a-z\s]*$/i.test(e);
} }, between: Pc, confirmed: { validator: function(e, t) {
  var n = t.linkField, o = t.dataKeyMap;
  if (!e) return !0;
  var r = o.get(n);
  return e === (r == null ? void 0 : r.value);
} }, email: { validator: function(e) {
  return !e || /^(\w+|\w+(\.\w+))+@(\w+\.)+\w+$/.test(e);
} }, float: jc, integer: Ic, length: { validator: function(e, t) {
  var n = t.ruleValue;
  return !e || e.length === +n;
} }, max: Dc, max_length: { validator: function(e, t) {
  var n = t.ruleValue;
  return !e || e.length <= +n;
} }, min: Ec, min_length: { validator: function(e, t) {
  var n = t.ruleValue;
  return !e || +n <= e.length;
} }, number: Bc, required: Rc, url: { validator: function(e) {
  return /^https?:\/\/(\w+\.)+\w+(:\d+)?([?\/]\S*)?$/i.test(e);
} } }), vt = ",", wt = "@", zc = function() {
  function e() {
    var t = this;
    this.locale = null, this.validateModel = /* @__PURE__ */ new Map(), this.localize = function(n) {
      return t.locale = n.message, t.resolveDefaultRules(), t;
    }, this.extend = function(n, o) {
      return t.validateModel.set(n, o), t;
    }, this.extends = function(n) {
      for (var o = 0, r = Object.entries(n); o < r.length; o++) {
        var l = r[o], a = l[0], s = l[1];
        t.extend(a, s);
      }
      return t;
    }, this.resolveDefaultRules = function() {
      t.locale || Jt("validator", "未注册国际化词条，参考链接：https://github.com/D-xuanmo/validator#%E4%BD%BF%E7%94%A8");
      for (var n = 0, o = Object.entries(Fc); n < o.length; n++) {
        var r = o[n], l = r[0], a = r[1];
        t.extend(l, { message: t.locale[l], validator: a.validator, paramsEnum: a.paramsEnum });
      }
    }, this.validate = this.validate.bind(this);
  }
  return e.prototype.isValidateFail = function(t) {
    return t !== !0;
  }, e.prototype.parseRule = function(t) {
    return t == null ? void 0 : t.split("|");
  }, e.prototype.formatMessage = function(t, n, o) {
    var r = o ?? {}, l = r.ruleParams, a = r.paramsEnum, s = r.context, i = t.replace(/\{#field}/gi, n);
    if (Array.isArray(l) && (Pe(a) && Jt("validator", "The {".concat(n, "} field validation rule parameter is not defined.")), l.forEach(function(d, f) {
      i = i.replace(new RegExp("\\{".concat(a[f].name, "}")), d);
    })), typeof l == "string") {
      var c = l;
      if (new RegExp("^".concat(wt)).test(l)) {
        var u = s == null ? void 0 : s.dataKeyMap.get(l.replace(wt, ""));
        c = (u == null ? void 0 : u.label) || (u == null ? void 0 : u.dataKey) || "";
      }
      i = i.replace(/\{[a-z]+}/i, c);
    }
    return i;
  }, e.prototype.regexpValidateHandler = function(t, n) {
    return !t || new RegExp(n).test(t);
  }, e.prototype.formatRuleParams = function(t) {
    return t && t.includes(vt) ? t.split(vt) : t;
  }, e.prototype.formatLinkField = function(t) {
    var n;
    return t != null && t.includes(wt) && (n = t.replace(new RegExp(wt, "g"), "")), n != null && n.includes(vt) ? n.split(vt) : n;
  }, e.prototype.scopeValidateHandler = function(t, n, o) {
    return gt(this, void 0, void 0, function() {
      var r, l, a;
      return yt(this, function(s) {
        switch (s.label) {
          case 0:
            return r = !0, n.regexp && (r = this.regexpValidateHandler(t, n.regexp)), n.validator ? (r = (l = n.validator) === null || l === void 0 ? void 0 : l.call(n, t, o), co(r) ? [4, (a = n.validator) === null || a === void 0 ? void 0 : a.call(n, t, o)] : [3, 2]) : [3, 2];
          case 1:
            r = s.sent(), s.label = 2;
          case 2:
            return r ? [2, !0] : [2, n.message];
        }
      });
    });
  }, e.prototype.validateHandler = function(t, n, o, r) {
    return gt(this, void 0, void 0, function() {
      var l, a, s, i, c, u, d, f, h, b, k;
      return yt(this, function(p) {
        switch (p.label) {
          case 0:
            if (l = this.parseRule(o.rules), a = null, !l) return [3, 6];
            s = 0, p.label = 1;
          case 1:
            return s < l.length ? (i = l[s], c = i.split(":"), u = c[0], d = c[1], (f = this.validateModel.get(u)) || Jt("validator", "{".concat(u, "} rule not registered.")), h = !0, f.regexp && (h = this.regexpValidateHandler(t, f.regexp)), f.validator ? (h = (b = f.validator) === null || b === void 0 ? void 0 : b.call(f, t, Me(Me({}, r), { ruleValue: this.formatRuleParams(d), linkField: this.formatLinkField(d) })), co(h) ? [4, (k = f.validator) === null || k === void 0 ? void 0 : k.call(f, t, Me(Me({}, r), { ruleValue: this.formatRuleParams(d), linkField: this.formatLinkField(d) }))] : [3, 3]) : [3, 3]) : [3, 5];
          case 2:
            h = p.sent(), p.label = 3;
          case 3:
            if (!h) return a = this.formatMessage(f.message, n, { ruleParams: this.formatRuleParams(d), paramsEnum: f.paramsEnum, context: r }), [3, 5];
            p.label = 4;
          case 4:
            return s++, [3, 1];
          case 5:
            return [2, a === null || a];
          case 6:
            return [2, !0];
        }
      });
    });
  }, e.prototype.convertDataToMap = function(t) {
    var n = /* @__PURE__ */ new Map();
    return t.forEach(function(o) {
      !o.matrix && n.set(o.dataKey, o);
    }), n;
  }, e.prototype.singleValidate = function(t, n, o) {
    return gt(this, void 0, void 0, function() {
      var r, l, a, s, i, c, u, d, f, h, b, k, p, w, _;
      return yt(this, function(v) {
        switch (v.label) {
          case 0:
            if (r = t.dataKey, l = t.value, a = function(M, E) {
              var L = {};
              for (var m in M) Object.prototype.hasOwnProperty.call(M, m) && E.indexOf(m) < 0 && (L[m] = M[m]);
              if (M != null && typeof Object.getOwnPropertySymbols == "function") {
                var $ = 0;
                for (m = Object.getOwnPropertySymbols(M); $ < m.length; $++) E.indexOf(m[$]) < 0 && Object.prototype.propertyIsEnumerable.call(M, m[$]) && (L[m[$]] = M[m[$]]);
              }
              return L;
            }(t, ["value"]), s = (_ = t.label) !== null && _ !== void 0 ? _ : r, !t.matrix) return [3, 7];
            i = t.value, c = i.columns, u = i.data, d = {}, f = 0, v.label = 1;
          case 1:
            if (!(f < u.length)) return [3, 6];
            for (h = u[f], b = [], k = 0; k < c.length; k++) p = c[k], b.push(Me(Me({}, p), { rowId: h.rowId, matrixId: t.matrixId, value: h[p.dataKey] }));
            v.label = 2;
          case 2:
            return v.trys.push([2, 4, , 5]), [4, this.validate(b)];
          case 3:
            return v.sent(), [3, 5];
          case 4:
            return w = v.sent(), Object.assign(d, w), [3, 5];
          case 5:
            return f++, [3, 1];
          case 6:
            return [2, d];
          case 7:
            return t.required && Pe(l) ? [2, this.formatMessage(this.validateModel.get("required").message, s)] : a.regexp || a.validator ? [2, this.scopeValidateHandler(l, a, { data: n, dataKeyMap: o })] : [4, this.validateHandler(l, s, a, { data: n, dataKeyMap: o })];
          case 8:
            return [2, v.sent()];
        }
      });
    });
  }, e.prototype.validate = function(t, n) {
    var o = this;
    return new Promise(function(r, l) {
      gt(o, void 0, void 0, function() {
        var a, s, i, c, u, d, f, h, b, k, p, w, _;
        return yt(this, function(v) {
          switch (v.label) {
            case 0:
              a = (n ?? {}).checkAll, s = a === void 0 || a, i = {}, c = this.convertDataToMap(t), u = 0, v.label = 1;
            case 1:
              return u < t.length ? (d = t[u], [4, this.singleValidate(d, t, c)]) : [3, 4];
            case 2:
              f = v.sent(), this.isValidateFail(f) && (b = (h = d).matrixId, k = h.rowId, s || l(((p = {})[d.dataKey] = f, p)), b ? hn(f) ? Object.assign(i, f) : Object.assign(i, ((w = {})["".concat(b, ".").concat(k, ".").concat(d.dataKey)] = f, w)) : Object.assign(i, ((_ = {})[d.dataKey] = f, _))), v.label = 3;
            case 3:
              return u++, [3, 1];
            case 4:
              return s && hn(i) && !Pe(i) && l(i), r(!0), [2];
          }
        });
      });
    });
  }, e;
}(), pn = new zc();
const qc = "zh-CN", Gc = {
  required: "{#field}不能为空",
  email: "{#field}格式错误",
  length: "{#field}长度必须为{length}",
  min_length: "{#field}长度不能小于{length}",
  max_length: "{#field}长度不能大于{length}",
  min: "{#field}不能小于{min}",
  max: "{#field}不能大于{max}",
  number: "{#field}只能包含数字",
  integer: "{#field}不是一个整数",
  float: "{#field}不是一个浮点数",
  between: "{#field}必须在{min}与{max}之间",
  confirmed: "{#field}与{target}不匹配",
  alpha: "{#field}只能包含字母字符",
  alpha_num: "{#field}只能包含字母数字字符",
  alpha_spaces: "{#field}只能包含字母字符和空格",
  url: "{#field}不是合格的 URL"
}, Vc = {
  code: qc,
  message: Gc
};
pn.localize(Vc);
function Yc(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var br = { exports: {} };
(function(e) {
  var t = Object.prototype.hasOwnProperty, n = "~";
  function o() {
  }
  Object.create && (o.prototype = /* @__PURE__ */ Object.create(null), new o().__proto__ || (n = !1));
  function r(i, c, u) {
    this.fn = i, this.context = c, this.once = u || !1;
  }
  function l(i, c, u, d, f) {
    if (typeof u != "function")
      throw new TypeError("The listener must be a function");
    var h = new r(u, d || i, f), b = n ? n + c : c;
    return i._events[b] ? i._events[b].fn ? i._events[b] = [i._events[b], h] : i._events[b].push(h) : (i._events[b] = h, i._eventsCount++), i;
  }
  function a(i, c) {
    --i._eventsCount === 0 ? i._events = new o() : delete i._events[c];
  }
  function s() {
    this._events = new o(), this._eventsCount = 0;
  }
  s.prototype.eventNames = function() {
    var c = [], u, d;
    if (this._eventsCount === 0) return c;
    for (d in u = this._events)
      t.call(u, d) && c.push(n ? d.slice(1) : d);
    return Object.getOwnPropertySymbols ? c.concat(Object.getOwnPropertySymbols(u)) : c;
  }, s.prototype.listeners = function(c) {
    var u = n ? n + c : c, d = this._events[u];
    if (!d) return [];
    if (d.fn) return [d.fn];
    for (var f = 0, h = d.length, b = new Array(h); f < h; f++)
      b[f] = d[f].fn;
    return b;
  }, s.prototype.listenerCount = function(c) {
    var u = n ? n + c : c, d = this._events[u];
    return d ? d.fn ? 1 : d.length : 0;
  }, s.prototype.emit = function(c, u, d, f, h, b) {
    var k = n ? n + c : c;
    if (!this._events[k]) return !1;
    var p = this._events[k], w = arguments.length, _, v;
    if (p.fn) {
      switch (p.once && this.removeListener(c, p.fn, void 0, !0), w) {
        case 1:
          return p.fn.call(p.context), !0;
        case 2:
          return p.fn.call(p.context, u), !0;
        case 3:
          return p.fn.call(p.context, u, d), !0;
        case 4:
          return p.fn.call(p.context, u, d, f), !0;
        case 5:
          return p.fn.call(p.context, u, d, f, h), !0;
        case 6:
          return p.fn.call(p.context, u, d, f, h, b), !0;
      }
      for (v = 1, _ = new Array(w - 1); v < w; v++)
        _[v - 1] = arguments[v];
      p.fn.apply(p.context, _);
    } else {
      var M = p.length, E;
      for (v = 0; v < M; v++)
        switch (p[v].once && this.removeListener(c, p[v].fn, void 0, !0), w) {
          case 1:
            p[v].fn.call(p[v].context);
            break;
          case 2:
            p[v].fn.call(p[v].context, u);
            break;
          case 3:
            p[v].fn.call(p[v].context, u, d);
            break;
          case 4:
            p[v].fn.call(p[v].context, u, d, f);
            break;
          default:
            if (!_) for (E = 1, _ = new Array(w - 1); E < w; E++)
              _[E - 1] = arguments[E];
            p[v].fn.apply(p[v].context, _);
        }
    }
    return !0;
  }, s.prototype.on = function(c, u, d) {
    return l(this, c, u, d, !1);
  }, s.prototype.once = function(c, u, d) {
    return l(this, c, u, d, !0);
  }, s.prototype.removeListener = function(c, u, d, f) {
    var h = n ? n + c : c;
    if (!this._events[h]) return this;
    if (!u)
      return a(this, h), this;
    var b = this._events[h];
    if (b.fn)
      b.fn === u && (!f || b.once) && (!d || b.context === d) && a(this, h);
    else {
      for (var k = 0, p = [], w = b.length; k < w; k++)
        (b[k].fn !== u || f && !b[k].once || d && b[k].context !== d) && p.push(b[k]);
      p.length ? this._events[h] = p.length === 1 ? p[0] : p : a(this, h);
    }
    return this;
  }, s.prototype.removeAllListeners = function(c) {
    var u;
    return c ? (u = n ? n + c : c, this._events[u] && a(this, u)) : (this._events = new o(), this._eventsCount = 0), this;
  }, s.prototype.off = s.prototype.removeListener, s.prototype.addListener = s.prototype.on, s.prefixed = n, s.EventEmitter = s, e.exports = s;
})(br);
var Wc = br.exports;
const Uc = /* @__PURE__ */ Yc(Wc);
class Hc extends Uc {
  constructor() {
    super(...arguments);
    W(this, "queueTask", /* @__PURE__ */ new Map());
  }
  /**
   * 可对支持被拦截的事件，进行拦截
   * @param eventName 事件名
   * @param task 任务
   */
  proxy(n, o) {
    typeof o != "function" && on(hr, "The proxy must be a function.");
    const r = this.queueTask.get(n);
    return r ? r.add(o) : this.queueTask.set(n, /* @__PURE__ */ new Set([o])), this;
  }
  /**
   * 取消拦截器
   * @param eventName
   * @param task
   */
  removeProxy(n, o) {
    var r;
    return (r = this.queueTask.get(n)) == null || r.delete(o), this;
  }
  /**
   * 执行事件
   * @param eventName 事件名
   * @param args 需要传递给拦截器的参数
   * @example
   * events.executeProxy('eventName', a, b, c)
   *   .then((value: SuccessType) => { console.log(value) })
   *   .catch((error: FailType) => { console.log(error) })
   */
  executeProxy(n, ...o) {
    return new Promise(
      async (r, l) => {
        const a = Array.from(this.queueTask.get(n) ?? []);
        if (a.length)
          for (let s = 0; s < a.length; s++)
            try {
              const i = await a[s](...o);
              i !== !0 && l(i);
            } catch (i) {
              l(i);
            }
        r(!0);
      }
    );
  }
  destroy() {
    this.queueTask.clear(), this.removeAllListeners();
  }
}
var Be = /* @__PURE__ */ ((e) => (e.EQUAL = "equal", e.NOT_EQUAL = "not_equal", e.NULL = "null", e.NOT_NULL = "not_null", e.IN = "in", e.NOT_IN = "not_in", e))(Be || {}), Ie = /* @__PURE__ */ ((e) => (e.EDIT = "edit", e.DISPLAY = "display", e.HIDE = "hide", e.READONLY = "readonly", e.DISABLED = "disabled", e.REQUIRED = "required", e))(Ie || {}), mn = /* @__PURE__ */ ((e) => (e.ANY = "any", e.ALL = "all", e))(mn || {}), Ct = /* @__PURE__ */ ((e) => (e.CONSTANT = "constant", e.VARIABLE = "variable", e))(Ct || {});
class uo {
  constructor(t) {
    // 显示集合
    W(this, "displayMap", oe(/* @__PURE__ */ new Map()));
    // 只读集合
    W(this, "readonlyMap", oe(/* @__PURE__ */ new Map()));
    // 只读集合
    W(this, "disabledMap", oe(/* @__PURE__ */ new Map()));
    // 必填集合
    W(this, "requiredMap", oe(/* @__PURE__ */ new Map()));
    W(this, "formStore");
    // 所有需要执行联动的 id 列表
    W(this, "triggerIdList", []);
    W(this, "linageList", []);
    W(this, "getDisabled", (t) => this.formStore.formDisabled.value || this.disabledMap.get(t));
    this.formStore = t;
  }
  init(t) {
    ie(t) || (this.linageList = t, t.forEach((n) => {
      n.conditionList.forEach((o) => {
        o.details.forEach((r) => {
          this.triggerIdList.push(r.triggerId);
        });
      });
    }));
  }
  /**
   * 执行联动
   * @param dataKey
   * @param value
   */
  execute(t, n) {
    if (!this.triggerIdList.includes(t)) return;
    const o = {
      [mn.ANY]: "some",
      [mn.ALL]: "every"
    };
    this.linageList.forEach((r) => {
      r.conditionList.forEach((l) => {
        const a = l.details[o[l.condition]]((s) => {
          const i = s.triggerId === t ? n : this.formStore.getFieldValue(s.triggerId), c = Ct.CONSTANT && s, u = Ct.VARIABLE && s, d = s.type === Ct.CONSTANT ? c.constants : this.formStore.getFieldValue(u.variableId);
          return this.compare(s, d, i);
        });
        return this.trigger(r.linkageList, a);
      });
    }), this.formStore.events.emit(`${st.LINKAGE}.afterExecute`, !0);
  }
  setDisplay(t, n) {
    this.displayMap.set(t, n);
  }
  setReadonly(t, n) {
    this.readonlyMap.set(t, n);
  }
  setDisabled(t, n) {
    this.disabledMap.set(t, n);
  }
  setRequired(t, n) {
    this.requiredMap.set(t, n);
  }
  getRequired(t) {
    return this.requiredMap.get(t);
  }
  getDisplay(t) {
    const n = this.formStore.getParents(t);
    if (n.length) {
      for (let o = 0; o < n.length; o++)
        if (!this.displayMap.get(n[o].id)) return !1;
    }
    return this.displayMap.get(t);
  }
  getReadonly(t) {
    return this.formStore.formReadonly.value || this.readonlyMap.get(t);
  }
  compare(t, n, o) {
    switch (t.symbol) {
      case Be.EQUAL:
        return Mt(n, o);
      case Be.NOT_EQUAL:
        return !Mt(n, o);
      case Be.NULL:
        return ie(o);
      case Be.NOT_NULL:
        return !ie(o);
      case Be.IN:
        return this.compareIn(o, n);
      case Be.NOT_IN:
        return !this.compareIn(o, n);
    }
  }
  trigger(t, n) {
    t.forEach((o) => {
      switch (o.propKey) {
        case Ie.REQUIRED:
          this.setRequired(o.targetId, n);
          break;
        case Ie.DISABLED:
          this.setDisabled(o.targetId, n);
          break;
        case Ie.HIDE:
          this.setDisplay(o.targetId, !n);
          break;
        case Ie.READONLY:
          this.setReadonly(o.targetId, n);
          break;
        case Ie.DISPLAY:
          this.setDisplay(o.targetId, n);
          break;
        case Ie.EDIT:
          this.setDisabled(o.targetId, !n), this.setReadonly(o.targetId, !n);
          break;
      }
    });
  }
  compareIn(t, n) {
    return ie(n) ? !1 : Array.isArray(t) && Array.isArray(n) ? t.some((o) => me(o) && n.findIndex((r) => r.value === o.value) > -1 ? !0 : n.includes(o)) : me(t) ? Object.keys(t).every((o) => t[o] === n[o]) : `${t}`.includes(`${n}`);
  }
}
class Kc {
  constructor(t) {
    W(this, "formStore");
    /**
     * 所有明细表数据
     * key 为 IDetailTableItem.detailTableId
     */
    W(this, "tableData", oe(/* @__PURE__ */ new Map()));
    this.formStore = t;
  }
  /**
   * 是否为空表
   * @param tableId
   */
  isEmptyTable(t) {
    var n;
    return (((n = this.tableData.get(t)) == null ? void 0 : n.size) ?? 0) === 0;
  }
  /**
   * 批量更新明细表数据
   * @param tableId
   * @param tableData
   */
  updateTableData(t, n) {
    const o = this.getTableData(t);
    if (o)
      o.clear(), n.forEach((r, l) => {
        o.set(r.rowId, { ...r, dataIndex: l });
      });
    else {
      const r = /* @__PURE__ */ new Map();
      n.forEach((l, a) => {
        r.set(l.rowId, { ...l, dataIndex: a });
      }), this.tableData.set(t, r);
    }
  }
  /**
   * 获取明细表单个字段数据
   * @param tableId 明细表 id
   * @param rowId 明细行行 id
   * @param dataKey 数据 key
   */
  getFieldValue(t, n, o) {
    var r, l;
    return (l = (r = this.getTableData(t)) == null ? void 0 : r.get(n)) == null ? void 0 : l[o];
  }
  /**
   * 明细表初始化时，创建空表数据
   * @param tableId
   */
  createEmptyData(t) {
    this.tableData.set(t, /* @__PURE__ */ new Map());
  }
  /**
   * 添加行数据
   * @param tableId 明细表 id
   * @param rowData 行数据
   */
  addRow(t, n) {
    const o = this.getTableData(t), r = this.formStore.idGenerator();
    o == null || o.set(r, {
      ...n,
      rowId: r,
      dataIndex: o.size + 1
    });
  }
  /**
   * 插入行
   * @param tableId 明细表 id
   * @param dataIndex 行号
   * @param rowData 行数据
   */
  insertRow(t, n, o) {
    const r = this.getTableData(t);
    this.getTableData(t, !0).toSpliced(
      n,
      0,
      o || { rowId: this.formStore.idGenerator() }
    ).forEach((a, s) => {
      r.set(a.rowId, { ...a, dataIndex: s });
    });
  }
  /**
   * 更新明细表行数据
   * @param tableId 明细表 id
   * @param rowId 行 id
   * @param value 当前组件数据
   * @param dataKey 当前组件 dataKey
   */
  upsert(t, n, o, r) {
    const l = this.getTableData(t);
    if (!l) return on("DetailTable", "未找到对应的明细表");
    const a = l.get(n);
    if (a)
      l.set(n, {
        ...a,
        [r]: o
      });
    else {
      const s = this.formStore.idGenerator();
      l.set(s, {
        rowId: s,
        dataIndex: l.size,
        [r]: o
      });
    }
  }
  /**
   * 删除行数据
   * @param tableId 明细表 id
   * @param rowId 行 id
   */
  deleteRow(t, n) {
    var o;
    (o = this.getTableData(t)) == null || o.delete(n);
  }
  /**
   * 复制行数据
   * @param tableId 明细表 id
   * @param rowId 行 id
   */
  copyRow(t, n) {
    var r;
    const o = (r = this.getTableData(t)) == null ? void 0 : r.get(n);
    if (!o) return on("DetailTable", "未找到对应的明细行数据");
    this.addRow(t, kn(o));
  }
  getTableData(t, n = !1) {
    var o;
    return n ? Array.from(((o = this.tableData.get(t)) == null ? void 0 : o.values()) ?? []).toSorted(
      (r, l) => r.dataIndex - l.dataIndex
    ) : this.tableData.get(t);
  }
  /**
   * 获取转换后的明细表数据
   */
  getTableDataConverted() {
    const t = {};
    return Array.from(this.tableData.keys()).forEach((n) => {
      t[n] = this.getTableData(n, !0);
    }), t;
  }
}
const Xc = (e) => {
  const {
    id: t,
    label: n,
    labelWidth: o,
    hideLabel: r,
    component: l,
    layout: a,
    display: s,
    disabled: i,
    readonly: c,
    dataKey: u,
    value: d,
    required: f,
    rules: h,
    errorMessage: b,
    description: k,
    ...p
  } = e;
  return p;
}, en = (e, t, n) => t ? `${t}.${n}.${e}` : e, Zc = (e) => e.detailTableId && e.componentType !== "DetailTable";
class gr {
  constructor() {
    /**
     * 表单数据模型
     */
    W(this, "models", oe(/* @__PURE__ */ new Map()));
    /**
     * dataKey 映射 id 对应关系
     * @private
     */
    W(this, "dataKeyMap", /* @__PURE__ */ new Map());
    /**
     * 明细表 id 映射 id 对应关系
     * @private
     */
    W(this, "tableIdMap", /* @__PURE__ */ new Map());
    /**
     * 表单原始数据
     */
    W(this, "originalModel", []);
    /**
     * 校验失败错误信息
     */
    W(this, "errorMessages", oe({}));
    /**
     * 组件关系
     * key：id
     * value 子级集合
     */
    W(this, "compRelationship", oe(/* @__PURE__ */ new Map()));
    /**
     * 表单数据
     * @private
     */
    W(this, "mainFormData", oe({}));
    /**
     * 表单禁用
     */
    W(this, "formDisabled", X(!1));
    /**
     * 表单只读
     */
    W(this, "formReadonly", X(!1));
    /**
     * 事件中心
     */
    W(this, "events", new Hc());
    /**
     * 显示属性联动 store
     */
    W(this, "viewLinkageStore", new uo(this));
    /**
     * 明细表数据
     */
    W(this, "detailTableStore", new Kc(this));
    /**
     * id 生成器
     */
    W(this, "idGenerator", Oe);
    /**
     * 通过 dataKey 获取 model id
     * @param dataKey
     */
    W(this, "getModelIdByDataKey", (t) => this.dataKeyMap.get(t) || t);
    /**
     * 获取表单模型
     */
    W(this, "getFormModels", () => this.convertModel());
    /**
     * 转换表单模型
     */
    W(this, "convertModel", () => Array.from(this.models.values()));
  }
  /**
   * 初始化表单
   * @param options - 初始化选项
   * @param options.models - 表单模型
   * @param options.viewLinkage - 视图联动类型
   */
  init(t) {
    this.updateModels(t), this.events.emit(`${st.FORM}.ready`, this);
  }
  /**
   * 更新单个字段数据
   * @param dataKey
   * @param value
   * @param rowId
   * @deprecated 主版本发布后废弃，改为 updateFieldValue
   */
  updateSingleValue(t, n, o) {
    this.updateFieldValue(t, n, o);
  }
  /**
   * 更新单个字段数据
   * @param dataKey
   * @param value
   * @param rowId
   */
  updateFieldValue(t, n, o) {
    if (o) {
      const r = this.getDetailTableId(t);
      this.detailTableStore.upsert(r, o, n, t);
    } else
      Object.assign(this.mainFormData, { [t]: n }), this.viewLinkageStore.execute(t, n);
  }
  /**
   * 更新多个字段数据，默认会执行校验
   * @param data
   * @param validate 是否执行校验
   */
  updateData(t, n = !0) {
    if (t) {
      for (const [o, r] of Object.entries(t))
        this.tableIdMap.get(o) ? this.detailTableStore.updateTableData(o, r) : this.updateFieldValue(o, r);
      n && this.validate();
    }
  }
  /**
   * 更新表单模型
   * @param id - 组件 ID
   * @param item - 组件模型
   */
  updateModel(t, n) {
    const o = this.getModel(t);
    o && (Object.assign(o, n), this.models.set(this.getModelIdByDataKey(t), o));
  }
  /**
   * 更新表单模型
   * @param options - 初始化选项
   * @param options.models - 表单模型
   * @param options.viewLinkage - 视图联动类型
   */
  updateModels(t) {
    this.clear();
    const { models: n, viewLinkage: o } = t;
    this.originalModel = kn(n), n.forEach((r) => {
      var a;
      const l = this.compRelationship.get(r.layout.parent);
      l ? l.push(r.id) : this.compRelationship.set(r.layout.parent, [r.id]), r.detailTableId && r.componentType === "DetailTable" && this.tableIdMap.set(r.detailTableId, r.id), this.models.set(r.id, {
        ...r,
        display: ie(r.display) ? !0 : r.display,
        component: me(r.component) ? bo(r.component) : r.component
      }), this.setDisplay(r.id, r.display ?? !0), this.setRequired(
        r.id,
        r.required ?? ((a = r.rules) == null ? void 0 : a.includes("required")) ?? !1
      ), r.dataKey && (Zc(r) || Object.assign(this.mainFormData, { [r.dataKey]: r.value }), this.dataKeyMap.set(r.dataKey, r.id), this.setReadonly(r.id, r.readonly ?? !1), this.setDisabled(r.id, r.disabled ?? !1));
    }), this.viewLinkageStore.init(o || []);
  }
  /**
   * 获取单个 item 信息
   * @param id
   * @deprecated 主版本发布后废弃，改为 getModel
   */
  getItem(t) {
    return this.getModel(t);
  }
  /**
   * 获取单个 model 信息
   * @param id
   */
  getModel(t) {
    return this.models.get(this.dataKeyMap.get(t) || t);
  }
  /**
   * 获取明细表信息
   * @param tableId 明细表 id
   */
  getModelByTableId(t) {
    return this.models.get(this.tableIdMap.get(t));
  }
  /**
   * 获取子级集合
   * @param parentId 父级 id
   */
  getChildren(t) {
    const n = this.compRelationship.get(t);
    return n ? n.map((o) => this.getModel(o)) : [];
  }
  /**
   * 获取父级信息
   * @param id
   */
  getParent(t) {
    var n;
    return this.getModel((n = this.getModel(this.getModelIdByDataKey(t))) == null ? void 0 : n.layout.parent);
  }
  /**
   * 获取父级集合
   * @param id
   */
  getParents(t) {
    const n = [];
    let o = this.getParent(t);
    for (; o; )
      n.push(o), o = this.getParent(o.id);
    return n;
  }
  /**
   * 获取明细表 id
   * @param id
   */
  getDetailTableId(t) {
    return this.getModel(t).detailTableId;
  }
  /**
   * 获取单个字段 value
   * @param dataKey
   * @param rowId
   */
  getFieldValue(t, n) {
    const o = this.getModel(this.getModelIdByDataKey(t));
    if (n) {
      const r = this.getDetailTableId(t);
      return this.detailTableStore.getFieldValue(r, n, t);
    }
    if (o && o.isVirtualKey && o.valueItems) {
      const r = o.valueItems.reduce((l, a) => (this.mainFormData[a] === void 0 || (l[a] = this.mainFormData[a]), l), {});
      return ie(r) ? void 0 : r;
    }
    return this.mainFormData[t];
  }
  /**
   * 获取单个字段 value
   * @param dataKey
   * @param rowId
   * @deprecated 主版本发布后去除，需要改为 getFieldValue
   */
  getSingleValue(t, n) {
    return this.getFieldValue(t, n);
  }
  /**
   * 获取表单数据
   */
  getFormData() {
    return {
      ...this.mainFormData,
      ...this.detailTableStore.getTableDataConverted()
    };
  }
  /**
   * 设置显示隐藏
   * @param id
   * @param value
   */
  setDisplay(t, n) {
    this.viewLinkageStore.setDisplay(t, n);
  }
  /**
   * 设置只读
   * @param id
   * @param value
   */
  setReadonly(t, n) {
    this.viewLinkageStore.setReadonly(t, n);
  }
  /**
   * 设置禁用
   * @param id
   * @param value
   */
  setDisabled(t, n) {
    this.viewLinkageStore.setDisabled(t, n);
  }
  /**
   * 设置必填
   * @param id
   * @param value
   */
  setRequired(t, n) {
    this.viewLinkageStore.setRequired(t, n);
  }
  /**
   * 设置整表禁用
   * @param value
   */
  setFormDisabled(t) {
    this.formDisabled.value = t;
  }
  /**
   * 设置整表只读
   * @param value
   */
  setFormReadonly(t) {
    this.formReadonly.value = t;
  }
  /**
   * 表单重置
   */
  reset() {
    this.originalModel.forEach((t) => {
      t.dataKey && (t.isVirtualKey && t.valueItems ? t.valueItems.forEach((n) => {
        var o;
        this.updateFieldValue(
          n,
          me(t.value) ? (o = t.value) == null ? void 0 : o[n] : void 0
        );
      }) : this.updateFieldValue(t.dataKey, t.value));
    }), this.clearMessages();
  }
  /**
   * 表单校验
   */
  validate() {
    return new Promise((t, n) => {
      const o = [];
      this.convertModel().forEach((r) => {
        var a;
        if (!r.dataKey && r.componentType !== "DetailTable" || r.detailTableId && r.componentType !== "DetailTable" || !this.viewLinkageStore.getDisplay(r.id) || this.viewLinkageStore.getDisabled(r.id) || this.viewLinkageStore.getReadonly(r.id))
          return;
        const l = {
          ...r,
          value: this.getFieldValue(r.dataKey),
          required: this.viewLinkageStore.getRequired(r.id)
        };
        r.componentType === "DetailTable" && Object.assign(l, {
          matrix: r.componentType === "DetailTable",
          matrixId: r.detailTableId,
          value: {
            columns: this.getChildren(r.id),
            data: Array.from(
              ((a = this.detailTableStore.getTableData(r.detailTableId)) == null ? void 0 : a.values()) ?? []
            )
          }
        }), o.push(l);
      }), pn.validate(o).then(() => {
        this.clearMessages(), t(!0);
      }).catch((r) => {
        this.clearMessages(), Object.assign(this.errorMessages, r), n(r);
      });
    });
  }
  /**
   * 单个校验
   * @param dataKey 数据键名
   * @param detailTableId
   * @param rowId
   */
  singleValidate(t, n, o) {
    return new Promise((r, l) => {
      const a = {
        ...this.getModel(t),
        value: this.getFieldValue(t),
        required: this.viewLinkageStore.getRequired(t)
      };
      n && Object.assign(a, {
        ...this.getModel(t),
        value: this.getFieldValue(t, o)
      }), a && pn.validate([a]).then(() => {
        this.errorMessages[en(t, n, o)] = "", r("");
      }).catch((s) => {
        this.errorMessages[en(t, n, o)] = s[t], l(s[t]);
      }), r("");
    });
  }
  /**
   * 获取单个字段的错误信息
   * @param dataKey 数据键名
   * @param detailTableId 明细表 id
   * @param rowId 明细表行数据 id
   */
  getSingleMessage(t, n, o) {
    return this.errorMessages[en(t, n, o)];
  }
  /**
   * 清空所有校验信息
   */
  clearMessages() {
    Object.keys(this.errorMessages).forEach((t) => this.errorMessages[t] = "");
  }
  destroy() {
    this.clear(), this.events.destroy();
  }
  /**
   * 清理 store 相关数据
   */
  clear() {
    this.models.clear(), this.compRelationship.clear(), this.dataKeyMap = /* @__PURE__ */ new Map(), this.tableIdMap = /* @__PURE__ */ new Map(), this.originalModel = [], this.errorMessages = oe({}), this.mainFormData = oe({}), this.viewLinkageStore = new uo(this);
  }
}
const Se = (e) => {
  const { store: t } = Fe(Fn);
  return q(() => t.getChildren(e));
}, it = () => Fe(Fn, null), xc = (e) => {
  try {
    const { store: t } = it(), n = e.dataKey || e.id;
    return (o, r, l) => {
      t.events.emit(`${st.FIELD}.${n}.${o}`, r, l);
    };
  } catch {
    return;
  }
}, Qc = (e, t) => {
  const { store: n } = it();
  n.events.on(e, t), bn(() => {
    n.events.off(e, t);
  });
}, yr = (e) => ({
  on: Qc,
  emit: xc(e)
}), [Jc] = V("form-item"), eu = G({
  name: Jc,
  components: { DCell: ur },
  props: {
    model: {
      type: Object,
      required: !0,
      default: () => ({})
    },
    rowId: {
      type: String,
      default: void 0
    }
  },
  emits: ["change"],
  setup(e, { emit: t }) {
    const { store: n, formProps: o, onChange: r } = it(), { emit: l } = yr(e.model), a = e.model.detailTableId, s = e.rowId, i = e.model.dataKey, c = We("item"), u = We("item-message"), d = We("item-requiredMark"), f = We("item-colon"), h = We("item-description"), b = q(() => n.viewLinkageStore.getRequired(e.model.id)), k = q(() => n.getSingleMessage(i, a, s));
    return {
      itemClassName: c,
      errorClassName: u,
      requiredMarkClassName: d,
      colonClass: f,
      descriptionClass: h,
      showRequiredMark: b,
      errorMessage: k,
      formProps: o,
      store: n,
      omitSystemProps: Xc,
      handleChange: (w, _) => {
        e.model.controlled !== !0 && (_ || e.model.isVirtualKey ? (n.updateData(w, !1), r(w, e.model, s)) : (n.updateFieldValue(i, w, s), k.value && n.singleValidate(i, a, s), r({ [i]: w }, e.model, s))), t("change", w, s), n.events.emit(`${st.FIELD}.change`, w, e.model, s), l("change", w, s);
      }
    };
  }
}), tu = { key: 2 };
function nu(e, t, n, o, r, l) {
  const a = P("d-cell");
  return e.store.viewLinkageStore.getDisplay(e.model.id) ? (C(), T(J, { key: 0 }, [
    e.model.dataKey && e.model.layout.container !== !1 ? (C(), F(a, {
      key: 0,
      class: B(e.itemClassName),
      colon: e.formProps.colon,
      round: e.formProps.round,
      border: e.formProps.border,
      arrow: e.model.layout.showArrow,
      suffix: e.model.layout.suffix,
      description: e.formProps.useCustomDescription ? void 0 : e.model.description,
      "client-type": e.formProps.clientType,
      layout: e.model.layout.layout || e.formProps.layout,
      "hide-title": e.formProps.hideLabel || e.model.hideLabel,
      "title-vertical-center": e.model.layout.titleVerticalCenter,
      "title-width": e.model.layout.labelWidth || e.formProps.labelWidth,
      "content-align": e.model.layout.contentAlign || e.formProps.contentAlign
    }, {
      title: le(() => {
        var s, i;
        return [
          e.showRequiredMark && e.formProps.requiredMarkPosition === "left" ? (C(), T("span", {
            key: 0,
            class: B(e.requiredMarkClassName)
          }, "*", 2)) : z("", !0),
          e.formProps.renderFormLabel ? (C(), F(It(e.formProps.renderFormLabel((s = e.model) == null ? void 0 : s.label, e.model)), { key: 1 })) : (C(), T("span", tu, He((i = e.model) == null ? void 0 : i.label), 1)),
          e.formProps.colon ? (C(), T("span", {
            key: 3,
            class: B(e.colonClass)
          }, ":", 2)) : z("", !0),
          e.showRequiredMark && e.formProps.requiredMarkPosition === "right" ? (C(), T("span", {
            key: 4,
            class: B(e.requiredMarkClassName)
          }, "*", 2)) : z("", !0)
        ];
      }),
      default: le(() => [
        (C(), F(It(e.model.component), rt(e.omitSystemProps(e.model), {
          store: e.store,
          model: e.model,
          "row-id": e.rowId,
          "model-value": e.store.getFieldValue(e.model.dataKey, e.rowId),
          disabled: e.store.viewLinkageStore.getDisabled(e.model.id),
          readonly: e.store.viewLinkageStore.getReadonly(e.model.id),
          "onUpdate:modelValue": e.handleChange
        }), null, 16, ["store", "model", "row-id", "model-value", "disabled", "readonly", "onUpdate:modelValue"])),
        e.errorMessage ? (C(), T("p", {
          key: 0,
          class: B(e.errorClassName)
        }, He(e.errorMessage), 3)) : z("", !0)
      ]),
      _: 1
    }, 8, ["class", "colon", "round", "border", "arrow", "suffix", "description", "client-type", "layout", "hide-title", "title-vertical-center", "title-width", "content-align"])) : (C(), F(It(e.model.component), {
      key: 1,
      class: B(e.itemClassName),
      model: e.model,
      "row-id": e.rowId
    }, null, 8, ["class", "model", "row-id"]))
  ], 64)) : z("", !0);
}
const De = /* @__PURE__ */ Q(eu, [["render", nu]]), [ou, ru] = V("form-render"), lu = G({
  name: ou,
  components: {
    FormItem: De
  },
  setup() {
    const e = ru(), t = Se("root");
    return {
      wrapperClassName: e,
      children: t
    };
  }
});
function au(e, t, n, o, r, l) {
  const a = P("form-item");
  return C(), T("div", {
    class: B(e.wrapperClassName)
  }, [
    (C(!0), T(J, null, Le(e.children, (s) => (C(), F(a, {
      key: s.id,
      model: s
    }, null, 8, ["model"]))), 128))
  ], 2);
}
const su = /* @__PURE__ */ Q(lu, [["render", au]]), iu = G({
  name: hr,
  components: {
    FormRender: su
  },
  props: fr,
  emits: ["change"],
  setup(e, { emit: t }) {
    const n = e.store || new gr(), o = ze(
      [
        "colon",
        "requiredMarkPosition",
        "layout",
        "labelWidth",
        "clientType",
        "border",
        "round",
        "idGenerator",
        "renderFormLabel",
        "useCustomDescription"
      ],
      e
    ), r = q(
      () => We({
        "has-bg": e.hasBackground,
        [o.value.clientType.toLowerCase()]: !0,
        border: o.value.border ?? o.value.clientType === "MOBILE"
      })
    ), l = q(() => ({
      colon: o.value.colon,
      round: o.value.round,
      hideLabel: e.hideLabel,
      layout: o.value.layout,
      contentAlign: e.contentAlign,
      labelWidth: o.value.labelWidth,
      clientType: o.value.clientType,
      renderFormLabel: o.value.renderFormLabel,
      useCustomDescription: o.value.useCustomDescription,
      border: o.value.border ?? o.value.clientType === "MOBILE",
      requiredMarkPosition: o.value.requiredMarkPosition || yo
    }));
    return n.idGenerator = o.value.idGenerator, at(Fn, {
      store: n,
      formProps: l,
      onChange: (s, i) => {
        t("change", s, i);
      }
    }), ae(
      () => e.models,
      (s) => {
        n.init({
          models: s,
          viewLinkage: e.viewLinkage
        });
      },
      {
        immediate: !0
      }
    ), ae(
      () => e.data,
      (s) => n.updateData(s, !1),
      {
        immediate: !0
      }
    ), ae(() => e.disabled, n.setFormDisabled), ae(() => e.readonly, n.setFormReadonly), ae(() => e.viewLinkage, n.viewLinkageStore.init), bn(() => {
      n.destroy();
    }), {
      formClassName: r,
      store: n,
      formProps: l
    };
  }
}), cu = /* @__PURE__ */ U("button", {
  type: "submit",
  class: "d-hide"
}, null, -1);
function uu(e, t, n, o, r, l) {
  const a = P("form-render");
  return C(), T("form", {
    class: B(e.formClassName),
    onSubmit: t[0] || (t[0] = mo(() => {
    }, ["prevent"]))
  }, [
    cu,
    g(a)
  ], 34);
}
const du = /* @__PURE__ */ Q(iu, [["render", uu]]), [fu] = V("form-cell-group"), hu = G({
  name: fu,
  components: {
    DCellGroup: dr,
    DFormItem: De
  },
  props: {
    model: {
      type: Object,
      default: () => ({})
    }
  },
  setup(e) {
    return {
      children: Se(e.model.id)
    };
  }
});
function pu(e, t, n, o, r, l) {
  const a = P("d-form-item"), s = P("d-cell-group");
  return C(), F(s, {
    title: e.model.label
  }, {
    default: le(() => [
      (C(!0), T(J, null, Le(e.children, (i) => (C(), F(a, {
        key: i.dataKey,
        model: i
      }, null, 8, ["model"]))), 128))
    ]),
    _: 1
  }, 8, ["title"]);
}
const mu = /* @__PURE__ */ Q(hu, [["render", pu]]), [bu] = V("form-grid"), gu = G({
  name: bu,
  components: {
    FormItem: De,
    DGrid: Dn,
    DGridItem: et
  },
  props: {
    model: {
      type: Object,
      default: () => ({})
    }
  },
  setup(e) {
    return {
      children: Se(e.model.id)
    };
  }
});
function yu(e, t, n, o, r, l) {
  const a = P("form-item"), s = P("d-grid-item"), i = P("d-grid");
  return C(), F(i, {
    columns: e.model.layout.columns,
    rows: e.model.layout.rows,
    gap: e.model.layout.gap,
    "row-gap": e.model.layout.rowGap,
    "column-gap": e.model.layout.columnGap
  }, {
    default: le(() => [
      (C(!0), T(J, null, Le(e.children, (c) => (C(), F(s, {
        key: c.id,
        row: c.layout.row,
        column: c.layout.column,
        height: c.layout.height
      }, {
        default: le(() => [
          g(a, { model: c }, null, 8, ["model"])
        ]),
        _: 2
      }, 1032, ["row", "column", "height"]))), 128))
    ]),
    _: 1
  }, 8, ["columns", "rows", "gap", "row-gap", "column-gap"]);
}
const vu = /* @__PURE__ */ Q(gu, [["render", yu]]), [wu, Cu] = V("detail-table"), ku = G({
  name: wu,
  props: {
    model: {
      type: Object,
      default: () => ({})
    },
    defaultRows: {
      type: Number,
      default: 0
    }
  },
  setup(e) {
    const t = e.model.detailTableId, { store: n } = it();
    return n.detailTableStore.isEmptyTable(t) && (n.detailTableStore.createEmptyData(t), e.defaultRows && n.detailTableStore.isEmptyTable(t) && n.detailTableStore.updateTableData(
      t,
      Array.from({ length: e.defaultRows }).map((o, r) => ({
        rowId: n.idGenerator(),
        dataIndex: r
      }))
    )), {
      containerClassName: Cu()
    };
  }
});
function $u(e, t, n, o, r, l) {
  return C(), T("div", {
    class: B(e.containerClassName)
  }, [
    ne(e.$slots, "default")
  ], 2);
}
const Su = /* @__PURE__ */ Q(ku, [["render", $u]]), Et = Symbol("Layout"), [Mu, Ou] = V("layout"), _u = G({
  name: Mu,
  setup(e, t) {
    const n = X(0), o = X(""), r = oe(/* @__PURE__ */ new Map()), l = oe(/* @__PURE__ */ new Map()), a = X([]), s = {
      layout: Oe(8),
      "layout-header": Oe(8),
      "layout-footer": Oe(8),
      "layout-content": Oe(8)
    }, i = X(/* @__PURE__ */ new Map());
    return at(Et, {
      columns: n,
      getCollapsed: (f) => i.value.get(f) ?? !1,
      onColumnWidthChange: (f, h) => {
        r.set(f, h);
      },
      onCollapsedChange: (f, h) => {
        i.value.set(f, h);
      }
    }), ae(() => {
      var f, h;
      return (h = (f = t.slots).default) == null ? void 0 : h.call(f);
    }, (f) => {
      n.value = 0, l.clear(), r.clear(), a.value = jn(f).map((h) => {
        var p, w, _, v, M, E, L, m, $, O, S, R, D;
        const b = xr((p = h.type) == null ? void 0 : p.name), k = s[b] || Oe(8);
        switch (h.props = {
          ...h.props,
          layoutId: k,
          key: k
        }, b) {
          case "layout":
            n.value += 1, r.set(k, "1fr");
            break;
          case "layout-sider":
            n.value++, r.set(k, K((w = h.props) == null ? void 0 : w.width) || K((v = (_ = h.type.props) == null ? void 0 : _.width) == null ? void 0 : v.default) || "1fr"), l.set("layout-content", K((M = h.props) == null ? void 0 : M.height) || K((L = (E = h.type.props) == null ? void 0 : E.height) == null ? void 0 : L.default) || "1fr");
            break;
          case "layout-content":
            n.value += 2, r.set(k, "1fr 1fr"), l.set("layout-content", K((m = h.props) == null ? void 0 : m.height) || K((O = ($ = h.type.props) == null ? void 0 : $.height) == null ? void 0 : O.default) || "1fr");
            break;
          case "layout-header":
          case "layout-footer":
            l.set(b, K((S = h.props) == null ? void 0 : S.height) || K((D = (R = h.type.props) == null ? void 0 : R.height) == null ? void 0 : D.default) || "1fr");
            break;
        }
        return bo(h);
      }), o.value = Array.from(l.values()).join(" ");
    }, {
      immediate: !0
    }), () => g(Dn, {
      class: Ou(),
      rows: o.value,
      columns: Array.from(r.values()).join(" ") || n.value
    }, {
      default: () => [a.value]
    });
  }
}), Lu = {
  width: {
    type: [Number, String],
    default: 200
  },
  border: {
    type: Boolean,
    default: !0
  },
  /**
   * 是否开启折叠
   */
  collapsed: {
    type: Boolean,
    default: !1
  },
  /**
   * 折叠后宽度
   */
  collapsedWidth: {
    type: Number,
    default: 0
  },
  /**
   * 侧边栏位置
   */
  placement: {
    type: String,
    default: "left"
  },
  /**
   * 触发按钮距离顶部距离
   * 默认：50%
   */
  triggerTop: {
    type: [Number, String],
    default: "50%"
  },
  /**
   * 折叠事件
   */
  onCollapsed: {
    type: Function,
    default: void 0
  }
}, Tu = {
  height: {
    type: [Number, String],
    default: 50
  },
  border: {
    type: Boolean,
    default: !0
  }
}, Nu = {
  height: {
    type: [Number, String],
    default: 50
  },
  border: {
    type: Boolean,
    default: !0
  }
}, [Au, Ru] = V("layout-header"), Du = G({
  name: Au,
  props: Tu,
  setup(e, t) {
    const {
      columns: n
    } = Fe(Et);
    return () => g(et, {
      class: Ru({
        border: e.border
      }),
      column: n.value
    }, {
      default: () => {
        var o, r;
        return [(r = (o = t.slots).default) == null ? void 0 : r.call(o)];
      }
    });
  }
}), Eu = (e) => typeof e == "function" ? e() : e, Bu = (e, {
  slots: t
}) => {
  var n;
  return Eu(e.condition) ? (n = t.default) == null ? void 0 : n.call(t) : null;
}, Iu = (e, {
  slots: t
}) => g(Bu, e, {
  default: () => {
    var n;
    return [(n = t.default) == null ? void 0 : n.call(t)];
  }
}), [ju, tn] = V("layout-sider"), Pu = G({
  name: ju,
  props: Lu,
  emits: ["collapsed"],
  setup(e, t) {
    const {
      getCollapsed: n,
      onColumnWidthChange: o,
      onCollapsedChange: r
    } = Fe(Et), l = q(() => n(t.attrs.layoutId)), a = () => {
      const s = !l.value;
      o(t.attrs.layoutId, K(s ? e.collapsedWidth : e.width)), r(t.attrs.layoutId, s), t.emit("collapsed", s);
    };
    return () => g(et, {
      class: tn({
        border: e.border,
        collapsed: l.value,
        [`placement-${e.placement}`]: !0
      }),
      column: 1
    }, {
      default: () => {
        var s, i;
        return [g(Iu, {
          condition: e.collapsed
        }, {
          default: () => [g("span", {
            class: tn("trigger"),
            style: {
              top: K(e.triggerTop)
            }
          }, [g(Qs, {
            onClick: a
          }, null)])]
        }), g("div", {
          class: tn("content")
        }, [(i = (s = t.slots).default) == null ? void 0 : i.call(s)])];
      }
    });
  }
}), [Fu, zu] = V("layout-content"), qu = G({
  name: Fu,
  setup(e, t) {
    return () => g(et, {
      class: zu(),
      column: 2
    }, {
      default: () => {
        var n, o;
        return [(o = (n = t.slots).default) == null ? void 0 : o.call(n)];
      }
    });
  }
}), [Gu, Vu] = V("layout-footer"), Yu = G({
  name: Gu,
  props: Nu,
  setup(e, t) {
    const {
      columns: n
    } = Fe(Et);
    return () => g(et, {
      class: Vu({
        border: e.border
      }),
      column: n.value
    }, {
      default: () => {
        var o, r;
        return [(r = (o = t.slots).default) == null ? void 0 : r.call(o)];
      }
    });
  }
}), vr = Y(_u), wr = Y(Du), Cr = Y(Pu), kr = Y(qu), $r = Y(Yu), [Wu] = V("form-layout-header"), Uu = G({
  name: Wu,
  components: {
    FormItem: De
  },
  props: {
    model: {
      type: Object,
      default: () => ({})
    }
  },
  setup(e) {
    return {
      children: Se(e.model.id)
    };
  }
});
function Hu(e, t, n, o, r, l) {
  const a = P("form-item");
  return C(!0), T(J, null, Le(e.children, (s) => (C(), F(a, {
    key: s.id,
    model: s
  }, null, 8, ["model"]))), 128);
}
const Sr = /* @__PURE__ */ Q(Uu, [["render", Hu]]), [Ku] = V("form-layout-footer"), Xu = G({
  name: Ku,
  components: {
    FormItem: De
  },
  props: {
    model: {
      type: Object,
      default: () => ({})
    }
  },
  setup(e) {
    return {
      children: Se(e.model.id)
    };
  }
});
function Zu(e, t, n, o, r, l) {
  const a = P("form-item");
  return C(!0), T(J, null, Le(e.children, (s) => (C(), F(a, {
    key: s.id,
    model: s
  }, null, 8, ["model"]))), 128);
}
const Mr = /* @__PURE__ */ Q(Xu, [["render", Zu]]), [xu] = V("form-layout-sider"), Qu = G({
  name: xu,
  components: {
    FormItem: De
  },
  props: {
    model: {
      type: Object,
      default: () => ({})
    }
  },
  setup(e) {
    return {
      children: Se(e.model.id)
    };
  }
});
function Ju(e, t, n, o, r, l) {
  const a = P("form-item");
  return C(!0), T(J, null, Le(e.children, (s) => (C(), F(a, {
    key: s.id,
    model: s
  }, null, 8, ["model"]))), 128);
}
const Or = /* @__PURE__ */ Q(Qu, [["render", Ju]]), [ed] = V("form-layout-content"), td = G({
  name: ed,
  components: {
    FormItem: De
  },
  props: {
    model: {
      type: Object,
      default: () => ({})
    }
  },
  setup(e) {
    return {
      children: Se(e.model.id)
    };
  }
});
function nd(e, t, n, o, r, l) {
  const a = P("form-item");
  return C(!0), T(J, null, Le(e.children, (s) => (C(), F(a, {
    is: s.component,
    key: s.id,
    model: s
  }, null, 8, ["is", "model"]))), 128);
}
const _r = /* @__PURE__ */ Q(td, [["render", nd]]), [od] = V("form-layout"), rd = G({
  name: od,
  components: {
    DLayout: vr,
    DLayoutHeader: wr,
    DLayoutFooter: $r,
    DLayoutSider: Cr,
    DLayoutContent: kr,
    FormLayoutHeader: Sr,
    FormLayoutFooter: Mr,
    FormLayoutSider: Or,
    FormLayoutContent: _r
  },
  props: {
    model: {
      type: Object,
      default: () => ({})
    }
  },
  setup(e) {
    const t = Se(e.model.id), n = t.value.find(
      (r) => r.component === "DFormLayoutHeader"
    ), o = t.value.find(
      (r) => r.component === "DFormLayoutFooter"
    );
    return {
      children: t.value.filter(
        (r) => ["DFormLayoutSider", "DFormLayoutContent"].includes(r.component)
      ),
      headerModel: n,
      footerModel: o
    };
  }
});
function ld(e, t, n, o, r, l) {
  const a = P("form-layout-header"), s = P("d-layout-header"), i = P("form-layout-sider"), c = P("d-layout-sider"), u = P("form-layout-content"), d = P("d-layout-content"), f = P("form-layout-footer"), h = P("d-layout-footer"), b = P("d-layout");
  return C(), F(b, null, {
    default: le(() => {
      var k, p, w, _;
      return [
        e.headerModel ? (C(), F(s, {
          key: 0,
          height: (k = e.headerModel) == null ? void 0 : k.layout.height,
          border: (p = e.headerModel) == null ? void 0 : p.layout.border
        }, {
          default: le(() => [
            g(a, { model: e.headerModel }, null, 8, ["model"])
          ]),
          _: 1
        }, 8, ["height", "border"])) : z("", !0),
        (C(!0), T(J, null, Le(e.children, (v) => (C(), T(J, {
          key: v.id
        }, [
          v.component === "DFormLayoutSider" && v.layout.placement !== "right" ? (C(), F(c, {
            key: 0,
            width: v.layout.width,
            border: v.layout.border,
            collapsed: v.layout.collapsed,
            "collapsed-width": v.layout.collapsedWidth,
            placement: "left"
          }, {
            default: le(() => [
              g(i, { model: v }, null, 8, ["model"])
            ]),
            _: 2
          }, 1032, ["width", "border", "collapsed", "collapsed-width"])) : z("", !0),
          v.component === "DFormLayoutContent" ? (C(), F(d, { key: 1 }, {
            default: le(() => [
              g(u, { model: v }, null, 8, ["model"])
            ]),
            _: 2
          }, 1024)) : z("", !0),
          v.component === "DFormLayoutSider" && v.layout.placement === "right" ? (C(), F(c, {
            key: 2,
            width: v.layout.width,
            border: v.layout.border,
            collapsed: v.layout.collapsed,
            "collapsed-width": v.layout.collapsedWidth,
            placement: "right"
          }, {
            default: le(() => [
              g(i, { model: v }, null, 8, ["model"])
            ]),
            _: 2
          }, 1032, ["width", "border", "collapsed", "collapsed-width"])) : z("", !0)
        ], 64))), 128)),
        e.footerModel ? (C(), F(h, {
          key: 1,
          height: (w = e.footerModel) == null ? void 0 : w.layout.height,
          border: (_ = e.footerModel) == null ? void 0 : _.layout.border
        }, {
          default: le(() => [
            g(f, { model: e.footerModel }, null, 8, ["model"])
          ]),
          _: 1
        }, 8, ["height", "border"])) : z("", !0)
      ];
    }),
    _: 1
  });
}
const ad = /* @__PURE__ */ Q(rd, [["render", ld]]), sd = Y(ad), id = Y(Sr), cd = Y(Mr), ud = Y(Or), dd = Y(_r), fd = Y(du), hd = Y(mu), pd = Y(vu), md = Y(De), bd = Y(Su);
var Lt = /* @__PURE__ */ ((e) => (e.Confirm = "confirm", e.Alert = "alert", e))(Lt || {});
const gd = {
  ...Te(Re, ["lockScroll", "teleport", "lazyRender", "closeOnEsc", "clientType"]),
  /**
   * 弹框显示隐藏
   */
  visible: {
    type: Boolean,
    default: !1
  },
  class: {
    type: String,
    default: void 0
  },
  /**
   * 对话框标题
   */
  title: {
    type: String,
    default: "提示"
  },
  /**
   * 对话框内容
   */
  content: {
    type: [String, Object],
    default: ""
  },
  /**
   * 控制按钮 loading
   */
  loading: {
    type: Boolean,
    default: !1
  },
  /**
   * 是否支持全屏
   */
  scale: {
    type: Boolean,
    default: !1
  },
  /**
   * 关闭按钮文字
   */
  cancelButtonText: {
    type: String,
    default: "取消"
  },
  /**
   * 关闭按钮 props
   */
  cancelButtonProps: {
    type: Object,
    default: () => ({})
  },
  /**
   * 隐藏取消按钮
   */
  hideCancelButton: {
    type: Boolean,
    default: !1
  },
  /**
   * 确认按钮文字
   */
  confirmButtonText: {
    type: String,
    default: "确认"
  },
  /**
   * 确认按钮 props
   */
  confirmButtonProps: {
    type: Object,
    default: () => ({})
  },
  /**
   * 隐藏确认按钮
   */
  hideConfirmButton: {
    type: Boolean,
    default: !1
  },
  /**
   * 是否显示关闭图标
   */
  closable: {
    type: Boolean,
    default: !0
  },
  /**
   * 点击遮罩层是否关闭对话框
   */
  closeOnOverlayClick: {
    type: Boolean,
    default: !0
  },
  /**
   * 是否显示遮罩层
   */
  showOverlay: {
    type: Boolean,
    default: !0
  },
  /**
   * 主题
   */
  theme: {
    type: String,
    default: "info"
  },
  /**
   * 关闭对话框是否销毁子元素
   */
  destroyOnClose: {
    type: Boolean,
    default: !1
  },
  /**
   * 对话框宽度
   */
  width: {
    type: [Number, String],
    default: 480
  },
  /**
   * 对话框高度
   */
  height: {
    type: [Number, String],
    default: void 0
  },
  /**
   * 是否需要行内样式
   */
  noInlineStyle: {
    type: Boolean,
    default: !1
  },
  /**
   * 显示对话框图标
   */
  showIcon: {
    type: Boolean,
    default: !1
  },
  /**
   * 显示底部
   */
  footer: {
    type: [Boolean, Object],
    default: !0
  },
  /**
   * 底部按钮是否为文字按钮
   */
  textButton: {
    type: Boolean,
    default: !1
  },
  /**
   * 弹框类型
   */
  type: {
    type: String,
    default: Lt.Confirm
  },
  /**
   * 确认事件
   */
  onConfirm: {
    type: Function,
    default: void 0
  },
  /**
   * 关闭事件
   */
  onClose: {
    type: Function,
    default: void 0
  }
}, yd = () => {
  const e = Pr();
  return (t, n) => {
    const o = e[t];
    return o ? Fr(o, n) : null;
  };
}, [fo, pe] = V("dialog"), vd = G({
  name: fo,
  components: {
    DPopup: _t,
    DButton: Ue,
    DSpace: cr,
    CheckCircleFilled: cn,
    CloseFilled: un,
    TipsFilled: dn,
    WarningFilled: fn
  },
  props: gd,
  emits: ["update:visible", "confirm", "close"],
  setup(e, t) {
    const n = ze(["clientType", "closeOnEsc"], e), o = yd(), r = n.value.clientType === wn.MOBILE, l = q(() => [pe({
      "hide-overlay": !e.showOverlay,
      [n.value.clientType.toLowerCase()]: !0,
      "text-btn": e.textButton,
      [e.type]: !0,
      "no-footer": !e.footer
    }), e.class].join(" ")), a = pe("wrapper"), s = pe("header"), i = pe("title"), c = pe("title-icon"), u = pe("title-text"), d = pe("body"), f = pe("footer"), h = pe("cancel-button"), b = pe("confirm-button"), [k, p] = Dt(e, t.emit, "visible", "update:visible"), w = q(() => ({
      width: K(e.width),
      height: K(e.height)
    })), _ = e.textButton ? {
      fill: "none",
      size: "large"
    } : void 0, v = () => {
      t.emit("close"), p(!1);
    }, M = () => {
      const {
        onConfirm: O
      } = e;
      O ? Promise.resolve(O()).then((S) => {
        S !== !1 && p(!1);
      }) : (t.emit("confirm"), p(!1));
    };
    or(k, {
      type: "dialog",
      closeOnEsc: n.value.closeOnEsc,
      closeFN: v
    });
    const E = () => e.showIcon ? t.slots.icon ? t.slots.icon() : {
      info: g(dn, {
        className: c,
        color: "var(--d-primary)"
      }, null),
      success: g(cn, {
        className: c,
        color: "var(--d-success)"
      }, null),
      warning: g(fn, {
        className: c,
        color: "var(--d-warning)"
      }, null),
      error: g(un, {
        className: c,
        color: "var(--d-error)"
      }, null)
    }[e.theme] : null, L = () => g("div", {
      class: i
    }, [E(), g("span", {
      class: u
    }, [e.title])]), m = () => {
      var S, R;
      const O = ((R = (S = t.slots).default) == null ? void 0 : R.call(S)) || e.content || null;
      return e.destroyOnClose ? k.value ? O : null : O;
    }, $ = () => {
      if (!e.footer) return null;
      if (Array.isArray(e.footer)) return e.footer;
      const O = e.hideCancelButton ? null : g(Ue, rt({
        class: h,
        fill: r ? "solid" : "outline",
        theme: r ? "light" : void 0,
        disabled: e.loading,
        block: r
      }, _, e.cancelButtonProps, {
        onClick: v
      }), {
        default: () => [e.cancelButtonText]
      }), S = e.hideConfirmButton ? null : g(Ue, rt({
        class: b,
        theme: "primary",
        loading: e.loading,
        block: r
      }, _, e.confirmButtonProps, {
        onClick: M
      }), {
        default: () => [e.confirmButtonText]
      });
      return g("div", {
        class: f
      }, [o("footer", {
        cancel: O,
        confirm: S,
        handleClose: v,
        handleConfirm: M
      }) || [O, S]]);
    };
    return () => g(_t, {
      teleport: e.teleport,
      visible: k.value,
      placement: "custom",
      transitionPrefix: fo,
      overlay: e.showOverlay,
      scale: e.scale,
      closable: r ? !1 : e.closable,
      closeOnOverlayClick: e.closeOnOverlayClick,
      popupContainerClass: l.value,
      popupClass: a,
      popupHeaderClass: s,
      popupBodyClass: d,
      popupStyle: e.noInlineStyle ? void 0 : w.value,
      lockScroll: e.lockScroll,
      lazyRender: e.lazyRender,
      onClose: v
    }, {
      default: m,
      title: L,
      footer: $
    });
  }
}), wd = /* @__PURE__ */ new Map();
function Cd(e) {
  const {
    instance: t,
    unmount: n
  } = $n({
    setup(o, {
      expose: r
    }) {
      const l = X(!1), a = oe(e), s = () => {
        l.value = !0;
      }, i = () => {
        l.value = !1, n();
      };
      return r({
        open: s,
        update: (u) => {
          Object.assign(a, u);
        },
        close: i
      }), () => {
        const u = {
          ...a,
          visible: l.value,
          "onUpdate:visible": i
        };
        return g(Lr, u, null);
      };
    }
  });
  return t;
}
function ho(e) {
  const t = Cd(e);
  return t.open(), wd.set(tr("dialog"), t), t;
}
const kd = () => {
  const e = ze(["closeOnEsc", "clientType"]);
  return {
    confirm: (t) => ho({
      closeOnEsc: e.value.closeOnEsc,
      clientType: e.value.clientType,
      width: 400,
      ...t,
      type: Lt.Confirm
    }),
    alert: (t) => ho({
      width: 400,
      ...t,
      clientType: e.value.clientType,
      type: Lt.Alert,
      hideCancelButton: !0,
      closeOnEsc: !1,
      closeOnOverlayClick: !1
    })
  };
}, Lr = Y(vd), $d = {
  ...Te(Re, ["lockScroll", "teleport", "lazyRender"]),
  /**
   * 弹框显示隐藏
   */
  visible: {
    type: Boolean,
    default: !1
  },
  /**
   * 抽屉标题
   */
  title: {
    type: String,
    default: "提示"
  },
  /**
   * 抽屉内容
   */
  content: {
    type: String,
    default: ""
  },
  /**
   * 控制按钮 loading
   */
  loading: {
    type: Boolean,
    default: !1
  },
  /**
   * 是否支持全屏
   */
  scale: {
    type: Boolean,
    default: !1
  },
  /**
   * 关闭按钮文字
   */
  cancelButtonText: {
    type: String,
    default: "取消"
  },
  /**
   * 关闭按钮 props
   */
  cancelButtonProps: {
    type: Object,
    default: () => ({})
  },
  /**
   * 隐藏取消按钮
   */
  hideCancelButton: {
    type: Boolean,
    default: !1
  },
  /**
   * 确认按钮文字
   */
  confirmButtonText: {
    type: String,
    default: "确认"
  },
  /**
   * 确认按钮 props
   */
  confirmButtonProps: {
    type: Object,
    default: () => ({})
  },
  /**
   * 隐藏确认按钮
   */
  hideConfirmButton: {
    type: Boolean,
    default: !1
  },
  /**
   * 是否显示关闭图标
   */
  closable: {
    type: Boolean,
    default: !0
  },
  /**
   * 是否按下 esc 关闭抽屉
   */
  closeOnEsc: {
    type: Boolean,
    default: !0
  },
  /**
   * 点击遮罩层是否关闭抽屉
   */
  closeOnOverlayClick: {
    type: Boolean,
    default: !0
  },
  /**
   * 是否显示遮罩层
   */
  showOverlay: {
    type: Boolean,
    default: !0
  },
  /**
   * 关闭抽屉是否销毁子元素
   */
  destroyOnClose: {
    type: Boolean,
    default: !1
  },
  /**
   * 抽屉宽度
   */
  width: {
    type: [Number, String],
    default: 300
  },
  /**
   * 抽屉高度
   */
  height: {
    type: [Number, String],
    default: void 0
  },
  /**
   * 抽屉位置
   */
  placement: {
    type: String,
    default: "right"
  },
  /**
   * 按钮列表
   */
  buttonList: {
    type: [Boolean, Object],
    default: !0
  },
  /**
   * 容器 className
   */
  containerClass: {
    type: String,
    default: void 0
  },
  /**
   * 是否需要行内样式
   */
  noInlineStyle: {
    type: Boolean,
    default: !1
  },
  /**
   * 确认事件
   */
  onConfirm: {
    type: Function,
    default: void 0
  },
  /**
   * 关闭事件
   */
  onClose: {
    type: Function,
    default: void 0
  }
}, [Sd, ye] = V("drawer"), Md = G({
  name: Sd,
  inheritAttrs: !1,
  props: $d,
  emits: ["update:visible", "confirm", "close"],
  setup(e, t) {
    const n = q(() => [ye({
      "hide-overlay": !e.showOverlay,
      [e.placement]: e.placement
    }), e.containerClass || ""]), o = ye("wrapper"), r = ye("header"), l = ye("header-extra"), a = ye("title"), s = ye("title-text"), i = ye("body"), c = ye("cancel-button"), u = ye("confirm-button"), [d, f] = Dt(e, t.emit, "visible", "update:visible"), h = q(() => ({
      width: ["left", "right"].includes(e.placement) ? K(e.width) : void 0,
      height: ["top", "bottom"].includes(e.placement) ? K(e.height) : void 0
    })), b = () => {
      t.emit("close"), f(!1);
    }, k = () => {
      const {
        onConfirm: v
      } = e;
      v ? Promise.resolve(v()).then((M) => {
        M !== !1 && f(!1);
      }) : (t.emit("confirm"), f(!1));
    };
    or(d, {
      type: "drawer",
      closeOnEsc: e.closeOnEsc,
      closeFN: b
    });
    const p = () => {
      var E, L;
      if (!e.buttonList) return null;
      if (Array.isArray(e.buttonList)) return e.buttonList;
      const v = e.hideCancelButton ? null : g(Ue, rt({
        class: c,
        fill: "outline",
        disabled: e.loading
      }, e.cancelButtonProps, {
        onClick: b
      }), {
        default: () => [e.cancelButtonText]
      }), M = e.hideConfirmButton ? null : g(Ue, rt({
        class: u,
        theme: "primary",
        loading: e.loading
      }, e.confirmButtonProps, {
        onClick: k
      }), {
        default: () => [e.confirmButtonText]
      });
      return ((L = (E = t.slots) == null ? void 0 : E.buttons) == null ? void 0 : L.call(E, {
        cancel: v,
        confirm: M
      })) || g(J, null, [M, v]);
    }, w = () => g(J, null, [g("div", {
      class: a
    }, [g("span", {
      class: s
    }, [e.title])]), g("div", {
      class: l
    }, [p()])]), _ = () => {
      var M, E;
      const v = ((E = (M = t.slots).default) == null ? void 0 : E.call(M)) || e.content || null;
      return e.destroyOnClose ? d.value ? v : null : v;
    };
    return () => g(_t, {
      teleport: e.teleport,
      visible: d.value,
      title: e.title,
      placement: e.placement,
      overlay: e.showOverlay,
      scale: e.scale,
      closable: e.closable,
      closeOnOverlayClick: e.closeOnOverlayClick,
      popupContainerClass: n.value,
      popupClass: o,
      popupHeaderClass: r,
      popupBodyClass: i,
      popupStyle: e.noInlineStyle ? void 0 : h.value,
      lockScroll: e.lockScroll,
      lazyRender: e.lazyRender,
      onClose: b
    }, {
      title: w,
      default: _
    });
  }
}), Od = Y(Md), _d = {
  /**
   * 是否显示 loading
   */
  loading: {
    type: Boolean,
    default: !0
  },
  /**
   * loading 文案描述
   */
  description: {
    type: String,
    default: ""
  },
  /**
   * 延迟显示 loading，单位：毫秒
   */
  delay: {
    type: Number,
    default: 0
  },
  /**
   * 图标大小
   */
  size: {
    type: String,
    default: "large"
  },
  /**
   * 布局类型
   */
  layout: {
    type: String,
    default: "vertical"
  },
  /**
   * 全屏显示
   */
  fullScreen: {
    type: Boolean,
    default: !1
  },
  /**
   * 是否撑满父级元素高度
   */
  fullHeight: {
    type: Boolean,
    default: !1
  },
  /**
   * 全屏状态下禁止滚动穿透
   */
  preventScrollThrough: {
    type: Boolean,
    default: !0
  }
}, [Ld, ot] = V("loading"), Td = G({
  name: Ld,
  components: { Loading2Outlined: Bn },
  inheritAttrs: !1,
  props: _d,
  setup(e) {
    const t = ot({ "full-height": e.fullHeight }), n = ot("content"), o = q(
      () => ot("body", {
        [e.layout]: !0,
        fullScreen: e.fullScreen,
        scrollThrough: !e.preventScrollThrough && e.fullScreen
      })
    ), r = ot("description"), l = ot("icon"), a = X(e.loading);
    return ae(
      () => e.loading,
      (s) => {
        s ? setTimeout(() => {
          a.value = !0;
        }, e.delay) : a.value = !1;
      }
    ), {
      wrapperClassName: t,
      contentClassName: n,
      bodyClassName: o,
      descriptionClassName: r,
      iconClassName: l,
      showLoading: a
    };
  }
}), Nd = ["id"];
function Ad(e, t, n, o, r, l) {
  const a = P("loading2-outlined");
  return C(), T("div", {
    id: e.$attrs.id,
    class: B([e.wrapperClassName, e.$attrs.class])
  }, [
    e.$slots.default ? (C(), T("div", {
      key: 0,
      class: B(e.contentClassName)
    }, [
      ne(e.$slots, "default")
    ], 2)) : z("", !0),
    yn(U("div", {
      class: B(e.bodyClassName)
    }, [
      U("span", {
        class: B(e.iconClassName)
      }, [
        ne(e.$slots, "icon", {}, () => [
          g(a, {
            spin: "",
            size: e.size
          }, null, 8, ["size"])
        ])
      ], 2),
      e.description ? (C(), T("p", {
        key: 0,
        class: B(e.descriptionClassName)
      }, He(e.description), 3)) : z("", !0)
    ], 2), [
      [vn, e.showLoading]
    ])
  ], 10, Nd);
}
const Rd = /* @__PURE__ */ Q(Td, [["render", Ad]]);
let re = null;
const Tr = (e) => {
  const t = document.createElement("div"), {
    instance: n,
    unmount: o
  } = $n({
    inheritAttrs: !1,
    setup(r, {
      expose: l
    }) {
      const {
        to: a = t
      } = e ?? {}, s = X(!0);
      return l({
        close: () => {
          s.value = !1, o();
        }
      }), () => {
        const c = {
          ...e,
          loading: s.value
        };
        return g(Tt, {
          to: a
        }, {
          default: () => [g(Nr, c, null)]
        });
      };
    }
  }, t);
  return n;
}, Dd = {
  open(e) {
    return re == null || re.close(), re = Tr({
      fullScreen: !0,
      ...e
    });
  },
  close: () => re == null ? void 0 : re.close()
}, Ed = () => ({
  open(e) {
    return re == null || re.close(), re = Tr({
      fullScreen: !0,
      ...e
    });
  },
  close: () => re == null ? void 0 : re.close()
}), Nr = Y(Rd), Bd = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ConfigProviderInjectKey: En,
  DButton: Ue,
  DCell: ur,
  DCellGroup: dr,
  DConfigProvider: Os,
  DDetailTableWrapper: bd,
  DDialog: Lr,
  DDrawer: Od,
  DForm: fd,
  DFormCellGroup: hd,
  DFormGrid: pd,
  DFormItem: md,
  DFormLayout: sd,
  DFormLayoutContent: dd,
  DFormLayoutFooter: cd,
  DFormLayoutHeader: id,
  DFormLayoutSider: ud,
  DGrid: Dn,
  DGridItem: et,
  DImage: lc,
  DLayout: vr,
  DLayoutContent: kr,
  DLayoutFooter: $r,
  DLayoutHeader: wr,
  DLayoutSider: Cr,
  DLoading: Nr,
  DMessage: Qi,
  DOverlay: ir,
  DPopup: _t,
  DSpace: cr,
  FORM_PROPS: fr,
  FormStore: gr,
  LoadingPlugin: Dd,
  MessagePlugin: sr,
  useDialog: kd,
  useForm: it,
  useFormEvent: yr,
  useLinkChildren: Se,
  useLoading: Ed,
  useMessage: xi
}, Symbol.toStringTag, { value: "Module" })), Id = function(e) {
  Object.values(Bd).forEach((t) => {
    /^d-/.test(t == null ? void 0 : t.name) && e.use(t);
  });
}, Hd = { install: Id, version: zr };
export {
  Re as COMMON_PROPS,
  wn as ClientTypeEnum,
  En as ConfigProviderInjectKey,
  Ue as DButton,
  ur as DCell,
  dr as DCellGroup,
  Os as DConfigProvider,
  bd as DDetailTableWrapper,
  Lr as DDialog,
  Od as DDrawer,
  yo as DEFAULT_REQUIRED_MARK_POSITION,
  fd as DForm,
  hd as DFormCellGroup,
  pd as DFormGrid,
  md as DFormItem,
  sd as DFormLayout,
  dd as DFormLayoutContent,
  cd as DFormLayoutFooter,
  id as DFormLayoutHeader,
  ud as DFormLayoutSider,
  Dn as DGrid,
  et as DGridItem,
  lc as DImage,
  vr as DLayout,
  kr as DLayoutContent,
  $r as DLayoutFooter,
  wr as DLayoutHeader,
  Cr as DLayoutSider,
  Nr as DLoading,
  Qi as DMessage,
  ir as DOverlay,
  _t as DPopup,
  cr as DSpace,
  Yr as ERROR_COLOR,
  fr as FORM_PROPS,
  gr as FormStore,
  Wr as HorizontalAlignEnum,
  zd as LABEL_WIDTH,
  Dd as LoadingPlugin,
  sr as MessagePlugin,
  Xr as MessageThemeEnum,
  $e as PREFIX,
  qr as PRIMARY_COLOR,
  Hr as PlacementEnum,
  qd as ROOT_PARENT,
  nl as Request,
  Zr as SEPARATOR,
  Gr as SUCCESS_COLOR,
  Ur as SizeEnum,
  go as TRANSITION_DURATION,
  Kr as ThemeEnum,
  zc as Validator,
  Vr as WARNING_COLOR,
  K as addUnit,
  Wd as color,
  zr as commonVersion,
  Qr as createBEM,
  V as createNamespace,
  Gd as createPrefix,
  Hd as default,
  Vd as filePreview,
  nn as generateModifier,
  xr as getComponentName,
  tr as getID,
  Mt as isEqual,
  $n as mountComponent,
  Te as pickProps,
  Yd as request,
  or as useCloseOnEsc,
  ze as useConfig,
  kd as useDialog,
  it as useForm,
  yr as useFormEvent,
  Se as useLinkChildren,
  Ed as useLoading,
  xi as useMessage,
  Dt as useModelValue,
  nr as useZIndex,
  pn as validator,
  Ud as watchOnce,
  Y as withInstall
};
//# sourceMappingURL=index.es.js.map
